var _path, _path2, _path3, _path4, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-25",
    d: "M86.8,453.53c-90.13-52-90.13-136.4,0-188.44s236.27-52,326.4,0,90.13,136.4,0,188.44S176.93,505.57,86.8,453.53Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-25",
    d: "M74.64,370.09l134.21,77.49a13.11,13.11,0,0,0,11.86,0l216.52-125c3.28-1.89,3.28-4.95,0-6.84L303,238.24a13.11,13.11,0,0,0-11.86,0l-216.52,125C71.36,365.13,71.36,368.2,74.64,370.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-25",
    points: "127.6 466.79 186.44 432.92 73.01 367.65 14.17 401.51 127.6 466.79",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-25",
    cx: 420.77,
    cy: 386.49,
    rx: 62.74,
    ry: 36.22,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Symbols--inject-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--money-icon--inject-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1,195.68l1.51,2.66-3.59,2-1.52-2.66c-2.67,1.05-5.81,1.19-8.25-1.59l3.93-3.85a3,3,0,0,0,4.08.69c1.19-.68,1.72-1.61,1.11-2.67-1-1.7-3.07-.63-5.74.05-2.87.7-5.84.86-7.83-2.64-1.79-3.14-.89-6,1.93-8.23l-1.51-2.66,3.62-2.07,1.51,2.66c3.08-1.15,5.73-.67,7.78,1.35l-3.72,3.69c-.88-1-2.2-1.25-3.8-.34s-1.67,1.84-1.21,2.64c.75,1.32,2,1,4.82.19,3-.79,6.73-1.76,9,2.22C42,190.38,40.93,193.43,38.1,195.68Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.23,131.56l-4.65-1.86,1.13-2.82c-2.13-1.33-4.34-3.68-3.64-7.51l.08-.46,6.3.78-.12.53A2.46,2.46,0,0,0,42,123.16c1.06.42,1.75.26,2.05-.49.4-1-.46-1.68-2.16-2.88-.38-.27-.78-.55-1.19-.86-2.31-1.8-4.46-4.16-2.88-8.11,1.29-3.24,4-4.61,7.56-3.89l1.13-2.83L51.16,106,50,108.81a7,7,0,0,1,3.54,7l0,.51-6.07-.72.1-.52a2.28,2.28,0,0,0-1.73-2.53c-1.11-.44-1.8-.31-2.09.4-.36.91.17,1.41,2.6,3.17s5.72,4.23,3.91,8.74c-1.29,3.23-4.14,4.64-7.88,3.92Zm-3.35-2.41,2.79,1.11,1.07-2.69.42.1c2,.46,5.6.66,7.15-3.23s-1.3-5.88-3.57-7.56-3.63-2.62-2.94-4.36c.19-.46,1-1.92,3.39-1a3.28,3.28,0,0,1,2.4,3.11l4,.47c.08-2.36-1.08-4.29-3.47-5.71l-.37-.22,1.08-2.69L47,105.4,46,108.1l-.42-.11c-2.31-.55-5.36-.45-6.83,3.21-1.25,3.13.12,5,2.57,6.93.39.3.79.58,1.16.84,1.66,1.17,3.22,2.28,2.5,4.07-.51,1.29-1.76,1.68-3.34,1a3.44,3.44,0,0,1-2.32-3.54L35,120c-.36,3.2,1.73,5.14,3.6,6.22l.38.21Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.7,69l.71-3.89c-3.07-1.15-6.48-3.56-6.59-8.62v-.61l8.22-.64v.71a3.19,3.19,0,0,0,2.85,3.32,3,3,0,0,0,1.75-.1,1.35,1.35,0,0,0,.73-1c.25-1.4-1-2-3.49-3.12-.56-.24-1.14-.5-1.74-.79-3.41-1.69-6.76-4.14-5.77-9.57.8-4.4,3.93-6.9,8.62-6.92l.71-3.89L216.12,35l-.71,3.9c3.8,1.49,6,4.23,6.32,7.94l.06.66-7.91.66v-.7c0-1.86-1.57-2.54-2.86-2.77-1.52-.28-2.38.08-2.55,1-.25,1.32.8,1.86,4.12,3.37S221,53,219.83,59.19c-.81,4.44-4.08,7-9,7l-.71,3.89Zm2.19-4.76-.68,3.71,3.84.7.67-3.7h.56c2.67.08,7.3-.6,8.27-6s-3.18-7.16-6.51-8.71-5.3-2.4-4.86-4.79c.11-.64.76-2.69,4.06-2.09,2.19.4,3.56,1.6,3.86,3.34l5.26-.44c-.5-3-2.48-5.18-5.9-6.38l-.52-.19.67-3.7-3.88-.7-.68,3.7-.56,0c-3.08-.11-7,.82-7.86,5.85-.79,4.32,1.45,6.39,5.06,8.17.58.28,1.15.53,1.69.77,2.42,1.07,4.7,2.07,4.25,4.54a2.61,2.61,0,0,1-1.45,2,4.19,4.19,0,0,1-2.54.21,4.5,4.5,0,0,1-3.88-3.91l-5.61.43c.37,4.18,3.54,6.11,6.2,7Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.27,60.86l-.66,2.93-4-.88L38.31,60c-2.63-1-5-3-4.94-6.58l5.38-.22a3,3,0,0,0,2.51,3.2c1.31.29,2.31-.05,2.57-1.21.41-1.87-1.82-2.48-4.21-3.75s-4.8-3.22-3.95-7.07c.77-3.46,3.33-5,6.83-4.71l.65-2.93,4,.89-.65,2.93c3,1.18,4.61,3.28,4.76,6.1l-5.13.23c0-1.33-.77-2.36-2.54-2.75s-2.42.24-2.62,1.12c-.32,1.45.85,2,3.38,3.31s6,3.16,5.07,7.53C48.62,59.61,45.81,61.09,42.27,60.86Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.25,85l-2.83-5.13c-4.55,1.6-10.79,2.16-15.67-3.57l-.39-.46,8.43-8,.44.55a5.09,5.09,0,0,0,6.85,1.24c1.46-.81,3-2.18,1.9-4.12s-3.42-1.55-7.34-.47c-.88.24-1.8.5-2.76.73-5.42,1.24-11.48,1.57-15.37-5.47-3.23-5.86-1.95-11.49,3.59-15.93l-2.83-5.12,8-4.42,2.84,5.14C433.88,38,439,39,442.84,43l.46.47-8.05,7.78-.45-.54c-1.53-1.82-3.72-2-6.34-.58-1.51.84-3.11,2.22-2.09,4.06s2.87,1.61,8.33.16,13.16-3.32,17.59,4.73c3.22,5.82,1.78,11.79-3.93,16.43l2.83,5.13ZM441,78.26l2.74,5,5.67-3.13-2.73-5,.43-.34c5.6-4.32,7-9.7,4-15.13-4-7.17-10.71-5.47-16.14-4.1-5.25,1.4-8.15,2.17-9.78-.78-.56-1-1.42-3.6,2.6-5.82,2.89-1.59,5.57-1.45,7.48.38l6.14-5.93c-3.59-3.33-8.11-4-13.45-2.12l-.52.19-2.73-5L419,39.69l2.74,5-.44.34c-5.34,4-6.64,9.24-3.67,14.61,3.45,6.27,8.74,6,13.94,4.84.94-.22,1.84-.47,2.7-.71,3.83-1.06,7.14-2,8.82,1.08,1.23,2.22.35,4.36-2.41,5.88a6.33,6.33,0,0,1-8-1l-6.54,6.24c4.52,4.87,10.27,4.1,14.35,2.55Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.33,72.69l.81,2.63-3.55,1.1-.81-2.64c-2.55.41-5.34-.08-6.93-3L330,68.18a2.74,2.74,0,0,0,3.45,1.39c1.17-.36,1.82-1.08,1.49-2.13-.52-1.68-2.57-1.14-5.05-1.07-2.66.06-5.29-.38-6.36-3.83-1-3.11.39-5.47,3.29-6.86l-.81-2.63,3.58-1.11.82,2.63c2.92-.41,5.16.53,6.56,2.7l-4,2.51c-.58-1.07-1.69-1.52-3.27-1s-1.83,1.29-1.58,2.08c.4,1.3,1.6,1.24,4.2,1.1s6.24-.23,7.46,3.7C340.82,68.8,339.25,71.26,336.33,72.69Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.54,148.2l-.53,2.87-3.87-.72.53-2.87c-2.59-.88-5-2.71-5-6.23l5.22-.39a2.91,2.91,0,0,0,2.55,3c1.28.24,2.24-.12,2.45-1.26.34-1.83-1.85-2.35-4.21-3.51-2.52-1.25-4.78-3-4.08-6.73.64-3.39,3.07-4.93,6.48-4.8l.53-2.87,3.91.73-.53,2.87c2.95,1.05,4.58,3,4.82,5.76l-5,.4c0-1.29-.83-2.27-2.56-2.59s-2.35.31-2.51,1.18c-.26,1.42.89,1.95,3.4,3.1s6,2.87,5.17,7.15C478.68,146.77,476,148.31,472.54,148.2Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrows--inject-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--arrows--inject-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrow--inject-25"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "77.86 324.13 90.46 331.4 111.19 319.43 111.19 66.23 125.02 58.25 101.3 40.01 88.7 32.74 64.03 78.91 76.63 86.19 77.86 85.48 77.86 324.13",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.86 324.13 90.46 331.4 111.19 319.43 111.19 66.23 125.02 58.25 101.3 40.01 88.7 32.74 64.03 78.91 76.63 86.19 77.86 85.48 77.86 324.13",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--down-arrow--inject-25",
    points: "90.46 331.4 111.19 319.43 111.19 66.23 125.02 58.25 101.3 40.01 76.63 86.19 90.46 78.2 90.46 331.4",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--down-arrow--inject-25",
    points: "90.46 331.4 111.19 319.43 111.19 66.23 125.02 58.25 101.3 40.01 76.63 86.19 90.46 78.2 90.46 331.4",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.86 324.13 90.46 331.4 90.46 78.2 77.86 85.48 77.86 324.13",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.86 324.13 90.46 331.4 90.46 78.2 77.86 85.48 77.86 324.13",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arrow--inject-25"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "136.81 293.68 146.26 299.13 161.8 290.15 161.8 84.39 172.16 78.41 154.38 64.74 144.94 59.29 126.45 93.9 135.9 99.35 136.81 98.82 136.81 293.68",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.9 99.35 154.38 64.74 144.94 59.29 126.45 93.9 135.9 99.35",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--down-arrow--inject-25",
    points: "146.26 299.13 161.8 290.15 161.8 84.39 172.16 78.41 154.38 64.74 135.9 99.35 146.26 93.36 146.26 299.13",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--down-arrow--inject-25",
    points: "146.26 299.13 161.8 290.15 161.8 84.39 172.16 78.41 154.38 64.74 135.9 99.35 146.26 93.36 146.26 299.13",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.81 293.68 146.26 299.13 146.26 93.36 136.81 98.82 136.81 293.68",
    style: {
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arrows--inject-25"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "55.2 235.56 13.59 259.58 34.4 221.36 55.2 235.56",
    style: {
      fill: "#B42F53",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.2 253.03 13.59 277.05 34.4 238.83 55.2 253.03",
    style: {
      fill: "#B42F53",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.2 270.5 13.59 294.52 34.4 256.3 55.2 270.5",
    style: {
      fill: "#B42F53",
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.64,357.49c0,3.36,2.5,5.5,5.6,7.29L210,438a12.41,12.41,0,0,0,11.2,0L425.8,319.89c3.1-1.79,5.6-4.09,5.6-7.44s-2.5-5.43-5.6-7.21L299,232a12.35,12.35,0,0,0-11.2,0L83.24,350.13C80.14,351.92,77.64,354.14,77.64,357.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.24,356.6,210,429.81a12.35,12.35,0,0,0,11.2,0L425.8,311.71c3.1-1.79,3.1-4.69,0-6.47L299,232a12.35,12.35,0,0,0-11.2,0L83.24,350.13C80.14,351.92,80.14,354.81,83.24,356.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.65,431.16v8.16A11.46,11.46,0,0,1,210,438L83.24,364.78c-3.1-1.79-5.6-3.93-5.6-7.29,0-3.14,2.25-5.33,5.16-7.11-2.4,1.7-2.45,4.55.44,6.22L210,429.81A11.36,11.36,0,0,0,215.65,431.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.54,351.08l188-108.53a5.85,5.85,0,0,1,5.28,0l6.85,3.84c1.46.85,1.46,2.21,0,3.05L112.64,358a5.85,5.85,0,0,1-5.28,0l-6.82-3.83C99.08,353.29,99.08,351.93,100.54,351.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,362,307,253.44a5.39,5.39,0,0,1,4.83-.26l48.93,28.25c1.2.69,1,1.94-.46,2.78L172.52,392.6a5.42,5.42,0,0,1-4.83.27l-49.14-28.12C117.34,364.06,117.54,362.81,119,362Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.89,299l5.88-3.4c.25-.15.28-.37.05-.5l-5.63-3.25a1,1,0,0,0-.85,0l-5.89,3.4c-.25.14-.27.36-.05.49l5.63,3.25A1,1,0,0,0,281.89,299Zm-8.6-11.76-5.88,3.4c-.25.14-.27.36-.05.49l5.63,3.25a.92.92,0,0,0,.85,0l5.89-3.4c.25-.14.27-.36,0-.49l-5.63-3.25A.94.94,0,0,0,273.29,287.27Zm-19,11-10,5.75c-.25.14-.27.36,0,.49l5.63,3.25a.92.92,0,0,0,.85,0l10-5.75c.25-.14.28-.36.05-.49l-5.63-3.25A.92.92,0,0,0,254.28,298.25Zm10.41-6-5.88,3.4c-.25.15-.28.37-.05.5l5.63,3.25a1,1,0,0,0,.85,0l5.89-3.4c.25-.15.27-.37.05-.49l-5.63-3.26A1,1,0,0,0,264.69,292.23ZM241.6,305.56l-5.88,3.4c-.25.15-.28.37-.05.5l5.63,3.25a1,1,0,0,0,.85,0l5.89-3.4c.25-.14.27-.36.05-.49l-5.63-3.25A1,1,0,0,0,241.6,305.56Zm-8.6,5-5.89,3.4c-.25.14-.27.37-.05.49l5.63,3.25a.94.94,0,0,0,.86,0l5.89-3.39c.25-.15.27-.37.05-.5l-5.64-3.25A1,1,0,0,0,233,310.53Zm22.07,13.27,5.89-3.4c.25-.15.27-.37.05-.49l-5.63-3.26a1,1,0,0,0-.86,0l-5.88,3.4c-.25.15-.28.37-.06.49l5.64,3.26A1,1,0,0,0,255.07,323.8Zm-8.6,5,5.88-3.39c.25-.15.28-.37.05-.5l-5.63-3.25a1,1,0,0,0-.85,0l-5.89,3.4c-.25.14-.27.36-.05.49l5.63,3.25A.94.94,0,0,0,246.47,328.76Zm-8.6,5,5.88-3.4c.25-.14.27-.36.05-.49l-5.63-3.25a.92.92,0,0,0-.85,0L231.43,330c-.25.15-.27.37-.05.5l5.63,3.25A1,1,0,0,0,237.87,333.73Zm-8.61,5,5.89-3.4c.25-.15.27-.37,0-.5l-5.63-3.25a1,1,0,0,0-.86,0l-5.88,3.4c-.25.15-.27.37-.05.49l5.63,3.26A1,1,0,0,0,229.26,338.7Zm44-34.71,5.88-3.4c.25-.14.27-.36.05-.49l-5.63-3.25a.92.92,0,0,0-.85,0l-5.89,3.4c-.25.14-.27.36-.05.49l5.63,3.25A.94.94,0,0,0,273.29,304Zm-9.62,14.84,13.13-7.58c.25-.14.27-.37.05-.49l-13.67-7.9a1,1,0,0,0-.86,0l-6.79,3.92c-.25.15-.27.37-.05.5l7.24,4.17c.22.13.2.35-.05.5l-5.43,3.13c-.25.15-.28.37-.05.5l5.63,3.25A1,1,0,0,0,263.67,318.83ZM224.4,315.5l-5.89,3.4c-.25.14-.27.36,0,.49l5.63,3.25a.94.94,0,0,0,.86,0l5.88-3.4c.25-.14.28-.36,0-.49l-5.63-3.25A.92.92,0,0,0,224.4,315.5Zm-8.6,5-5.89,3.4c-.25.15-.27.37,0,.5l5.63,3.25a1,1,0,0,0,.85,0l5.89-3.4c.25-.14.27-.37.05-.49l-5.63-3.25A.94.94,0,0,0,215.8,320.46Zm-47.61,53a.94.94,0,0,0,.86,0l5.88-3.4c.25-.14.28-.36,0-.49l-5.63-3.25a.92.92,0,0,0-.85,0l-5.89,3.4c-.25.14-.27.36-.05.49ZM147,360.2l-5.89,3.39c-.25.15-.27.37-.05.5l5.63,3.25a1,1,0,0,0,.86,0l5.88-3.4c.25-.14.28-.36.05-.49l-5.63-3.25A.92.92,0,0,0,147,360.2Zm10.91,9.95a.92.92,0,0,0,.85,0l5.89-3.39c.25-.15.27-.37.05-.5L159.05,363a1,1,0,0,0-.86,0l-5.88,3.4c-.26.14-.28.36-.06.49Zm23.73,5.34,5.89-3.4c.25-.14.27-.36.05-.49l-5.63-3.25a.94.94,0,0,0-.86,0l-5.89,3.4c-.25.14-.27.36-.05.49l5.63,3.25A.94.94,0,0,0,181.62,375.49Zm-9.46,5a1,1,0,0,0,.86,0l5.88-3.4c.25-.14.28-.36,0-.49l-5.63-3.25a.94.94,0,0,0-.85,0l-5.89,3.4c-.25.15-.27.37-.05.5Zm-16.58-25.26-5.89,3.4c-.25.14-.27.36-.05.49l5.63,3.25a.94.94,0,0,0,.86,0L162,359c.26-.15.28-.37.06-.5l-5.64-3.25A1,1,0,0,0,155.58,355.23Zm43-24.83-5.89,3.4c-.24.14-.27.36,0,.49l5.64,3.25a.92.92,0,0,0,.85,0l5.89-3.4c.25-.14.27-.36.05-.49l-5.63-3.25A.94.94,0,0,0,198.59,330.4Zm-34.41,19.86-5.88,3.4c-.25.15-.28.37-.05.49l5.63,3.26a1,1,0,0,0,.85,0l5.89-3.4c.25-.15.27-.37,0-.49L165,350.23A1,1,0,0,0,164.18,350.26Zm43-24.83-5.88,3.4c-.25.14-.28.36-.05.49l5.63,3.25a.92.92,0,0,0,.85,0l5.89-3.39c.25-.15.27-.37.05-.5l-5.63-3.25A1,1,0,0,0,207.19,325.43ZM190,335.36l-5.89,3.4c-.25.15-.27.37,0,.5l5.63,3.25a1,1,0,0,0,.86,0l5.88-3.4c.25-.14.28-.37.05-.49l-5.63-3.26A1,1,0,0,0,190,335.36Zm-8.6,5-5.89,3.4c-.25.14-.27.36-.05.49l5.63,3.25a.94.94,0,0,0,.86,0l5.88-3.39c.25-.15.27-.37.05-.5l-5.63-3.25A1,1,0,0,0,181.39,340.33Zm-8.61,5-5.88,3.39c-.25.15-.27.37-.05.5l5.63,3.25a1,1,0,0,0,.85,0l5.89-3.4c.25-.14.27-.36.05-.49l-5.63-3.25A.94.94,0,0,0,172.78,345.3Zm39.28,3.33,5.88-3.4c.25-.14.28-.36.06-.49l-5.64-3.25a.92.92,0,0,0-.85,0l-5.89,3.39c-.25.15-.27.37-.05.5l5.63,3.25A1,1,0,0,0,212.06,348.63Zm80.25-72.34-5.89,3.4c-.25.14-.27.36-.05.49l5.63,3.25a.94.94,0,0,0,.86,0l5.89-3.4c.25-.14.27-.36.05-.49l-5.64-3.25A.92.92,0,0,0,292.31,276.29Zm-10.41,6L276,285.7c-.25.14-.27.36-.05.49l5.63,3.25a.94.94,0,0,0,.86,0l5.88-3.39c.25-.15.27-.37.05-.5l-5.63-3.25A1,1,0,0,0,281.9,282.3Zm19-11-5.88,3.4c-.25.14-.28.37,0,.49l5.63,3.25a.94.94,0,0,0,.85,0l5.89-3.4c.25-.15.27-.37,0-.5l-5.63-3.25A1,1,0,0,0,300.91,271.32Zm-47.55,44.17,5.89-3.39c.25-.15.27-.37.05-.5l-5.63-3.25a1,1,0,0,0-.85,0l-5.89,3.4c-.25.14-.27.36-.05.49l5.63,3.25A.92.92,0,0,0,253.36,315.49Zm57-49.16a.94.94,0,0,0-.86,0l-5.88,3.39c-.25.15-.27.37-.05.5l5.63,3.25a1,1,0,0,0,.85,0l5.89-3.4c.25-.14.27-.36.05-.49Zm-89.71,77.33,5.89-3.4c.25-.14.27-.36,0-.49L221,336.52a.94.94,0,0,0-.86,0l-5.88,3.4c-.25.14-.28.36,0,.49l5.63,3.25A.92.92,0,0,0,220.66,343.66Zm105.49-60.9,5.89-3.4c.25-.14.27-.37,0-.49l-5.63-3.25a1,1,0,0,0-.86,0l-5.88,3.4c-.25.15-.28.37-.05.5l5.63,3.25A1,1,0,0,0,326.15,282.76Zm-16.64.32,5.88-3.4c.25-.14.27-.36.05-.49l-5.63-3.25a.92.92,0,0,0-.85,0l-5.89,3.39c-.25.15-.27.37-.05.5l5.63,3.25A1,1,0,0,0,309.51,283.08Zm8.9-12.11a1,1,0,0,0-.85,0l-5.89,3.4c-.25.14-.27.36-.05.49l5.63,3.25a.94.94,0,0,0,.86,0l5.88-3.39c.25-.15.28-.37.05-.5Zm1.81-1,13.68,7.89a.92.92,0,0,0,.85,0l5.89-3.4c.25-.14.27-.36.05-.49L327,266a1,1,0,0,0-.86,0l-5.89,3.4C320,269.58,320,269.8,320.22,269.93Zm-19.87,11-5.88,3.4c-.25.15-.27.37-.05.49l5.63,3.26a1,1,0,0,0,.85,0l5.89-3.4c.25-.15.27-.37,0-.5l-5.63-3.25A1,1,0,0,0,300.35,280.93Zm-64.74,37.38-5.88,3.4c-.26.14-.28.37-.06.49l5.64,3.25a.94.94,0,0,0,.85,0l5.89-3.4c.25-.15.27-.37,0-.5l-5.63-3.25A1,1,0,0,0,235.61,318.31Zm81.08-30.56a.94.94,0,0,0,.86,0l5.89-3.39c.25-.15.27-.37.05-.5l-5.64-3.25a1,1,0,0,0-.85,0l-5.89,3.4c-.25.14-.27.36-.05.49Zm-72.48,25.6-5.88,3.39c-.25.15-.28.37-.05.5l5.63,3.25a1,1,0,0,0,.85,0l5.89-3.4c.25-.14.27-.36,0-.49l-5.63-3.25A.94.94,0,0,0,244.21,313.35ZM176.8,368.52a.92.92,0,0,0,.85,0l5.89-3.39c.25-.15.27-.37.05-.5L178,361.35a1,1,0,0,0-.86,0l-5.88,3.4c-.25.14-.28.37-.06.49Zm-10-10.48-5.88,3.4c-.25.15-.28.37,0,.5l5.63,3.25a1,1,0,0,0,.85,0l5.89-3.4c.25-.14.27-.37.05-.49L167.65,358A1,1,0,0,0,166.79,358Zm19.46,5.49,5.89-3.4c.25-.14.27-.37.05-.49l-5.63-3.25a.94.94,0,0,0-.86,0l-5.88,3.39c-.25.15-.28.37,0,.5l5.63,3.25A1,1,0,0,0,186.25,363.53Zm8.6-5,5.89-3.4c.25-.14.27-.36,0-.49l-5.63-3.25a.92.92,0,0,0-.85,0l-5.89,3.4c-.25.14-.27.36,0,.49l5.63,3.25A.92.92,0,0,0,194.85,358.56Zm8.61-5,5.88-3.4c.25-.15.28-.37,0-.5l-5.63-3.25a1,1,0,0,0-.85,0l-5.89,3.4c-.25.14-.27.37-.05.49l5.63,3.25A1,1,0,0,0,203.46,353.6Zm-28.06-.52-5.89,3.4c-.25.14-.27.36,0,.49l5.63,3.25a.94.94,0,0,0,.86,0l5.88-3.4c.25-.14.27-.36,0-.49l-5.63-3.25A.92.92,0,0,0,175.4,353.08Zm8.6-5-5.89,3.4c-.25.14-.27.36-.05.49l5.63,3.25a.94.94,0,0,0,.86,0l5.88-3.39c.25-.15.28-.37,0-.5l-5.63-3.25A1,1,0,0,0,184,348.11Zm34.41-19.86-5.89,3.39c-.25.15-.27.37-.05.5l5.63,3.25a1,1,0,0,0,.86,0l5.88-3.4c.25-.14.27-.36,0-.49l-5.63-3.25A.92.92,0,0,0,218.41,328.25Zm-8.61,5-5.88,3.4c-.25.14-.27.37,0,.49l5.63,3.25a.94.94,0,0,0,.85,0l5.89-3.4c.25-.15.27-.37,0-.5l-5.63-3.25A1,1,0,0,0,209.8,333.21ZM227,323.28l-5.89,3.4c-.25.14-.27.36-.05.49l5.63,3.25a.94.94,0,0,0,.86,0l5.88-3.4c.25-.14.28-.36.05-.49l-5.63-3.25A.92.92,0,0,0,227,323.28ZM192.6,343.14l-5.89,3.4c-.25.15-.27.37-.05.5l5.63,3.25a1,1,0,0,0,.86,0l5.89-3.4c.24-.14.27-.37.05-.49l-5.64-3.25A.94.94,0,0,0,192.6,343.14Zm8.6-5-5.88,3.4c-.25.14-.28.36,0,.49l5.63,3.25a.92.92,0,0,0,.85,0l5.89-3.4c.25-.14.27-.36.05-.49l-5.63-3.25A.94.94,0,0,0,201.2,338.18Zm-11,32.35,5.89-3.4c.25-.15.27-.37,0-.5l-5.63-3.25a1,1,0,0,0-.86,0l-5.88,3.4c-.25.14-.28.37,0,.49l5.63,3.26A1,1,0,0,0,190.22,370.53Zm-45.36-2.15-5.63-3.25a1,1,0,0,0-.85,0l-5.89,3.4c-.25.15-.27.37-.05.49l5.63,3.26a1,1,0,0,0,.86,0l5.88-3.4C145.06,368.73,145.08,368.51,144.86,368.38Zm11.21,2.82L150.44,368a.92.92,0,0,0-.85,0l-9.06,5.23c-.25.14-.27.36-.05.49l5.63,3.25a.94.94,0,0,0,.86,0l9.05-5.23C156.27,371.55,156.3,371.33,156.07,371.2ZM136.46,362l-5.63-3.25a1,1,0,0,0-.86,0l-7.24,4.18c-.25.15-.28.37,0,.5l5.63,3.25a1,1,0,0,0,.85,0l7.25-4.18C136.66,362.31,136.68,362.09,136.46,362Zm5.55-3.2a1,1,0,0,0,.86,0l5.88-3.4c.25-.14.27-.37.05-.49l-5.63-3.25a.94.94,0,0,0-.85,0l-5.89,3.4c-.25.15-.27.37-.05.5Zm24.37,15.78-5.63-3.25a.94.94,0,0,0-.85,0l-11.32,6.54c-.25.14-.27.36-.05.49l5.63,3.25a.94.94,0,0,0,.85,0L166.33,375C166.58,374.89,166.6,374.66,166.38,374.54Zm4,7-5.63-3.25a1,1,0,0,0-.85,0l-7.25,4.18c-.25.15-.27.37-.05.5l5.63,3.25a1,1,0,0,0,.86,0L170.3,382C170.55,381.88,170.57,381.66,170.35,381.53ZM206,321.83a.92.92,0,0,0,.85,0l5.89-3.4c.25-.14.27-.36,0-.49l-5.63-3.25a.94.94,0,0,0-.86,0l-5.88,3.4c-.25.14-.27.36,0,.49Zm-17.21,9.93a1,1,0,0,0,.86,0l5.88-3.4c.25-.15.28-.37.05-.5l-5.63-3.25a1,1,0,0,0-.85,0l-5.89,3.4c-.25.14-.27.36-.05.49Zm-38.15,22a.94.94,0,0,0,.86,0l5.88-3.4c.25-.14.28-.36.05-.49l-5.63-3.25a.92.92,0,0,0-.85,0l-5.89,3.4c-.25.14-.27.36-.05.49Zm46.76-27a1,1,0,0,0,.85,0l5.89-3.4c.25-.14.27-.37,0-.49l-5.63-3.25a1,1,0,0,0-.86,0l-5.88,3.4c-.25.15-.28.37,0,.5Zm-17.21,9.93a.94.94,0,0,0,.86,0l5.88-3.4c.25-.14.28-.36,0-.49l-5.63-3.25a.92.92,0,0,0-.85,0l-5.89,3.4c-.25.14-.27.36-.05.49Zm-5.58,45.15a1,1,0,0,0-.86,0l-9.05,5.23c-.25.14-.28.36,0,.49l5.63,3.25a.92.92,0,0,0,.85,0l9.06-5.22c.25-.15.27-.37.05-.5Zm-6.76-38a1,1,0,0,0,.85,0l5.89-3.4c.25-.14.27-.36.05-.49L169,336.69a.94.94,0,0,0-.86,0l-5.88,3.39c-.25.15-.28.37-.05.5Zm-8.61,5a1,1,0,0,0,.86,0l5.89-3.4c.25-.15.27-.37,0-.5l-5.64-3.25a1,1,0,0,0-.85,0l-5.89,3.4c-.25.14-.27.37,0,.49Zm174.73-58.95a.92.92,0,0,0-.85,0l-14.49,8.36c-.25.15-.27.37-.05.5l5.63,3.25a1,1,0,0,0,.86,0l14.48-8.37c.25-.14.28-.36.05-.49Zm-19,11a.94.94,0,0,0-.86,0l-5.88,3.4c-.25.14-.28.36-.05.49l5.63,3.25a.92.92,0,0,0,.85,0l5.89-3.4c.25-.14.27-.36.05-.49ZM198.82,365.56l5.89-3.4c.25-.14.27-.36,0-.49l-5.63-3.25a.94.94,0,0,0-.86,0l-5.88,3.39c-.25.15-.27.37,0,.5l5.63,3.25A1,1,0,0,0,198.82,365.56Zm98.9-54.78a1,1,0,0,0-.85,0l-5.89,3.4c-.25.14-.27.36-.05.49l5.63,3.25a.94.94,0,0,0,.86,0l5.88-3.39c.25-.15.28-.37.05-.5Zm44.83-25.88a1,1,0,0,0-.86,0l-5.89,3.4c-.25.15-.27.37-.05.49l5.63,3.26a1,1,0,0,0,.86,0l5.89-3.4c.25-.15.27-.37.05-.5Zm14.23-1.71-13.68-7.9a1,1,0,0,0-.85,0l-5.89,3.4c-.25.14-.27.37-.05.49l13.68,7.9a1,1,0,0,0,.85,0l5.89-3.4C357,283.54,357,283.32,356.78,283.19Zm-91.2,46.15a1,1,0,0,0-.86,0l-7.24,4.18c-.25.15-.27.37-.05.5l5.63,3.25a1,1,0,0,0,.85,0l7.25-4.18c.25-.15.27-.37,0-.5Zm21.73-12.55a1,1,0,0,0-.85,0l-9.06,5.23c-.25.15-.27.37,0,.49L283,325.8a1,1,0,0,0,.86,0l9.05-5.23c.25-.15.27-.37.05-.5Zm-41.65,24a1,1,0,0,0-.86,0l-48.44,28c-.25.14-.27.37-.05.49l5.63,3.25a.94.94,0,0,0,.85,0l48.45-28c.25-.15.27-.37,0-.5ZM194.5,370.38a.94.94,0,0,0-.86,0l-7.24,4.18c-.25.14-.28.37-.05.49l5.63,3.26a1,1,0,0,0,.85,0l7.25-4.19c.25-.14.27-.36,0-.49Zm61.12-35.29a1,1,0,0,0-.86,0l-7.24,4.18c-.25.15-.27.37-.05.5l5.63,3.25a1,1,0,0,0,.85,0l7.25-4.18c.25-.15.27-.37.05-.5Zm-71.08,41a.94.94,0,0,0-.86,0l-7.24,4.18c-.25.15-.28.37-.05.5l5.63,3.25a1,1,0,0,0,.85,0l7.25-4.19c.25-.14.27-.36,0-.49Zm91-52.54a.94.94,0,0,0-.86,0l-7.24,4.18c-.25.15-.27.37-.05.49l5.63,3.26a1,1,0,0,0,.85,0l7.25-4.19c.25-.14.27-.36.05-.49Zm30.79-17.77a1,1,0,0,0-.86,0l-5.89,3.4c-.25.15-.27.37-.05.5l5.64,3.25a1,1,0,0,0,.85,0l5.89-3.4c.25-.14.27-.37,0-.49Zm19.26-13.45,5.89-3.4c.25-.14.27-.37,0-.49l-5.63-3.25a.94.94,0,0,0-.86,0l-5.88,3.39c-.25.15-.27.37-.05.5l5.63,3.25A1,1,0,0,0,325.59,292.37Zm-35.1,1.69,5.89-3.4c.25-.14.27-.36.05-.49l-5.63-3.25a.94.94,0,0,0-.86,0l-5.89,3.39c-.25.15-.27.37-.05.5l5.63,3.25A1,1,0,0,0,290.49,294.06Zm-22.85,31.77,17.21-9.94c.25-.14.27-.36,0-.49l-5.63-3.25a.94.94,0,0,0-.86,0l-17.2,9.93c-.25.15-.28.37,0,.5l5.63,3.25A1,1,0,0,0,267.64,325.83Zm48.5-28.47a.94.94,0,0,0,.85,0l5.89-3.4c.25-.15.27-.37.05-.5l-5.63-3.25a1,1,0,0,0-.86,0l-5.88,3.4c-.25.14-.28.37-.05.49ZM309,292.69l5.88-3.4c.25-.14.28-.36.05-.49l-5.63-3.25a.92.92,0,0,0-.85,0l-5.89,3.4c-.25.14-.27.36-.05.49l5.63,3.25A.94.94,0,0,0,309,292.69ZM259,330.79l5.89-3.39c.25-.15.27-.37.05-.5l-5.63-3.25a1,1,0,0,0-.86,0l-5.89,3.4c-.25.14-.27.36,0,.49l5.63,3.25A.94.94,0,0,0,259,330.79Zm38.08-22.45a.94.94,0,0,0,.86,0l5.88-3.39c.25-.15.27-.37.05-.5l-5.63-3.25a1,1,0,0,0-.85,0l-5.89,3.4c-.25.14-.27.36-.05.49ZM216,355.63l5.88-3.4c.25-.15.28-.37.06-.5l-5.64-3.25a1,1,0,0,0-.85,0l-5.89,3.4c-.25.15-.27.37-.05.49l5.63,3.26A1,1,0,0,0,216,355.63Zm8.6-5,5.89-3.4c.25-.14.27-.36,0-.49l-5.63-3.25a.94.94,0,0,0-.86,0l-5.88,3.39c-.25.15-.28.37-.06.5l5.64,3.25A1,1,0,0,0,224.63,350.66Zm-17.2,9.93,5.88-3.4c.25-.14.28-.36.05-.49l-5.63-3.25a.92.92,0,0,0-.85,0l-5.89,3.4c-.25.14-.27.36-.05.49l5.63,3.25A.94.94,0,0,0,207.43,360.59Zm34.41-19.86,5.88-3.4c.25-.15.27-.37.05-.5l-5.63-3.25a1,1,0,0,0-.85,0L235.4,337c-.25.15-.27.37-.05.49l5.63,3.26A1,1,0,0,0,241.84,340.73Zm-8.61,5,5.89-3.4c.25-.14.27-.36,0-.49l-5.63-3.25a.94.94,0,0,0-.86,0L226.8,342c-.25.14-.28.36-.05.49l5.63,3.25A.92.92,0,0,0,233.23,345.69Zm17.21-9.93,5.88-3.4c.25-.14.28-.36.05-.49l-5.63-3.25a.92.92,0,0,0-.85,0L244,332c-.25.15-.27.37-.05.5l5.63,3.25A1,1,0,0,0,250.44,335.76Zm46.94-69.09a1,1,0,0,0,.85,0l5.89-3.4c.25-.14.27-.36.05-.49l-1.5-.87a1,1,0,0,0-.85,0l-5.89,3.4c-.25.14-.27.37-.05.49Zm-42.76,27.07a.94.94,0,0,0,.86,0l5.88-3.4c.25-.14.28-.36.06-.49l-5.64-3.25a.92.92,0,0,0-.85,0L249,290c-.25.14-.27.36,0,.49Zm17.21-9.93a1,1,0,0,0,.85,0l5.89-3.4c.25-.14.27-.37.05-.49L273,276.63a1,1,0,0,0-.86,0l-5.88,3.4c-.25.15-.27.37-.05.5Zm-27.71,16a1,1,0,0,0,.86,0l5.88-3.4c.25-.15.27-.37,0-.5l-5.63-3.25a1,1,0,0,0-.85,0l-5.89,3.4c-.25.14-.27.37,0,.49Zm19.11-11a.92.92,0,0,0,.85,0l5.89-3.39c.25-.15.27-.37,0-.5l-5.63-3.25a1,1,0,0,0-.86,0l-5.88,3.4c-.25.14-.28.36,0,.49Zm-36.31,21a1,1,0,0,0,.85,0l5.89-3.4c.25-.14.27-.37.05-.49l-5.63-3.25a1,1,0,0,0-.86,0l-5.89,3.4c-.25.15-.27.37,0,.5Zm8.6-5a.92.92,0,0,0,.85,0l5.89-3.4c.25-.14.27-.36.05-.49l-5.63-3.25a.94.94,0,0,0-.86,0l-5.88,3.4c-.25.14-.28.36-.05.49Zm44.66-28.17a.92.92,0,0,0,.85,0l5.89-3.4c.25-.14.27-.36.05-.49l-1.5-.86a1,1,0,0,0-.86,0l-5.88,3.4c-.25.15-.28.37-.05.5ZM306,261.7a.94.94,0,0,0,.86,0l5.88-3.39c.25-.15.28-.37,0-.5l-1.5-.86a.92.92,0,0,0-.85,0l-5.89,3.39c-.25.15-.27.37,0,.5Zm11.83,6.83a.94.94,0,0,0,.86,0l5.88-3.4c.25-.14.27-.36.05-.49L319,261.36a.92.92,0,0,0-.85,0l-5.89,3.4c-.25.14-.27.36-.05.49ZM334.2,287.4l5.88-3.4c.25-.14.27-.36.05-.49l-5.63-3.25a.92.92,0,0,0-.85,0l-5.89,3.4c-.25.14-.27.36-.05.49l5.63,3.25A.94.94,0,0,0,334.2,287.4Zm-45.42-15.76a1,1,0,0,0,.85,0l5.89-3.4c.25-.15.27-.37.05-.5l-1.5-.86a.94.94,0,0,0-.86,0l-5.88,3.4c-.25.14-.27.36-.05.49ZM218.31,314.7a.94.94,0,0,0,.86,0l5.88-3.39c.25-.15.28-.37,0-.5l-5.63-3.25a1,1,0,0,0-.85,0l-5.89,3.4c-.25.14-.27.36,0,.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tuch-pad--inject-25"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "242.95 363.66 244.23 364.39 278.22 384.02 338.67 349.11 339.93 348.4 304.66 328.04 242.95 363.66",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.9 349.56 304.66 330.39 245.01 364.84 278.22 384.02 337.9 349.56",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.2,351c-2.45-1.13-3.12-3.08-3.35-6.52l-11-160.82A11.16,11.16,0,0,1,66,174.2L270.59,56.1c3.09-1.79,5.36-2.76,8.22-.8s2.92,3,3.15,6.47l11,160.81a11.1,11.1,0,0,1-5.18,9.46L83.21,350.15C80.12,351.93,78.37,352.46,75.2,351Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,61.76c-.23-3.43-2.93-4.77-6-3L71.37,176.88A10.46,10.46,0,0,0,67.54,181l-5.34-2.69h0A10.75,10.75,0,0,1,66,174.2L270.59,56.1c3.09-1.79,5.37-2.78,8.21-.81C281.81,57.37,281.73,58.33,282,61.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8,350.38c-2.82,1.67-4.6,1.87-7.6.61-2.29-1-3.12-3.07-3.35-6.51l-11-160.83a9.86,9.86,0,0,1,1.34-5.33L67.54,181h0a10.21,10.21,0,0,0-1.35,5.34l11,160.83C77.4,350.34,80.16,351.94,82.8,350.38Z",
    style: {
      fill: "#263238"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.92,183,271.78,69.41c1.86-1.08,3.48-.27,3.62,1.79l10.26,150a6.69,6.69,0,0,1-3.11,5.67L85.69,340.52c-1.86,1.08-3.48.27-3.62-1.79l-10.25-150A6.68,6.68,0,0,1,74.92,183Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74.92,183a6.68,6.68,0,0,0-3.1,5.67L81.9,336.23,276.51,223.91a6.69,6.69,0,0,0,3.11-5.68L269.53,70.7Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.79,337.83a3.74,3.74,0,0,1-1.65.51,4.6,4.6,0,0,1-2.48-.35,4.44,4.44,0,0,1-2.24-3.32L79.14,213.41l4.17,2.07,8.27,121.25c.06.9.58,1.41,1.28,1.39A2.15,2.15,0,0,0,93.79,337.83Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.73,337.65c-.61,0-.72-.65-.74-.93L82.86,202.84,272,93.64,281.09,227a3.65,3.65,0,0,1-1.67,3.07l-186,107.38A1.42,1.42,0,0,1,92.73,337.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.64,94.46l.77,11.28L280.68,227a3.22,3.22,0,0,1-1.45,2.66L93.23,337a.9.9,0,0,1-.44.16c-.17,0-.2-.48-.2-.48L83.47,203.1,271.64,94.46m.9-1.63L82.43,202.58l9.15,134.15c.06.9.58,1.41,1.28,1.39a2,2,0,0,0,.93-.29l186-107.38a4.09,4.09,0,0,0,1.9-3.48l-8.27-121.25-.88-12.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.77,81.91c-.22-1-1.14-1.38-2.17-.78l-186,107.38A4,4,0,0,0,82.2,190L78,188a3.93,3.93,0,0,1,1.41-1.5l186-107.38a4.88,4.88,0,0,1,4.14-.16A4.51,4.51,0,0,1,271.77,81.91Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.77,81.91c-.22-1-1.14-1.38-2.17-.78l-186,107.38A4,4,0,0,0,82.2,190L78,188a3.93,3.93,0,0,1,1.41-1.5l186-107.38a4.88,4.88,0,0,1,4.14-.16A4.51,4.51,0,0,1,271.77,81.91Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2,190a3.57,3.57,0,0,0-.49,2l.72,10.6-4.17-2.07-.72-10.59a1,1,0,0,1,0-.24,3.9,3.9,0,0,1,0-.5A4.24,4.24,0,0,1,78,188Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2,190a3.57,3.57,0,0,0-.49,2l.72,10.6-4.17-2.07-.72-10.59a1,1,0,0,1,0-.24,3.9,3.9,0,0,1,0-.5A4.24,4.24,0,0,1,78,188Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.81,82.23l.73,10.6L142.52,168c-1.13.65-2.12.16-2.21-1.1l-.27-4c-.09-1.26-1.08-1.75-2.22-1.1L91.64,188.34c-1,.51-1,1.76-1.14,3.46l-.5,4a4.21,4.21,0,0,1-1.9,3.48l-5.67,3.27L81.71,192a4.06,4.06,0,0,1,1.9-3.48l186-107.38C270.73,80.47,271.73,81,271.81,82.23Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.07,88c.88-.5,1.64-.13,1.7.84a3.11,3.11,0,0,1-1.46,2.67c-.87.51-1.63.13-1.7-.84A3.16,3.16,0,0,1,266.07,88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.38,91.32c.87-.5,1.64-.12,1.7.85a3.15,3.15,0,0,1-1.46,2.67c-.87.5-1.63.12-1.7-.85A3.15,3.15,0,0,1,260.38,91.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.69,94.6c.87-.5,1.63-.12,1.7.85a3.17,3.17,0,0,1-1.46,2.67c-.88.5-1.64.12-1.7-.85A3.13,3.13,0,0,1,254.69,94.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.54,92.83l.88,12.89L83.31,215.48l-.88-12.9,4.24-2.45c1.13-.66,1.46-1.63,1.9-3.48l1.16-4.83c.36-1.68.77-2.83,1.91-3.48l47.88-27.58c1.15-.66,2.07-.75,3.06.62l2,3c.75,1.06,1.13,1.68,2.26,1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.43 202.58 83.31 215.48 79.14 213.41 78.26 200.53 82.43 202.58",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.43 202.58 83.31 215.48 79.14 213.41 78.26 200.53 82.43 202.58",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.31,203.31l-3.24,1.86,1.12-2.31a.51.51,0,0,0,0-.55c-.1-.11-.27,0-.37.17l-1.6,3.29h0a.56.56,0,0,0,0,.12l0,0a1,1,0,0,0,0,.17.47.47,0,0,0,0,.14v0s0,.05.06.06h0l1.91,1.26a.19.19,0,0,0,.18,0,.57.57,0,0,0,.19-.25.48.48,0,0,0-.07-.53L89.12,206l3.24-1.87a.63.63,0,0,0,.23-.54C92.58,203.33,92.45,203.22,92.31,203.31Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,201.75l3.23-1.87L96.9,199c-.12-.08-.14-.31-.06-.53s.25-.32.36-.25l1.91,1.26h0a.18.18,0,0,1,0,.07l0,0a.32.32,0,0,1,0,.14.47.47,0,0,1,0,.17v0a.56.56,0,0,1,0,.12h0l-1.6,3.29a.47.47,0,0,1-.16.2.18.18,0,0,1-.21,0,.55.55,0,0,1,0-.56l1.13-2.31-3.24,1.87c-.14.08-.27,0-.29-.24A.6.6,0,0,1,95,201.75Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.41,192.55c0-.19-.2-.16-.28,0l-.39,1.06c-.79-.07-1.69.66-2.25,1.94-.72,1.65-.59,3.58.3,4.3a1.24,1.24,0,0,0,1.51.05,3.6,3.6,0,0,0,1.39-1.72.52.52,0,0,0,0-.55c-.12-.09-.28,0-.37.21-.54,1.23-1.51,1.8-2.17,1.26s-.76-2-.22-3.22a2.15,2.15,0,0,1,1.53-1.45l-.29.8c-.07.2,0,.39.16.3l1.31-.85a.41.41,0,0,0,.13-.36Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.61,166l1.06-2.43a.69.69,0,0,0,0-.75c-.15-.12-.38,0-.51.29l-1.06,2.43-1.29-1.06c-.16-.13-.38,0-.51.29a.71.71,0,0,0,.05.75l1.3,1.06L137.54,169a.71.71,0,0,0,.05.75.23.23,0,0,0,.26,0,.64.64,0,0,0,.25-.3l1.06-2.43,1.3,1.06a.2.2,0,0,0,.26,0,.58.58,0,0,0,.24-.3.68.68,0,0,0-.05-.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.07,195.41l-.27-4a4.06,4.06,0,0,1,1.9-3.48l147.33-85c1.14-.66,2.13-.16,2.22,1.1l.27,4a4.07,4.07,0,0,1-1.91,3.48l-147.32,85C111.15,197.17,110.16,196.67,110.07,195.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.73,111.87a.64.64,0,0,1-.2,0,.56.56,0,0,1-.36-.59l.1-1.63-.86-.54a.56.56,0,0,1-.26-.43.85.85,0,0,1,.3-.71l1.2-.92a.17.17,0,0,0,.05-.09l.44-1.72a.72.72,0,0,1,.6-.57.54.54,0,0,1,.51.26l.54.92,1-.4a.57.57,0,0,1,.58.11.68.68,0,0,1,.08.8l-.8,1.6s0,.09,0,.1l.31,1.43a.84.84,0,0,1-.22.72.61.61,0,0,1-.49.19l-1-.1-1,1.34A.62.62,0,0,1,256.73,111.87Zm-.84-3.3.86.54a.56.56,0,0,1,.26.54l-.06,1.08.68-.89a.61.61,0,0,1,.55-.26l1,.1a.3.3,0,0,0,0-.11l-.31-1.43a.76.76,0,0,1,.07-.51l.7-1.41-.79.31a.53.53,0,0,1-.67-.23l-.42-.72-.4,1.53a.84.84,0,0,1-.28.44l-1.2.93S255.9,108.54,255.89,108.57Zm2.71-2.67h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M263.66,102.32A.78.78,0,0,1,263,102a.64.64,0,0,1,.21-.94L269,97.7a.8.8,0,0,1,1,.23.65.65,0,0,1-.21.94l-5.8,3.35A.68.68,0,0,1,263.66,102.32Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M263.88,105.55a.83.83,0,0,1-.67-.33.65.65,0,0,1,.21-1l5.8-3.35a.8.8,0,0,1,1,.23.66.66,0,0,1-.21.95l-5.8,3.35A.92.92,0,0,1,263.88,105.55Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M264.1,108.77a.8.8,0,0,1-.67-.33.64.64,0,0,1,.21-.94l5.8-3.35a.79.79,0,0,1,1,.23.65.65,0,0,1-.21.94l-5.8,3.35A.78.78,0,0,1,264.1,108.77Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    points: "91.03 219.31 266.79 117.83 274.13 225.43 98.37 326.9 91.03 219.31",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,218.16a1.08,1.08,0,0,1-.09.5.64.64,0,0,1-.28.35l-2,1.15a.25.25,0,0,1-.31,0,.5.5,0,0,1-.15-.36l-.33-4.81-4.17-7.56a.5.5,0,0,1-.08-.26.87.87,0,0,1,.07-.41.6.6,0,0,1,.23-.28l2.09-1.21c.2-.11.36-.13.47,0a.81.81,0,0,1,.21.23l2.3,4.45,1.55-6.68a3.24,3.24,0,0,1,.16-.44,1,1,0,0,1,.45-.49l2.08-1.21a.21.21,0,0,1,.25,0,.42.42,0,0,1,.12.3,1,1,0,0,1,0,.32l-2.87,11.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.8,205.55c0,.22,0,.51.07.86s0,.65,0,.88a8.85,8.85,0,0,1-.19,2.22,9.91,9.91,0,0,1-.73,2.15,8.26,8.26,0,0,1-1.21,1.86,6.43,6.43,0,0,1-1.66,1.38,3.73,3.73,0,0,1-1.71.56,2.17,2.17,0,0,1-1.36-.37,2.84,2.84,0,0,1-1-1.18,5.33,5.33,0,0,1-.48-1.84c0-.21-.05-.5-.07-.86s0-.64-.05-.87a8.4,8.4,0,0,1,.18-2.22,9.93,9.93,0,0,1,.74-2.15,8.66,8.66,0,0,1,1.22-1.88,6.19,6.19,0,0,1,1.65-1.38,3.61,3.61,0,0,1,1.71-.56,2.3,2.3,0,0,1,1.38.38,2.84,2.84,0,0,1,1,1.18A5.63,5.63,0,0,1,150.8,205.55Zm-5.44,4.83a1.48,1.48,0,0,0,.51,1.1.92.92,0,0,0,1-.08,2.34,2.34,0,0,0,1-1.06,3.37,3.37,0,0,0,.33-1.58,7.24,7.24,0,0,0,0-.79c0-.28,0-.53-.08-.75a1.48,1.48,0,0,0-.51-1.1.92.92,0,0,0-1,.09,2.32,2.32,0,0,0-.95,1,3.39,3.39,0,0,0-.33,1.58c0,.24,0,.5,0,.79A7,7,0,0,0,145.36,210.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.85,200.36a1.13,1.13,0,0,1,.09-.5.75.75,0,0,1,.28-.34l1.92-1.11a.24.24,0,0,1,.3,0,.48.48,0,0,1,.15.36l.39,5.71a2.61,2.61,0,0,0,.4,1.39c.22.28.55.29,1,0a2,2,0,0,0,.91-1.14,4.67,4.67,0,0,0,.18-1.72l-.39-5.71a1.08,1.08,0,0,1,.09-.5.68.68,0,0,1,.28-.35l1.92-1.11a.24.24,0,0,1,.3,0,.5.5,0,0,1,.15.36l.72,10.52a1.11,1.11,0,0,1-.09.5.68.68,0,0,1-.28.35l-1.77,1a.24.24,0,0,1-.3,0,.5.5,0,0,1-.15-.36l0-.52a5.61,5.61,0,0,1-.26.66,4.55,4.55,0,0,1-.41.68,4.9,4.9,0,0,1-.58.66,4.77,4.77,0,0,1-.8.6,2.1,2.1,0,0,1-2.44.11c-.64-.49-1-1.62-1.15-3.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.08,190.94a.24.24,0,0,1,.3,0,.51.51,0,0,1,.16.36l.15,2.28a1.13,1.13,0,0,1-.09.5.73.73,0,0,1-.28.35l-1.38.8a2.8,2.8,0,0,0-1.27,2.88l.38,5.56a1.13,1.13,0,0,1-.09.5.78.78,0,0,1-.28.35l-1.92,1.1a.24.24,0,0,1-.3,0,.47.47,0,0,1-.15-.36l-.72-10.52a1,1,0,0,1,.1-.5.71.71,0,0,1,.27-.35l1.77-1a.24.24,0,0,1,.3,0,.46.46,0,0,1,.15.35l0,.52a6.19,6.19,0,0,1,.79-1.3,4,4,0,0,1,1.16-1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.87,199.8a.25.25,0,0,1-.3,0,.55.55,0,0,1-.16-.36l-1-14.59a1.13,1.13,0,0,1,.09-.5.79.79,0,0,1,.28-.35l2-1.15a.25.25,0,0,1,.3,0,.5.5,0,0,1,.15.36l1,14.59a.91.91,0,0,1-.09.5.67.67,0,0,1-.28.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.31,192a1.11,1.11,0,0,1-.09.5.68.68,0,0,1-.28.35L183,193.94a.25.25,0,0,1-.3,0,.5.5,0,0,1-.15-.36l-.39-5.72a2.35,2.35,0,0,0-.43-1.37q-.36-.4-1.05,0a2.11,2.11,0,0,0-.95,1.16,4.21,4.21,0,0,0-.21,1.74l.39,5.71a1.13,1.13,0,0,1-.09.5.79.79,0,0,1-.28.35l-1.92,1.1a.24.24,0,0,1-.3,0,.47.47,0,0,1-.15-.36l-.72-10.52a1.11,1.11,0,0,1,.09-.5.73.73,0,0,1,.28-.35l1.84-1.06a.24.24,0,0,1,.3,0,.53.53,0,0,1,.16.36l0,.52c.07-.2.16-.41.27-.65a3.93,3.93,0,0,1,.42-.7,4.9,4.9,0,0,1,.58-.66,3.76,3.76,0,0,1,.79-.58,3.28,3.28,0,0,1,1.36-.48,1.57,1.57,0,0,1,1.11.34,2.74,2.74,0,0,1,.79,1.21,8.17,8.17,0,0,1,.4,2.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,183.56c0,.23,0,.5,0,.8s.05.56.08.78a1.48,1.48,0,0,0,.5,1.07.88.88,0,0,0,1-.07,2.17,2.17,0,0,0,.76-.66,3,3,0,0,0,.39-.85,2.19,2.19,0,0,1,.15-.41.62.62,0,0,1,.26-.29l2-1.16a.27.27,0,0,1,.31,0,.44.44,0,0,1,.14.37,6.45,6.45,0,0,1-.12,1.17,8,8,0,0,1-.55,1.76,9.06,9.06,0,0,1-1.15,1.91,6.62,6.62,0,0,1-1.95,1.65,3.88,3.88,0,0,1-1.62.56,2.23,2.23,0,0,1-1.36-.29,2.6,2.6,0,0,1-1-1.13,5.34,5.34,0,0,1-.5-1.95c0-.22-.06-.51-.08-.89s0-.68-.05-.91a9.34,9.34,0,0,1,.21-2.37,9,9,0,0,1,.78-2.14,8.08,8.08,0,0,1,1.22-1.79,6.49,6.49,0,0,1,1.57-1.28,3.74,3.74,0,0,1,2-.64,2.17,2.17,0,0,1,1.31.49,2.49,2.49,0,0,1,.74,1,4.4,4.4,0,0,1,.27.94.91.91,0,0,1-.09.5.79.79,0,0,1-.28.35l-2,1.15a.24.24,0,0,1-.28,0,.78.78,0,0,1-.19-.21.74.74,0,0,0-.48-.35,1.15,1.15,0,0,0-.78.23,2.27,2.27,0,0,0-.94,1.06A3.48,3.48,0,0,0,189,183.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.72,175c0,.22.05.5.07.85s0,.65.05.88a8.91,8.91,0,0,1-.2,2.23,9.32,9.32,0,0,1-.73,2.14A7.93,7.93,0,0,1,201.7,183a6,6,0,0,1-1.65,1.38,3.75,3.75,0,0,1-1.72.57,2.17,2.17,0,0,1-1.36-.38,2.89,2.89,0,0,1-.95-1.17,5.45,5.45,0,0,1-.48-1.84c0-.22,0-.51-.07-.86s0-.65,0-.88a8.32,8.32,0,0,1,.18-2.21,9.4,9.4,0,0,1,.73-2.15,8.79,8.79,0,0,1,1.22-1.88,6.39,6.39,0,0,1,1.65-1.39,3.62,3.62,0,0,1,1.72-.55,2.2,2.2,0,0,1,1.37.38,2.75,2.75,0,0,1,.95,1.17A5.69,5.69,0,0,1,203.72,175Zm-5.44,4.82a1.45,1.45,0,0,0,.51,1.1.9.9,0,0,0,1-.08,2.38,2.38,0,0,0,.95-1.05,3.69,3.69,0,0,0,.33-1.58c0-.24,0-.5,0-.79a6.65,6.65,0,0,0-.08-.75,1.48,1.48,0,0,0-.51-1.1.94.94,0,0,0-1,.08,2.49,2.49,0,0,0-.95,1,3.56,3.56,0,0,0-.32,1.59,7,7,0,0,0,0,.78C198.22,179.36,198.25,179.61,198.28,179.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.07,173.07a1,1,0,0,1-.1.5.71.71,0,0,1-.27.35L215.85,175a.24.24,0,0,1-.3,0,.47.47,0,0,1-.15-.36l-.39-5.78a2.49,2.49,0,0,0-.4-1.44c-.2-.21-.49-.2-.86,0a1.83,1.83,0,0,0-.78.94,4,4,0,0,0-.17,1.77l.39,5.78a1.13,1.13,0,0,1-.09.5.75.75,0,0,1-.28.34L211,177.8a.27.27,0,0,1-.31,0,.5.5,0,0,1-.15-.36l-.39-5.78a2.37,2.37,0,0,0-.39-1.44q-.31-.32-.87,0a1.87,1.87,0,0,0-.78.94,3.86,3.86,0,0,0-.18,1.7l.4,5.85a1.11,1.11,0,0,1-.09.5.68.68,0,0,1-.28.35L206,180.66a.25.25,0,0,1-.3,0,.5.5,0,0,1-.15-.36l-.72-10.52a1.08,1.08,0,0,1,.09-.5.74.74,0,0,1,.28-.35l1.84-1.07a.25.25,0,0,1,.31,0,.47.47,0,0,1,.15.36l0,.51a6.27,6.27,0,0,1,.75-1.46,3.41,3.41,0,0,1,1.1-1,2.42,2.42,0,0,1,1.44-.38,1.51,1.51,0,0,1,1.12.73,7.14,7.14,0,0,1,1-1.93,4.5,4.5,0,0,1,1.33-1.23,2.57,2.57,0,0,1,1.24-.4,1.46,1.46,0,0,1,1,.38,3,3,0,0,1,.74,1.25,9.17,9.17,0,0,1,.38,2.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.87,166.75a1.87,1.87,0,0,0,.18.78.82.82,0,0,0,.37.35.71.71,0,0,0,.46,0,2,2,0,0,0,.48-.19,3.08,3.08,0,0,0,.71-.56,2.76,2.76,0,0,0,.43-.64,3.5,3.5,0,0,1,.22-.4.74.74,0,0,1,.26-.21l2-1.14c.22-.13.35,0,.37.3a3.81,3.81,0,0,1-.17,1,8.33,8.33,0,0,1-.64,1.54,9.37,9.37,0,0,1-1.17,1.72,6.57,6.57,0,0,1-1.78,1.47,3.86,3.86,0,0,1-1.79.6,1.94,1.94,0,0,1-1.38-.46,3.14,3.14,0,0,1-.92-1.46A9.33,9.33,0,0,1,219,167a12.34,12.34,0,0,1,.11-2.58,9.49,9.49,0,0,1,.66-2.39,7.91,7.91,0,0,1,1.21-2,6.23,6.23,0,0,1,1.72-1.48,3.19,3.19,0,0,1,1.94-.54,2.23,2.23,0,0,1,1.38.69,4,4,0,0,1,.85,1.57,8.87,8.87,0,0,1,.37,2.05l0,.63a1.13,1.13,0,0,1-.09.5.73.73,0,0,1-.28.35Zm1.07-5.13a2.15,2.15,0,0,0-.93,1.13,4,4,0,0,0-.31,1.49l2.74-1.58a1.81,1.81,0,0,0-.48-1Q223.59,161.25,222.94,161.62Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.17,211a2.44,2.44,0,0,1,1.14-.1,1.75,1.75,0,0,1,.86.39,2,2,0,0,1,.56.72,3,3,0,0,1,.26.87.78.78,0,0,1-.31.72l-.91.52a.36.36,0,0,1-.33.06.58.58,0,0,1-.22-.22,1.19,1.19,0,0,0-.65-.49,1.67,1.67,0,0,0-1.19.32,4,4,0,0,0-.63.47,3.31,3.31,0,0,0-.5.62,2.58,2.58,0,0,0-.33.69,2,2,0,0,0-.08.72,1.09,1.09,0,0,0,.19.63.69.69,0,0,0,.49.22,3.15,3.15,0,0,0,.84-.1c.33-.08.75-.17,1.23-.3a4.69,4.69,0,0,1,1.35-.17,1.71,1.71,0,0,1,.93.3,1.69,1.69,0,0,1,.56.79,4.58,4.58,0,0,1,.24,1.31,5.42,5.42,0,0,1-.1,1.5,6.17,6.17,0,0,1-.48,1.49,6.93,6.93,0,0,1-.83,1.38,7.19,7.19,0,0,1-1.17,1.17l.09,1.29a1,1,0,0,1-.08.43.58.58,0,0,1-.23.29l-1.05.6a.2.2,0,0,1-.25,0,.39.39,0,0,1-.13-.3l-.09-1.3a3.24,3.24,0,0,1-1.12.18,2,2,0,0,1-.94-.26,1.86,1.86,0,0,1-.68-.71,2.93,2.93,0,0,1-.35-1.17.78.78,0,0,1,.31-.72l.9-.52a.46.46,0,0,1,.35-.08.44.44,0,0,1,.21.23,1.9,1.9,0,0,0,.26.37.67.67,0,0,0,.37.24,1.1,1.1,0,0,0,.57,0,2.7,2.7,0,0,0,.83-.35,6.09,6.09,0,0,0,.74-.51,3.44,3.44,0,0,0,.61-.66,3.16,3.16,0,0,0,.41-.74,2.14,2.14,0,0,0,.11-.84.82.82,0,0,0-.22-.58.85.85,0,0,0-.58-.14,4.77,4.77,0,0,0-.93.16c-.37.1-.8.19-1.28.28a3.84,3.84,0,0,1-1.17.11,1.48,1.48,0,0,1-.85-.31,1.75,1.75,0,0,1-.54-.81,4.71,4.71,0,0,1-.26-1.39,5.68,5.68,0,0,1,.1-1.48,6.79,6.79,0,0,1,.46-1.45,6.38,6.38,0,0,1,.76-1.31,7,7,0,0,1,1-1.09l-.09-1.29a.94.94,0,0,1,.08-.43.58.58,0,0,1,.23-.29l1-.6a.2.2,0,0,1,.25,0,.39.39,0,0,1,.13.3Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.48,206.22a2.44,2.44,0,0,1,1.14-.1,2,2,0,0,1,.86.39,2.19,2.19,0,0,1,.56.72,3.2,3.2,0,0,1,.26.87.8.8,0,0,1-.07.43.72.72,0,0,1-.24.29l-.91.52c-.14.08-.26.11-.33.06a.64.64,0,0,1-.23-.21,1.11,1.11,0,0,0-.64-.5,1.68,1.68,0,0,0-1.19.33,3,3,0,0,0-.63.47,3,3,0,0,0-.51.61,3.08,3.08,0,0,0-.32.69,2,2,0,0,0-.08.72,1.13,1.13,0,0,0,.19.64.64.64,0,0,0,.49.21,3.15,3.15,0,0,0,.84-.1l1.23-.29a5.11,5.11,0,0,1,1.34-.18,1.56,1.56,0,0,1,1.5,1.1,5.3,5.3,0,0,1,.24,1.3,5.52,5.52,0,0,1-.1,1.51,7,7,0,0,1-.48,1.49,7.06,7.06,0,0,1-2,2.54l.09,1.3a.9.9,0,0,1-.08.42.58.58,0,0,1-.23.29l-1.05.61a.2.2,0,0,1-.25,0,.39.39,0,0,1-.13-.3l-.09-1.3a2.82,2.82,0,0,1-1.12.18,1.94,1.94,0,0,1-.94-.26,1.83,1.83,0,0,1-.68-.7,2.83,2.83,0,0,1-.35-1.18.72.72,0,0,1,.07-.43.62.62,0,0,1,.24-.28l.9-.52c.15-.09.26-.12.34-.08a.38.38,0,0,1,.22.23,2.26,2.26,0,0,0,.26.37.71.71,0,0,0,.37.23,1.1,1.1,0,0,0,.57,0,2.9,2.9,0,0,0,.83-.34,6.17,6.17,0,0,0,.74-.52,3.39,3.39,0,0,0,.61-.65,3,3,0,0,0,.4-.75,1.93,1.93,0,0,0,.12-.83.83.83,0,0,0-.22-.59.91.91,0,0,0-.58-.14,6,6,0,0,0-.94.16c-.36.1-.79.19-1.28.29a4.07,4.07,0,0,1-1.16.1,1.42,1.42,0,0,1-.85-.31,1.87,1.87,0,0,1-.55-.8,5.26,5.26,0,0,1-.25-1.39,5.73,5.73,0,0,1,.1-1.49,6.89,6.89,0,0,1,.46-1.44,6.2,6.2,0,0,1,.76-1.32,6.91,6.91,0,0,1,1-1.08l-.09-1.3a.79.79,0,0,1,.08-.42.61.61,0,0,1,.23-.3l1-.6a.21.21,0,0,1,.26,0,.39.39,0,0,1,.13.3Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.79,201.42a2.3,2.3,0,0,1,1.14-.09,1.88,1.88,0,0,1,.86.38,2.19,2.19,0,0,1,.56.72,3.16,3.16,0,0,1,.26.88.77.77,0,0,1-.07.42.61.61,0,0,1-.25.29l-.9.52c-.14.09-.26.11-.33.07a.59.59,0,0,1-.23-.22,1.09,1.09,0,0,0-.64-.49,1.61,1.61,0,0,0-1.19.32,3.44,3.44,0,0,0-.63.47,3.24,3.24,0,0,0-.51.61,2.69,2.69,0,0,0-.32.69,2,2,0,0,0-.08.72,1.1,1.1,0,0,0,.19.64.63.63,0,0,0,.49.21,3.41,3.41,0,0,0,.83-.09l1.24-.3a4.66,4.66,0,0,1,1.34-.17,1.58,1.58,0,0,1,.93.29,1.67,1.67,0,0,1,.57.8,5.3,5.3,0,0,1,.24,1.31,5.86,5.86,0,0,1-.1,1.5,6.81,6.81,0,0,1-.48,1.49,6.73,6.73,0,0,1-.84,1.37,6.12,6.12,0,0,1-1.16,1.17l.09,1.3a.9.9,0,0,1-.08.42.62.62,0,0,1-.24.3l-1,.6a.21.21,0,0,1-.25,0,.41.41,0,0,1-.13-.31l-.09-1.29a3.27,3.27,0,0,1-1.12.18,2.06,2.06,0,0,1-.94-.26,2,2,0,0,1-.69-.71,2.94,2.94,0,0,1-.34-1.18.73.73,0,0,1,.07-.43.62.62,0,0,1,.24-.28l.9-.52a.41.41,0,0,1,.34-.08.41.41,0,0,1,.22.23,3,3,0,0,0,.25.37.73.73,0,0,0,.38.24,1.36,1.36,0,0,0,.57,0,3.1,3.1,0,0,0,.83-.35,5.85,5.85,0,0,0,.74-.52A3.41,3.41,0,0,0,186,212a3,3,0,0,0,.4-.75,1.93,1.93,0,0,0,.12-.83.66.66,0,0,0-.8-.72,4.29,4.29,0,0,0-.94.16c-.37.09-.79.19-1.28.28a4.11,4.11,0,0,1-1.16.11,1.56,1.56,0,0,1-.85-.31,1.88,1.88,0,0,1-.55-.81,5.26,5.26,0,0,1-.25-1.39,5.35,5.35,0,0,1,.1-1.49,7.5,7.5,0,0,1,.45-1.44,6.35,6.35,0,0,1,.77-1.31,6.56,6.56,0,0,1,1-1.09l-.09-1.3a.79.79,0,0,1,.08-.42.58.58,0,0,1,.23-.29l1-.61a.22.22,0,0,1,.26,0,.43.43,0,0,1,.13.31Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.1,196.63a2.43,2.43,0,0,1,1.14-.1,1.79,1.79,0,0,1,.86.39,2.12,2.12,0,0,1,.56.72,3,3,0,0,1,.26.87.72.72,0,0,1-.08.43.56.56,0,0,1-.24.28l-.9.53a.38.38,0,0,1-.34.06.65.65,0,0,1-.22-.22,1.13,1.13,0,0,0-.64-.49,1.66,1.66,0,0,0-1.19.32,4,4,0,0,0-.63.47,3.24,3.24,0,0,0-.51.61,2.61,2.61,0,0,0-.32.7,2,2,0,0,0-.08.72,1.09,1.09,0,0,0,.19.63.63.63,0,0,0,.49.21,2.67,2.67,0,0,0,.83-.09l1.24-.3a4.66,4.66,0,0,1,1.34-.17,1.71,1.71,0,0,1,.93.3,1.64,1.64,0,0,1,.57.79,5.39,5.39,0,0,1,.24,1.31,5.83,5.83,0,0,1-.1,1.5,6.64,6.64,0,0,1-.48,1.49,6.53,6.53,0,0,1-.84,1.38,6.76,6.76,0,0,1-1.16,1.17l.08,1.29a1,1,0,0,1-.07.43.55.55,0,0,1-.24.29l-1,.6a.21.21,0,0,1-.26,0,.42.42,0,0,1-.12-.3l-.09-1.3a3.27,3.27,0,0,1-1.12.18,1.94,1.94,0,0,1-.94-.26,1.89,1.89,0,0,1-.69-.71,2.94,2.94,0,0,1-.34-1.17.72.72,0,0,1,.07-.43.59.59,0,0,1,.24-.29l.9-.52a.45.45,0,0,1,.34-.08.41.41,0,0,1,.22.23,1.85,1.85,0,0,0,.25.37.73.73,0,0,0,.38.24,1.35,1.35,0,0,0,.57,0,2.66,2.66,0,0,0,.82-.35,6.19,6.19,0,0,0,.75-.51,3.79,3.79,0,0,0,.61-.66,3.12,3.12,0,0,0,.4-.74,2,2,0,0,0,.12-.84.8.8,0,0,0-.23-.58.82.82,0,0,0-.58-.14,5,5,0,0,0-.93.16c-.37.09-.79.19-1.28.28a4.14,4.14,0,0,1-1.16.11,1.48,1.48,0,0,1-.85-.31,1.69,1.69,0,0,1-.55-.81,4.75,4.75,0,0,1-.25-1.39,5.28,5.28,0,0,1,.1-1.48,7.38,7.38,0,0,1,.45-1.45,7.1,7.1,0,0,1,.76-1.31,7.5,7.5,0,0,1,1-1.09l-.08-1.3a.89.89,0,0,1,.07-.42.6.6,0,0,1,.24-.29l1-.6a.2.2,0,0,1,.26,0,.42.42,0,0,1,.12.3Z",
    style: {
      fill: "#B42F53"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--piggy-bank--inject-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--piggy-bank--inject-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--piggu-bank--inject-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.74,257.63c8.15-1.3,12.34-5.26,15.1-10.16,2-3.58,2.79-9.8,1.88-14.39a25.46,25.46,0,0,0-2.66-7.35c1.45-3.74.53-7.92-1.3-11.51-2.34-4.57-6.78-8-12.15-7.26-.88.12-.24.95.48,1.27,6.16,2.8,8.05,7.47,8.62,12.17a13.92,13.92,0,0,0-1.35-1A19.55,19.55,0,0,0,273,217.92c-4.87,2-5.6,6.75-2.27,10.55a16,16,0,0,0,18.83,3.3,19.35,19.35,0,0,1,.8,6.7A13.08,13.08,0,0,1,283.76,249a13.62,13.62,0,0,1-6.18,1.41,15.6,15.6,0,0,1-6.29-1.45,2.11,2.11,0,0,0-2.68,1.51C266.34,257.1,276.35,258.32,280.74,257.63ZM287.23,227c-2.4,1.26-5.87,1.88-8.39.92a8,8,0,0,1-3.7-2.35c-1.43-1.89.6-2.84,2.85-2.83A11.18,11.18,0,0,1,287.23,227Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.06,225.73a24.77,24.77,0,0,1,2.23,5.55,12,12,0,0,1-7,4.23,19.2,19.2,0,0,0-.74-3.74A11.48,11.48,0,0,0,295.06,225.73Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.23,227a11.16,11.16,0,0,0-.89-1,9.75,9.75,0,0,0,2.68-2.27,6.54,6.54,0,0,0,1.69-3.29A8,8,0,0,1,287.23,227Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.08,357.24c0-.05,0-.09,0-.14l0-.14h0c-.47-3.26,1.43-6.62,5.72-9.16,7.79-4.61,20.51-4.75,28.4-.3,4.34,2.44,6.31,5.76,5.92,9h0l0,.15c0,.05,8.33-1.17,8.33-1.17l-1.9,2A37.15,37.15,0,0,0,255,377.3l-1.06,7.06h0v.07h0c-.33,2-1.81,3.94-4.43,5.49-6.06,3.59-16,3.69-22.09.24-2.65-1.5-4.16-3.41-4.54-5.39h0v-.11Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.08,357.24c0-.05,0-.09,0-.14l0-.14h0c-.47-3.26,1.43-6.62,5.72-9.16,7.79-4.61,20.51-4.75,28.4-.3,4.34,2.44,6.31,5.76,5.92,9h0l0,.15c0,.05,8.33-1.17,8.33-1.17l-1.9,2A37.15,37.15,0,0,0,255,377.3l-1.06,7.06h0v.07h0c-.33,2-1.81,3.94-4.43,5.49-6.06,3.59-16,3.69-22.09.24-2.65-1.5-4.16-3.41-4.54-5.39h0v-.11Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.83,332.53l0-.14,0-.14h0c-.46-3.25,1.5-6.52,5.72-9.15,3-1.86,18.65-2,27.7-2.13,5.39-.06,8.34-.64,7.94,2.63h0l0,.14c0,.05,5.9-7.43,5.9-7.43h0a102.09,102.09,0,0,0-9.28,29.58l-2.1,13.76h0v.08h0c-.34,2-1.81,3.93-4.43,5.48-6.06,3.59-15.95,3.7-22.09.24-2.65-1.49-4.17-3.41-4.55-5.39h0V360Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.25,341.6c0-.05,0-.1,0-.14l0-.15h0c.4-3.26-1.63-6.48-5.91-9-3-1.8-18.68-1.63-27.74-1.53-5.38.05-8.35-.46-7.88,2.79h0l0,.15a.68.68,0,0,0,0,.14L178,369.49h0v.07h0c.38,2,1.9,3.89,4.55,5.39,6.14,3.45,16,3.34,22.09-.24,2.62-1.55,4.09-3.5,4.43-5.49h0v-.1Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.25,341.6c0-.05,0-.1,0-.14l0-.15h0c.4-3.26-1.63-6.48-5.91-9-3-1.8-18.68-1.63-27.74-1.53-5.38.05-8.35-.46-7.88,2.79h0l0,.15a.68.68,0,0,0,0,.14L178,369.49h0v.07h0c.38,2,1.9,3.89,4.55,5.39,6.14,3.45,16,3.34,22.09-.24,2.62-1.55,4.09-3.5,4.43-5.49h0v-.1Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.24,238.91c8.86-3.95,20.94-5.59,31.3-5.7a64,64,0,0,1,64.7,63.32c.25,23.52-12,45.58-29.42,59a139.37,139.37,0,0,1-28.3,16.18c-13.05,5.3-21.27,5.87-33.09,6a64,64,0,0,1-64.7-63.32c-.18-16.23,5.84-30.66,15.46-42.21,4-4.78,10.34-12.11,15.37-15.83C195.36,249.08,204.41,243.3,214.24,238.91Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.24,238.91c8.86-3.95,20.94-5.59,31.3-5.7a64,64,0,0,1,64.7,63.32c.25,23.52-12,45.58-29.42,59a139.37,139.37,0,0,1-28.3,16.18c-13.05,5.3-21.27,5.87-33.09,6a64,64,0,0,1-64.7-63.32c-.18-16.23,5.84-30.66,15.46-42.21,4-4.78,10.34-12.11,15.37-15.83C195.36,249.08,204.41,243.3,214.24,238.91Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.72,
    cy: 339.49,
    r: 11.69,
    transform: "translate(-161.16 475.33) rotate(-76.72)",
    style: {
      fill: "#B42F53",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.89,310.17a11.68,11.68,0,0,0-6.58-10.52,62.3,62.3,0,0,0-1.58,14.71,63.67,63.67,0,0,0,.43,6.81A11.68,11.68,0,0,0,162.89,310.17Z",
    style: {
      fill: "#B42F53",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.19,342.61C295.69,322.37,310,278,290,250.49a63.82,63.82,0,0,1,20.27,46c.25,23.52-12,45.58-29.42,59a139.37,139.37,0,0,1-28.3,16.18c-13.05,5.3-21.27,5.87-33.09,6A63.84,63.84,0,0,1,172,357.37l-.61-.67C207.55,382.16,246.7,362.85,271.19,342.61Z",
    style: {
      fill: "#B42F53",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.6,262l-9.82,5.81c-9.92-2.74-21.72-.88-29.14,12,0,0-2.9-29.86.82-38.16l2.86-1.69a8.64,8.64,0,0,1,5.67-.59C186.22,241.34,197.34,251.36,203.6,262Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.78,267.82c-12.84-3.14-22.55,1-29.14,12,0,0-11.69-42.84,6.61-38.82C183.63,243.68,193.78,267.82,193.78,267.82Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.78,267.82c-12.84-3.14-22.55,1-29.14,12,0,0-11.69-42.84,6.61-38.82C183.63,243.68,193.78,267.82,193.78,267.82Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.2,263.74c11.85-4.49,18.58,4.08,18.58,4.08-12.84-3.14-22.55,1-29.14,12A15.76,15.76,0,0,1,175.2,263.74Z",
    style: {
      fill: "#B42F53",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.67,279c10.94,9.74,20.8,22.14,28.12,40.79l9.41-5.53c3.51-3.64,12.41-34.37-5.52-45.59C233.71,261.19,213.67,279,213.67,279Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.67,279a103,103,0,0,1,28.12,40.79s19.52-34.63,1.44-49.67C232.67,261.36,213.67,279,213.67,279Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.67,279a103,103,0,0,1,28.12,40.79s19.52-34.63,1.44-49.67C232.67,261.36,213.67,279,213.67,279Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.67,279s10.88-.11,20.39,12.62c8.9,11.92,7.73,28.17,7.73,28.17A103,103,0,0,0,213.67,279Z",
    style: {
      fill: "#B42F53",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.61,311.69c3.8-2.25,9.24-1.93,15.3,1.48,11.67,6.58,21.25,22.12,21.38,34.73.07,6-2,10.27-5.51,12.37-1.68,1-8.26,4.91-10,5.89-3.8,2.21-9.21,1.87-15.24-1.52-11.67-6.57-21.24-22.12-21.38-34.73-.07-6,2-10.26,5.5-12.36C158.38,316.54,164.94,312.67,166.61,311.69Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.7,317.55c1.68-1,8.24-4.88,9.91-5.86,3.8-2.25,9.24-1.93,15.3,1.48a42.1,42.1,0,0,1,13,12l-38.29,22.66c-3.3-5.84-5.33-12.2-5.39-18C151.13,323.9,153.23,319.65,156.7,317.55Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,336.61l-36.68,21.61a49.1,49.1,0,0,1-7.75-10.35l38.29-22.66A48.84,48.84,0,0,1,201,336.61Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.09,319c-11.67-6.57-21-1.68-20.89,10.92s9.71,28.16,21.38,34.73,21,1.68,20.89-10.93S183.76,325.56,172.09,319Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.09,319c-11.67-6.57-21-1.68-20.89,10.92s9.71,28.16,21.38,34.73,21,1.68,20.89-10.93S183.76,325.56,172.09,319Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.09,319c-11.67-6.57-21-1.68-20.89,10.92s9.71,28.16,21.38,34.73,21,1.68,20.89-10.93S183.76,325.56,172.09,319Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.87,354.23h0c1.43.81,2.56-.07,2.54-2l-.1-9.62a6.13,6.13,0,0,0-2.62-4.87h0c-1.42-.8-2.56.08-2.54,2l.11,9.62A6.13,6.13,0,0,0,179.87,354.23Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.31,342.65l.1,9.62a3.19,3.19,0,0,1-.16,1.12,2.62,2.62,0,0,1-.56-.24,6.13,6.13,0,0,1-2.61-4.86l-.1-9.62a3.45,3.45,0,0,1,.15-1.12,2.88,2.88,0,0,1,.56.23A6.13,6.13,0,0,1,182.31,342.65Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.31,342.65l.1,9.62a3.19,3.19,0,0,1-.16,1.12,2.62,2.62,0,0,1-.56-.24,6.13,6.13,0,0,1-2.61-4.86l-.1-9.62a3.45,3.45,0,0,1,.15-1.12,2.88,2.88,0,0,1,.56.23A6.13,6.13,0,0,1,182.31,342.65Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,345.84h0c1.42.8,2.56-.07,2.54-2l-.11-9.62a6.14,6.14,0,0,0-2.61-4.87h0c-1.43-.8-2.56.08-2.54,2l.1,9.62A6.12,6.12,0,0,0,165,345.84Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.41,334.26l.11,9.62a3.73,3.73,0,0,1-.16,1.12,2.42,2.42,0,0,1-.56-.24,6.12,6.12,0,0,1-2.62-4.86l-.1-9.62a3.19,3.19,0,0,1,.16-1.12,2.55,2.55,0,0,1,.56.23A6.14,6.14,0,0,1,167.41,334.26Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.41,334.26l.11,9.62a3.73,3.73,0,0,1-.16,1.12,2.42,2.42,0,0,1-.56-.24,6.12,6.12,0,0,1-2.62-4.86l-.1-9.62a3.19,3.19,0,0,1,.16-1.12,2.55,2.55,0,0,1,.56.23A6.14,6.14,0,0,1,167.41,334.26Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.35,362.8c5.23-7.36,1.65-22.63-4.34-31.84,5.07,7,8.38,15.38,8.46,22.75.14,12.61-9.22,17.5-20.89,10.93a39.83,39.83,0,0,1-10.52-8.92C169.46,364.4,183.77,370.66,189.35,362.8Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.85,314.84c-.7,2.64,2.14.57,4.78,1.27s4.07,3.91,4.78,1.27a4.95,4.95,0,0,0-9.56-2.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.07,296.63c-1.6,2.22,1.79,1.3,4,2.9s2.41,5.1,4,2.89a4.94,4.94,0,1,0-8-5.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.01 266.62 248.63 247.9 241.51 243.9 209.9 262.61 217.01 266.62",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.01 266.62 248.63 247.9 241.51 243.9 209.9 262.61 217.01 266.62",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.51 243.9 241.56 247.98 213.45 264.61 209.9 262.61 241.51 243.9",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.51 243.9 241.56 247.98 245.12 249.98 248.63 247.9 241.51 243.9",
    style: {
      opacity: 0.2
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.78,335.47A6.39,6.39,0,0,0,27.46,329c-2.57-2.14-6-3-6.38-2.81s0,3.76,2.68,6.61A7.52,7.52,0,0,0,29.78,335.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3,343.62a6.41,6.41,0,0,0-5-4.67c-3.26-.74-6.76.06-7,.4S21,342.69,24.73,344A7.57,7.57,0,0,0,31.3,343.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.56,344.85a6.41,6.41,0,0,0,3.75-5.73c.16-3.33-.93-6.42-1.3-6.56s-3.33,2.48-4.18,5.89C34.91,342.17,37,344.05,37.56,344.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.17,373a26.09,26.09,0,0,0,.22-9,50,50,0,0,0-1.57-8.23,65.1,65.1,0,0,0-6.83-16,34.87,34.87,0,0,0-6.87-8.9c-.06-.05-.22.07-.17.13a52.28,52.28,0,0,1,5.64,8.5,60.36,60.36,0,0,1,4.05,8.17,63.54,63.54,0,0,1,3.94,15,87.46,87.46,0,0,1,.47,10.23A.56.56,0,0,0,41.17,373Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9,347.48a20.91,20.91,0,0,0,1.61-4.24,11.4,11.4,0,0,0,.43-4.3c0-.2-.18.06-.2.19a32.67,32.67,0,0,1-.91,3.76,14.52,14.52,0,0,1-1.76,3.71.92.92,0,0,0,.06,1A.48.48,0,0,0,36.9,347.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.57,347a16.65,16.65,0,0,0-5-3.85,19.59,19.59,0,0,0-2.62-1.24,11.52,11.52,0,0,0-3.34-.78c-.05,0-.32.1-.23.12a32.07,32.07,0,0,1,3.14,1.18,18.36,18.36,0,0,1,2.71,1.44A27.8,27.8,0,0,1,36,347.65C36.32,348,36.8,347.3,36.57,347Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.91,355.1A6.42,6.42,0,0,0,32,349.49c-3-1.4-6.62-1.35-6.9-1.06s1,3.63,4.32,5.69A7.56,7.56,0,0,0,35.91,355.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.35,359.52a16.62,16.62,0,0,0-4.09-4.81A18,18,0,0,0,34,353a11.15,11.15,0,0,0-3.1-1.46c-.05,0-.33,0-.25.07a31.1,31.1,0,0,1,2.83,1.81,17.92,17.92,0,0,1,2.34,2,27.18,27.18,0,0,1,3.9,4.68C39.91,360.38,40.52,359.85,40.35,359.52Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.22,320.07a7,7,0,0,1,1.23-7.33c2.33-2.78,5.87-4.39,6.28-4.23s.72,4-1.58,7.58A8.16,8.16,0,0,1,51.22,320.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.18,329.07a7,7,0,0,1,4.45-6c3.35-1.41,7.24-1.23,7.52-.91s-1.19,3.9-4.87,6A8.21,8.21,0,0,1,51.18,329.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.72,331.6a7,7,0,0,1-5.12-5.4c-.82-3.53-.25-7,.12-7.27s4.05,2,5.61,5.5C47,328.22,45.14,330.64,44.72,331.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.33,362.39a28.44,28.44,0,0,1-2-9.57,55.19,55.19,0,0,1,.08-9.09,71.29,71.29,0,0,1,4.19-18.45c1.4-3.75,3.05-7.7,5.61-10.83.06-.06.25,0,.21.11a55.75,55.75,0,0,0-4.37,10.17,65.08,65.08,0,0,0-2.74,9.51A68.5,68.5,0,0,0,46,351a95.46,95.46,0,0,0,1.48,11A.61.61,0,0,1,46.33,362.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.94,334.28a22.31,22.31,0,0,1-2.54-4.22,12.37,12.37,0,0,1-1.3-4.51c0-.22.2,0,.25.16a36.6,36.6,0,0,0,1.7,3.85,16.6,16.6,0,0,0,2.6,3.63,1,1,0,0,1,.15,1.12A.52.52,0,0,1,45.94,334.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2,333.73a18,18,0,0,1,4.61-5.08,21,21,0,0,1,2.56-1.84,12.54,12.54,0,0,1,3.42-1.47c.05,0,.36,0,.27.08a34.87,34.87,0,0,0-3.13,1.87,19,19,0,0,0-2.61,2.06,29.53,29.53,0,0,0-4.4,4.95C46.65,334.68,46,334.07,46.2,333.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.48,342.23a6.94,6.94,0,0,1,3.11-6.75c3-2.08,6.81-2.72,7.16-2.46s-.35,4.06-3.5,6.91A8.2,8.2,0,0,1,48.48,342.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.59,347.82A18,18,0,0,1,48,341.89a20.25,20.25,0,0,1,2.12-2.32,12.16,12.16,0,0,1,3-2.16c.05,0,.35,0,.28,0a30.55,30.55,0,0,0-2.67,2.48,18.55,18.55,0,0,0-2.13,2.55,30,30,0,0,0-3.26,5.76C45.23,348.65,44.47,348.2,44.59,347.82Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Banknotes--inject-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Money--inject-25"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "177.13 418.89 75.75 360.54 25.06 389.71 126.44 448.06 177.13 418.89",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.13 418.89 75.75 360.54 25.06 389.71 126.44 448.06 177.13 418.89",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4,389.72l96,55.27,45.35-26.1-96-55.28Zm2.67,0,42.68-24.57,93.38,53.75-42.69,24.57Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103,419.41c-6.91,0-14-1.59-19.46-4.73h0c-5.32-3.06-8.37-7.24-8.37-11.46,0-3.88,2.5-7.45,7-10.06,9.69-5.57,26.05-5.23,36.47.77C124,397,127,401.17,127,405.39c0,3.87-2.5,7.44-7,10.05S109.26,419.41,103,419.41ZM99.2,390.09c-6.11,0-12.07,1.27-16.55,3.86-4.25,2.44-6.59,5.73-6.59,9.27,0,3.89,2.89,7.78,7.92,10.67h0c10.17,5.86,26.13,6.2,35.56.77,4.25-2.44,6.58-5.73,6.58-9.27,0-3.89-2.88-7.78-7.91-10.68A39.1,39.1,0,0,0,99.2,390.09Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103,416.15a36.77,36.77,0,0,1-17.81-4.31c-4.28-2.46-6.73-5.6-6.73-8.62,0-2.66,1.92-5.22,5.39-7.22,4-2.29,9.43-3.54,15.37-3.54A36.78,36.78,0,0,1,117,396.77c4.28,2.46,6.73,5.6,6.73,8.62,0,2.65-1.92,5.22-5.4,7.22C114.39,414.89,108.93,416.15,103,416.15Z",
    style: {
      fill: "#B42F53"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M121.1,438.06,93.24,421.92l2.23.29a48.13,48.13,0,0,0,6,.38,42.32,42.32,0,0,0,19.39-5.09c4.93-2.83,9.9-7.91,9.9-12.86a12,12,0,0,0-1.12-5l-.6-1.29L159.57,416,156.22,418a1.44,1.44,0,0,0-.88,1.14,1.46,1.46,0,0,0,.88,1.15l3.35,1.92-27.8,15.9-2.89-1.66a5.43,5.43,0,0,0-4.89,0Z",
    style: {
      fill: "#B42F53",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.37,426.78a9.55,9.55,0,0,1-4.65-1.13,3.6,3.6,0,0,1-2.1-2.94,3.08,3.08,0,0,1,1.79-2.61,9.72,9.72,0,0,1,8.74.17,3.6,3.6,0,0,1,2.1,2.94,3.1,3.1,0,0,1-1.79,2.62A8.35,8.35,0,0,1,133.37,426.78Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.21,410.22,42.75,392.73l3.35-1.93c.57-.33.88-.73.88-1.14a1.44,1.44,0,0,0-.88-1.14l-3.35-1.94L70.5,370.82l2.89,1.67a5.51,5.51,0,0,0,4.88,0l2.89-1.67,27.86,16-2.26-.29a47.89,47.89,0,0,0-6-.38,42.88,42.88,0,0,0-19.63,4.95c-6.41,3.69-9.67,7.65-9.67,11.77a17.36,17.36,0,0,0,1.17,6.07Z",
    style: {
      fill: "#B42F53",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.57,390.21a9.48,9.48,0,0,1-4.65-1.14h0a3.57,3.57,0,0,1-2.1-2.93,3.11,3.11,0,0,1,1.79-2.62,9.69,9.69,0,0,1,8.74.18,3.6,3.6,0,0,1,2.1,2.94,3.08,3.08,0,0,1-1.79,2.61A8.35,8.35,0,0,1,69.57,390.21Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "177.13 418.89 177.13 431.18 126.44 460.35 126.44 448.06 177.13 418.89",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "177.13 418.89 177.13 431.18 126.44 460.35 126.44 448.06 177.13 418.89",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "126.44 450.8 142.44 441.93 126.44 451.55 126.44 450.8"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "177.13 424.72 171.79 428.11 177.13 425.35 177.13 424.72"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "177.13 427.65 150.45 443.46 177.13 428.56 177.13 427.65"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "126.44 453.73 153.12 438.86 126.44 454.69 126.44 453.73"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "126.44 460.35 25.06 402 25.06 389.71 126.44 448.06 126.44 460.35",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "126.44 460.35 25.06 402 25.06 389.71 126.44 448.06 126.44 460.35"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "126.44 450.8 121.1 448.06 126.44 451.55 126.44 450.8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "126.44 453.73 99.61 438.78 126.44 454.69 126.44 453.73"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "25.06 395.5 43.74 406.61 25.06 396.22 25.06 395.5"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "25.06 398.58 35.73 405.07 25.06 399.27 25.06 398.58"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "135.27 392.76 82.82 422.96 66.81 413.75 119.26 383.55 135.27 392.76",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.81 413.75 66.81 427.11 82.82 436.32 82.82 422.96 66.81 413.75",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.82 436.32 83.75 435.78 82.82 435.24 82.82 436.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.27 392.76 135.27 394.8 133.5 393.78 135.27 392.76",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "83.75 435.78 83.75 423.5 82.82 422.96 82.82 435.24 83.75 435.78"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      opacity: 0.2
    }
  }, _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "83.75 423.5 134.44 394.32 133.5 393.78 82.82 422.96 83.75 423.5"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "133.55 391.77 81.08 421.96 79.75 421.19 132.21 391 133.55 391.77",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.33 385.32 69.87 415.51 68.54 414.74 121 384.55 122.33 385.32",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.08 421.96 81.08 435.33 79.75 434.56 79.75 421.19 81.08 421.96",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.87 415.51 69.87 428.87 68.54 428.11 68.54 414.74 69.87 415.51",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--money--inject-25"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "172.79 401.76 71.42 343.41 20.73 372.58 122.11 430.93 172.79 401.76",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.79 401.76 71.42 343.41 20.73 372.58 122.11 430.93 172.79 401.76",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.06,372.58l96.05,55.28,45.35-26.1-96-55.28Zm2.67,0L71.42,348l93.37,53.75-42.68,24.57Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.66,402.28c-6.91,0-14-1.59-19.47-4.74h0c-5.32-3.06-8.37-7.23-8.37-11.46,0-3.87,2.5-7.44,7-10.05,9.69-5.58,26.05-5.23,36.47.77,5.32,3.06,8.37,7.24,8.37,11.46,0,3.87-2.5,7.44-7,10.05S104.93,402.28,98.66,402.28ZM94.87,373c-6.11,0-12.07,1.27-16.56,3.85-4.24,2.45-6.58,5.74-6.58,9.27,0,3.89,2.89,7.79,7.92,10.68h0c10.17,5.86,26.12,6.2,35.56.77,4.24-2.44,6.58-5.74,6.58-9.27,0-3.89-2.88-7.78-7.91-10.68A39.1,39.1,0,0,0,94.87,373Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.65,399a36.74,36.74,0,0,1-17.81-4.31c-4.28-2.46-6.73-5.61-6.73-8.63,0-2.65,1.91-5.21,5.39-7.21,4-2.29,9.43-3.55,15.37-3.55a36.78,36.78,0,0,1,17.82,4.31c4.27,2.47,6.73,5.61,6.73,8.63,0,2.65-1.92,5.22-5.4,7.22C110.05,397.76,104.6,399,98.65,399Z",
    style: {
      fill: "#B42F53"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M116.77,420.93,88.9,404.79l2.24.29a48,48,0,0,0,6,.38,42.44,42.44,0,0,0,19.38-5.09c4.94-2.84,9.91-7.91,9.91-12.86a11.85,11.85,0,0,0-1.13-5l-.59-1.3,30.51,17.67-3.34,1.93a1.18,1.18,0,0,0,0,2.28l3.35,1.93-27.8,15.9-2.89-1.67a5.46,5.46,0,0,0-4.89,0Z",
    style: {
      fill: "#B42F53",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129,409.65a9.59,9.59,0,0,1-4.66-1.13,3.62,3.62,0,0,1-2.1-2.94,3.09,3.09,0,0,1,1.8-2.61,9.69,9.69,0,0,1,8.74.17,3.62,3.62,0,0,1,2.1,2.94,3.12,3.12,0,0,1-1.79,2.62A8.49,8.49,0,0,1,129,409.65Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.88,393.09,38.42,375.6l3.35-1.93a1.45,1.45,0,0,0,.87-1.15,1.43,1.43,0,0,0-.87-1.13l-3.35-1.94,27.74-15.76,2.9,1.67a5.51,5.51,0,0,0,4.88,0l2.89-1.67,27.86,16-2.26-.29a47.93,47.93,0,0,0-6-.38A42.86,42.86,0,0,0,76.79,374c-6.42,3.7-9.67,7.66-9.67,11.78a17.41,17.41,0,0,0,1.17,6.07Z",
    style: {
      fill: "#B42F53",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.24,373.07a9.55,9.55,0,0,1-4.65-1.13h0a3.6,3.6,0,0,1-2.1-2.94,3.08,3.08,0,0,1,1.79-2.61,9.69,9.69,0,0,1,8.74.18,3.58,3.58,0,0,1,2.1,2.94,3.09,3.09,0,0,1-1.79,2.61A8.35,8.35,0,0,1,65.24,373.07Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "172.79 401.76 172.79 414.04 122.11 443.22 122.11 430.93 172.79 401.76",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "172.79 401.76 172.79 414.04 122.11 443.22 122.11 430.93 172.79 401.76",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "122.11 433.67 138.11 424.79 122.11 434.42 122.11 433.67"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "172.79 407.59 167.46 410.97 172.79 408.21 172.79 407.59"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "172.79 410.52 146.12 426.33 172.79 411.42 172.79 410.52"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "122.11 436.6 148.78 421.72 122.11 437.56 122.11 436.6"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "122.11 443.22 20.73 384.87 20.73 372.58 122.11 430.93 122.11 443.22",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "122.11 443.22 20.73 384.87 20.73 372.58 122.11 430.93 122.11 443.22"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "122.11 433.67 116.77 430.93 122.11 434.42 122.11 433.67"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "122.11 436.6 95.28 421.65 122.11 437.56 122.11 436.6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "20.73 378.37 39.4 389.48 20.73 379.09 20.73 378.37"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "20.73 381.45 31.4 387.94 20.73 382.14 20.73 381.45"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "130.94 375.63 78.48 405.82 62.48 396.62 114.93 366.41 130.94 375.63",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.48 396.62 62.48 409.98 78.48 419.19 78.48 405.82 62.48 396.62",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.48 419.19 79.42 418.65 78.48 418.11 78.48 419.19",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.94 375.63 130.94 377.67 129.17 376.65 130.94 375.63",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "79.42 418.64 79.42 406.37 78.48 405.82 78.48 418.11 79.42 418.64"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      opacity: 0.2
    }
  }, _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "79.42 406.37 130.1 377.19 129.17 376.65 78.48 405.82 79.42 406.37"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "129.21 374.63 76.75 404.83 75.42 404.06 127.88 373.87 129.21 374.63",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118 368.19 65.54 398.38 64.21 397.61 116.67 367.42 118 368.19",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.75 404.83 76.75 418.19 75.42 417.43 75.42 404.06 76.75 404.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.54 398.38 65.54 411.74 64.21 410.97 64.21 397.61 65.54 398.38",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coin--inject-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.93,206.24,237,204l-4.74-2.74h0a7.59,7.59,0,0,0-1.79-.74c-.22-.06-.44-.11-.67-.15a8.8,8.8,0,0,0-3.34.09,9.83,9.83,0,0,0-1.2.33c-.41.13-.82.29-1.24.47a16.18,16.18,0,0,0-1.6.82,17.14,17.14,0,0,0-1.67,1.1c-.41.3-.82.62-1.22,1-5.89,5-10.52,13.83-11.7,22.35-.08.58-.14,1.16-.19,1.73-.07.83-.1,1.64-.1,2.45,0,.66,0,1.3.08,1.92s.11,1.05.18,1.55.17,1,.28,1.44h0a14.15,14.15,0,0,0,1.38,3.65c.13.23.26.45.4.66a8.66,8.66,0,0,0,2.1,2.27c.25.19.51.35.77.51h0l4.49,2.59,1-2.07.8-.21a14.27,14.27,0,0,0,3.12-1.39,20.64,20.64,0,0,0,1.83-1.21,24.89,24.89,0,0,0,2.25-1.92A38.17,38.17,0,0,0,236.43,219c.21-1.1.36-2.19.46-3.27.08-.91.12-1.8.12-2.69a22.78,22.78,0,0,0-.31-3.81A16.61,16.61,0,0,0,235.93,206.24Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.93,221.43l9.62,5.56,1.27-3.66-9.63-5.57A36.94,36.94,0,0,0,208.93,221.43Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.27,201.24h0a7.59,7.59,0,0,0-1.79-.74c-.22-.06-.44-.11-.67-.15a8.8,8.8,0,0,0-3.34.09l-.44.11,9.91,5.72v0L237,204Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.24,215.3l1.26-1.53-14.43-8.3c-.46.45-.91.93-1.34,1.42Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.66,211l12.5,7.22,1.38-3.6-11.64-6.72A34.07,34.07,0,0,0,213.66,211Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.27,201.24h0a7.59,7.59,0,0,0-1.79-.74c-.22-.06-.44-.11-.67-.15a8.8,8.8,0,0,0-3.34.09,9.83,9.83,0,0,0-1.2.33c-.41.13-.82.29-1.24.47a16.18,16.18,0,0,0-1.6.82,17.14,17.14,0,0,0-1.67,1.1c-.41.3-.82.62-1.22,1-5.48,4.63-9.88,12.63-11.4,20.59l20.08,11.6A39.27,39.27,0,0,0,236.43,219c.21-1.1.36-2.19.46-3.27.08-.91.12-1.8.12-2.69a22.78,22.78,0,0,0-.31-3.81,16.61,16.61,0,0,0-.77-2.94L237,204Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.23,245.25l1-2.07.8-.21a14.27,14.27,0,0,0,3.12-1.39,20.64,20.64,0,0,0,1.83-1.21,24.89,24.89,0,0,0,2.25-1.92c.69-.67,1.35-1.38,2-2.14l-20.08-11.6c-.12.59-.21,1.17-.3,1.76s-.14,1.16-.19,1.73c-.07.83-.1,1.64-.1,2.45,0,.66,0,1.3.08,1.92s.11,1.05.18,1.55.17,1,.28,1.44h0a14.15,14.15,0,0,0,1.38,3.65c.13.23.26.45.4.66a8.66,8.66,0,0,0,2.1,2.27c.25.19.51.35.77.51h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.47,239.22c.13.23.26.45.4.66a8.66,8.66,0,0,0,2.1,2.27c.25.19.51.35.77.51h0l4.49,2.59,1-2.07h0l.07-.85-10-5.76A13.11,13.11,0,0,0,209.47,239.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.77,212.11a16,16,0,0,0-1.11-3.78,9.75,9.75,0,0,0-2.91-3.85,7.49,7.49,0,0,0-2.62-1.3l-.66-.14a8.8,8.8,0,0,0-3.34.09,11.25,11.25,0,0,0-1.2.32c-.41.14-.83.3-1.25.48a15.19,15.19,0,0,0-1.6.82c-.56.33-1.11.69-1.66,1.09s-.82.62-1.22,1c-5.89,5-10.52,13.84-11.7,22.36-.08.58-.14,1.16-.19,1.73-.07.82-.1,1.64-.1,2.45,0,.66,0,1.3.08,1.92s.1,1.05.18,1.55.17,1,.28,1.44h0a14.14,14.14,0,0,0,1.37,3.65c.13.23.26.45.4.66a8.83,8.83,0,0,0,2.1,2.27,7.48,7.48,0,0,0,4.15,1.49,10.08,10.08,0,0,0,3.32-.43,15.05,15.05,0,0,0,3.12-1.39,18.77,18.77,0,0,0,1.83-1.22,21.1,21.1,0,0,0,2.26-1.92,38.2,38.2,0,0,0,10.2-19.49c.21-1.1.37-2.19.47-3.27.08-.91.12-1.8.12-2.69A23.75,23.75,0,0,0,241.77,212.11Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.79,227.39c-.11.59-.21,1.18-.29,1.77s-.14,1.16-.19,1.73c-.07.82-.1,1.64-.1,2.45,0,.66,0,1.3.08,1.92s.1,1.05.18,1.55.17,1,.28,1.44h0a14.14,14.14,0,0,0,1.37,3.65c.13.23.26.45.4.66a8.83,8.83,0,0,0,2.1,2.27,7.48,7.48,0,0,0,4.15,1.49,10.08,10.08,0,0,0,3.32-.43,15.05,15.05,0,0,0,3.12-1.39,18.25,18.25,0,0,0,1.63-1.07Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,239.29a14.22,14.22,0,0,0,1.1,2.62c.13.23.26.45.4.66a8.83,8.83,0,0,0,2.1,2.27,7.47,7.47,0,0,0,3.36,1.4Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.84,220.46q-.72,1.8-1.26,3.66l17.48,17.48.24-.23a29.68,29.68,0,0,0,2.14-2.31Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.55,210.57a36.11,36.11,0,0,0-2.24,3.1l19.24,19.24a40,40,0,0,0,1.71-3.63Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.73,208.15q-.69.69-1.35,1.44L239.77,228c.26-.69.5-1.38.71-2.08Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,214.59h0c0-.35,0-.7-.08-1l0-.34c0-.12,0-.24-.05-.35s-.07-.5-.11-.75a16,16,0,0,0-1.11-3.78,9.75,9.75,0,0,0-2.91-3.85,7.49,7.49,0,0,0-2.62-1.3l-.66-.14a8.8,8.8,0,0,0-3.34.09l-.44.11Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.28,218.21c0,7.86-4.59,16.94-10.39,20.8-.24.16-.49.32-.74.46C221,243,216,239.26,216,231.06s5-17.72,11.13-21.27l.74-.4C233.69,206.55,238.28,210.34,238.28,218.21Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.28,218.21c0,7.86-4.59,16.94-10.39,20.8-.24.16-.49.32-.74.46C221,243,216,239.26,216,231.06s5-17.72,11.13-21.27l.74-.4C233.69,206.55,238.28,210.34,238.28,218.21Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.78,218.49c0,.25,0,.51,0,.77-.28,7.32-4.55,15.54-9.91,19.11l-.15.09a6.53,6.53,0,0,1-.56.35A9.14,9.14,0,0,1,223.8,240a5.63,5.63,0,0,1-5.87-3,11.64,11.64,0,0,1-1.38-5.08c0-.38,0-.78,0-1.19s0-.75,0-1.13c.05-.8.14-1.61.27-2.42a26.87,26.87,0,0,1,7.81-14.9,14,14,0,0,1,1.69-1.34c.28-.19.56-.37.84-.53s.48-.26.71-.38l.2-.09a7.14,7.14,0,0,1,4.4-.7c2.24.43,4,2.21,4.79,5.06A14.93,14.93,0,0,1,237.78,218.49Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.78,218.49c0,.25,0,.51,0,.77-.28,7.32-4.55,15.54-9.91,19.11l-.15.09a6.53,6.53,0,0,1-.56.35A9.14,9.14,0,0,1,223.8,240a5.63,5.63,0,0,1-5.87-3,11.64,11.64,0,0,1-1.38-5.08c0-.38,0-.78,0-1.19s0-.75,0-1.13c.05-.8.14-1.61.27-2.42a26.87,26.87,0,0,1,7.81-14.9,14,14,0,0,1,1.69-1.34c.28-.19.56-.37.84-.53s.48-.26.71-.38l.2-.09a7.14,7.14,0,0,1,4.4-.7c2.24.43,4,2.21,4.79,5.06A14.93,14.93,0,0,1,237.78,218.49Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,218.23c0-.26,0-.51,0-.76a14.86,14.86,0,0,0-.54-4.15,7.8,7.8,0,0,0-2.29-3.84,3.76,3.76,0,0,0-.73-.2,7.14,7.14,0,0,0-4.4.7l-.2.09c-.23.12-.47.24-.71.38s-.56.34-.84.53a14,14,0,0,0-1.69,1.34,26.87,26.87,0,0,0-7.81,14.9c-.13.81-.22,1.62-.27,2.42,0,.38,0,.76,0,1.13s0,.81,0,1.19a11.64,11.64,0,0,0,1.38,5.08,6.67,6.67,0,0,0,1.4,1.72A5.79,5.79,0,0,0,222,239a9.25,9.25,0,0,0,3.34-1.21l.57-.35.14-.1C231.45,233.78,235.72,225.56,236,218.23Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,218.23c0-.26,0-.51,0-.76a14.86,14.86,0,0,0-.54-4.15,7.8,7.8,0,0,0-2.29-3.84,3.76,3.76,0,0,0-.73-.2,7.14,7.14,0,0,0-4.4.7l-.2.09c-.23.12-.47.24-.71.38s-.56.34-.84.53a14,14,0,0,0-1.69,1.34,26.87,26.87,0,0,0-7.81,14.9c-.13.81-.22,1.62-.27,2.42,0,.38,0,.76,0,1.13s0,.81,0,1.19a11.64,11.64,0,0,0,1.38,5.08,6.67,6.67,0,0,0,1.4,1.72A5.79,5.79,0,0,0,222,239a9.25,9.25,0,0,0,3.34-1.21l.57-.35.14-.1C231.45,233.78,235.72,225.56,236,218.23Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.47,203c-6.43-.73-11.66,4.6-15.15,9.38-5,7.43-8.23,16.84-6.49,25.84v0a11.28,11.28,0,0,0,3.79,6.6,11.3,11.3,0,0,1-4-6.59v0c-1.61-7.36.41-15.1,3.78-21.69C220.06,210.06,226.17,202.15,234.47,203Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--money-sign--inject-25"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "229.6 220.47 227.47 219.23 231.6 215.71 233.74 216.94 229.6 220.47",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.92,221.28c-1.09-.78-3-.19-4.6.32l-1,.34a1.9,1.9,0,0,0-.16.74c0,1.24,1.06.91,3.35.15a16.53,16.53,0,0,1,2.37-.62c.07.63.51,1.21,2.22.3Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.63 237.47 223.49 236.24 223.49 233.72 225.63 234.95 225.63 237.47",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.24,227.9a3.2,3.2,0,0,1-1.86,2.55c-1.78,1-2.48.19-2.63-.64l-.37-.21a4.15,4.15,0,0,0,.86-.39,3.82,3.82,0,0,0,1.74-1.84C228.3,226.94,229.24,226.77,229.24,227.9Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.3,234.08a1.37,1.37,0,0,0-.78-.19c0-.13-.08-.26-.11-.4l-2.13-1.23a2.63,2.63,0,0,0,1.19,1.82h0l2.13,1.23A1,1,0,0,0,221.3,234.08Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.46,222.83c-2.29.76-3.35,1.09-3.35-.15a1.9,1.9,0,0,1,.16-.74c-1.56.48-2.29.54-2.29-.49,0-.76.51-1.7,1.93-2.52s2.35-.67,2.56.3l4.13-3.52-.06-.16a2.47,2.47,0,0,0,.74-.28l-1.71-1-.16-.1h0a3,3,0,0,0-1.62-.27,7.33,7.33,0,0,0-2.13.59v0l2.13-1.25L226.63,212h0l-1.45.84-2,1.14h0v2.52c-2.89,2.11-4.7,4.86-4.7,7.84a2.77,2.77,0,0,0,.95,2.51h0l0,0,.16.09,1.78,1a1.3,1.3,0,0,0-.1-.8,10.33,10.33,0,0,0,1.67-.37c2.17-.65,4.1-1.68,4.1-.08a2.08,2.08,0,0,1-.13.71c1.32-.43,2.26-.6,2.26.53a3.2,3.2,0,0,1-1.86,2.55c-1.78,1-2.48.19-2.63-.64h0l-.37-.21-1.76-1-4.34,3.68,2.13,1.23a3.59,3.59,0,0,0,.33.91,7,7,0,0,0,2.75-.68v1l3.38-.47v-2.52c2.92-2.15,4.94-5.06,4.94-8.09a4.24,4.24,0,0,0-.24-1.52A12,12,0,0,0,228.46,222.83Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.46,222.83c-2.29.76-3.35,1.09-3.35-.15a1.9,1.9,0,0,1,.16-.74c-1.56.48-2.29.54-2.29-.49,0-.76.51-1.7,1.93-2.52s2.35-.67,2.56.3l4.13-3.52-.06-.16a2.47,2.47,0,0,0,.74-.28l-1.71-1-.16-.1h0a3,3,0,0,0-1.62-.27,7.33,7.33,0,0,0-2.13.59v0l2.13-1.25L226.63,212h0l-1.45.84-2,1.14h0v2.52c-2.89,2.11-4.7,4.86-4.7,7.84a2.77,2.77,0,0,0,.95,2.51h0l0,0,.16.09,1.78,1a1.3,1.3,0,0,0-.1-.8,10.33,10.33,0,0,0,1.67-.37c2.17-.65,4.1-1.68,4.1-.08a2.08,2.08,0,0,1-.13.71c1.32-.43,2.26-.6,2.26.53a3.2,3.2,0,0,1-1.86,2.55c-1.78,1-2.48.19-2.63-.64h0l-.37-.21-1.76-1-4.34,3.68,2.13,1.23a3.59,3.59,0,0,0,.33.91,7,7,0,0,0,2.75-.68v1l3.38-.47v-2.52c2.92-2.15,4.94-5.06,4.94-8.09a4.24,4.24,0,0,0-.24-1.52A12,12,0,0,0,228.46,222.83Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M223.22,216.45a13.39,13.39,0,0,0-3.86,4.65,8,8,0,0,0-.73,2.92,5.1,5.1,0,0,0,.09,1.51,2.09,2.09,0,0,0,.75,1.27,2.05,2.05,0,0,1-.87-1.24,4.77,4.77,0,0,1-.17-1.55,7.65,7.65,0,0,1,.69-3,10.77,10.77,0,0,1,1.74-2.57A13.12,13.12,0,0,1,223.22,216.45Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M231.57,222.14a12,12,0,0,0-3.11.69c-2.29.76-3.35,1.09-3.35-.15a1.9,1.9,0,0,1,.16-.74,4,4,0,0,1,1.77-1.78c1.51-.87,2.35-.67,2.56.3l4.14-3.52a2.44,2.44,0,0,0-2.4-1.84,6.4,6.4,0,0,0-2.58.6v-2.52l-2.13,1.25-1.27.73v2.52c-2.9,2.11-4.71,4.86-4.71,7.84a4.25,4.25,0,0,0,.26,1.62c.64,1.6,2.39,1.38,4.23.84.65-.2,1.28-.43,1.84-.61,1.32-.43,2.26-.6,2.26.53a3.2,3.2,0,0,1-1.86,2.55c-1.78,1-2.48.19-2.63-.64l-4.34,3.68a3.59,3.59,0,0,0,.33.91,2.45,2.45,0,0,0,2.75,1.19,8,8,0,0,0,2.14-.64v2.52l3.37-1.95V233c2.93-2.16,4.95-5.06,4.95-8.1C234,222.71,232.91,222.11,231.57,222.14Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.57,222.14a12,12,0,0,0-3.11.69c-2.29.76-3.35,1.09-3.35-.15a1.9,1.9,0,0,1,.16-.74,4,4,0,0,1,1.77-1.78c1.51-.87,2.35-.67,2.56.3l4.14-3.52a2.44,2.44,0,0,0-2.4-1.84,6.4,6.4,0,0,0-2.58.6v-2.52l-2.13,1.25-1.27.73v2.52c-2.9,2.11-4.71,4.86-4.71,7.84a4.25,4.25,0,0,0,.26,1.62c.64,1.6,2.39,1.38,4.23.84.65-.2,1.28-.43,1.84-.61,1.32-.43,2.26-.6,2.26.53a3.2,3.2,0,0,1-1.86,2.55c-1.78,1-2.48.19-2.63-.64l-4.34,3.68a3.59,3.59,0,0,0,.33.91,2.45,2.45,0,0,0,2.75,1.19,8,8,0,0,0,2.14-.64v2.52l3.37-1.95V233c2.93-2.16,4.95-5.06,4.95-8.1C234,222.71,232.91,222.11,231.57,222.14Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M224.45,230.07l-2.66,2.25,3,3c.29-.1.58-.21.88-.34v1.21l.82.83,2.55-1.47v-.9Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.57,222.14a12,12,0,0,0-3.11.69l-.74.24,5.34,5.34a7.92,7.92,0,0,0,.89-3.52,5.21,5.21,0,0,0-.1-1l-1.69-1.69A2.88,2.88,0,0,0,231.57,222.14Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.79,221.15a5.14,5.14,0,0,1,1.25-1c1.51-.87,2.35-.67,2.56.3l.46-.38-4.7-4.71v2.31a15.13,15.13,0,0,0-1.65,1.39Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.89,215.31a9.54,9.54,0,0,0-1.13.39v-1.52l-.63-.63-1.5.88-.27.15,4.67,4.67,1.51-1.29Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.75,228.37l-2-2a3.43,3.43,0,0,0,.2.81A1.89,1.89,0,0,0,222.75,228.37Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.35 217.68 223.22 216.45 223.22 213.93 225.35 215.16 225.35 217.68",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.35 217.68 223.22 216.45 223.22 213.93 225.35 215.16 225.35 217.68",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,233l.33-.27.38-.3.47-.42c.17-.16.35-.32.53-.51l.29-.29.28-.31c.1-.11.2-.22.29-.34s.19-.22.28-.34.37-.49.53-.74a9.09,9.09,0,0,0,.48-.78c.14-.27.28-.53.39-.8a6.64,6.64,0,0,0,.3-.76l.11-.37.05-.18,0-.17a5.43,5.43,0,0,0,.11-.62,3.13,3.13,0,0,0,.06-.48l0-.42v.43c0,.13,0,.29,0,.48s-.06.39-.1.62l0,.18-.05.17-.1.38c-.09.24-.17.51-.3.78a7.24,7.24,0,0,1-.38.8c-.15.26-.3.53-.48.79s-.36.5-.54.74-.19.23-.29.35l-.29.33-.29.31-.29.28c-.19.19-.38.35-.55.51s-.34.28-.48.4l-.39.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.35 215.16 228.76 213.19 228.76 215.7 228.53 213.59 225.35 215.16",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.63 234.95 225.81 237.14 229 235.52 225.63 237.47 225.63 234.95",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "238.5 208.47 238.78 204.72 239.07 208.47 242.81 208.76 239.07 209.04 238.78 212.79 238.5 209.04 234.75 208.76 238.5 208.47",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.8 205.73 234.94 203.91 235.08 205.73 236.9 205.87 235.08 206.01 234.94 207.82 234.8 206.01 232.99 205.87 234.8 205.73",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--coins--inject-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.29,374.83c-2.15-3.63-5.72-7-10.74-9.93-17.55-10.14-46-10.14-63.58,0-5,2.89-8.58,6.3-10.73,9.93h-2.43V384h0c.32,6.39,4.69,12.72,13.13,17.59,17.56,10.14,46,10.14,63.58,0,8.45-4.87,12.85-11.2,13.17-17.59h0v-9.18Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.29,374.83c-2.15-3.63-5.72-7-10.74-9.93-17.55-10.14-46-10.14-63.58,0-5,2.89-8.58,6.3-10.73,9.93h-2.43V384h0c.32,6.39,4.69,12.72,13.13,17.59,17.56,10.14,46,10.14,63.58,0,8.45-4.87,12.85-11.2,13.17-17.59h0v-9.18Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.77,357.3c-11.51,0-23,2.53-31.8,7.6-5,2.89-8.58,6.3-10.73,9.93h-2.43V384h0c.32,6.39,4.69,12.72,13.13,17.59,8.78,5.07,20.29,7.61,31.8,7.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.21,361.51A48.56,48.56,0,0,0,392,364.9c-5,2.89-8.58,6.3-10.73,9.93h-2.43V384h0c.32,6.39,4.69,12.72,13.13,17.59a48.56,48.56,0,0,0,7.24,3.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.32,361.51a48,48,0,0,1,7.23,3.39c5,2.89,8.59,6.3,10.74,9.93h2.43V384h0c-.32,6.39-4.73,12.72-13.17,17.59a48,48,0,0,1-7.23,3.39Z",
    style: {
      fill: "#B42F53",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,356.48c-17.55,10.14-17.55,26.57,0,36.71,15.37,8.87,39.08,10,56.53,3.32h0l.7-.27a49,49,0,0,0,6.35-3.05c14.64-8.46,17.08-21.29,7.3-31.2h0a33.92,33.92,0,0,0-7.29-5.51C438,346.34,409.53,346.34,392,356.48Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,356.48c-17.55,10.14-17.55,26.57,0,36.71,15.37,8.87,39.08,10,56.53,3.32h0l.7-.27a49,49,0,0,0,6.35-3.05c14.64-8.46,17.08-21.29,7.3-31.2h0a33.92,33.92,0,0,0-7.29-5.51C438,346.34,409.53,346.34,392,356.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.85,362c.18.22,6.33,6.7,4.7,16-1.56,8.92-14.05,16.43-18.35,18.23a49,49,0,0,0,6.35-3.05C470.19,384.73,472.63,371.9,462.85,362Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.68,387.67c-.19-.21-6.33-6.69-4.7-16,1.55-8.92,14-16.43,18.35-18.23a48.42,48.42,0,0,0-6.36,3.05C377.33,364.93,374.9,377.76,384.68,387.67Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 423.78,
    cy: 374.8,
    rx: 41.79,
    ry: 24.13,
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 423.78,
    cy: 374.8,
    rx: 41.79,
    ry: 24.13,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.67,382c3.36-6.21,2.27-13.05-3.28-18.86a28.75,28.75,0,0,0-3.54-3.1,37.35,37.35,0,0,0-3.38-2.23c-.67-.39-1.35-.76-2.06-1.11,1.74,2.86,1.1,5.92-8.74,6.49-19.27,1.13,5.14,19.54,5.14,19.54S460.23,376.73,463.67,382Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.69,376.91c2.89-.32,4.32-3.3,3.19-6.64s-4.37-5.79-7.26-5.47-4.33,3.3-3.2,6.64S458.79,377.24,461.69,376.91Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.22,392.25c-1-7.15-32.22-26.95-32.22-26.95s-6.93-2.78-4.63-7.63a35.61,35.61,0,0,0-3.34,2.16c-.73.52-1.4,1.06-2,1.61-9.31,8.06-9.32,18.65,0,26.72.63.54,1.31,1.08,2,1.61a34.5,34.5,0,0,0,3.1,2c1.06.62,2.17,1.2,3.31,1.74.91.43,1.86.84,2.82,1.21s1.93.73,2.93,1.06a60.5,60.5,0,0,0,9.33,2.24l2.09.31a72.47,72.47,0,0,0,9.33.58,70.74,70.74,0,0,0,11.41-.94S430.32,397,431.22,392.25Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.77,392.25c-.95-7.15-32.21-26.95-32.21-26.95s-6.94-2.78-4.63-7.63a35.8,35.8,0,0,0-3.35,2.16c-.72.52-1.4,1.06-2,1.61-9.31,8.06-9.32,18.65,0,26.72.63.54,1.31,1.08,2,1.61a34.5,34.5,0,0,0,3.1,2c1.06.62,2.17,1.2,3.31,1.74.92.43,1.86.84,2.82,1.21s1.93.73,2.93,1.06a60.78,60.78,0,0,0,9.33,2.24l2.1.31a72.36,72.36,0,0,0,9.33.58,70.93,70.93,0,0,0,11.41-.94S429.88,397,430.77,392.25Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.75,362.09c-11.66,6.73-12.14,17.47-1.42,24.53.45.3.93.6,1.42.89,12.16,7,31.87,7,44,0s12.16-18.4,0-25.42c-.49-.29-1-.57-1.52-.83C432,355.08,413.41,355.35,401.75,362.09Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.75,362.09c-11.66,6.73-12.14,17.47-1.42,24.53.45.3.93.6,1.42.89,12.16,7,31.87,7,44,0s12.16-18.4,0-25.42c-.49-.29-1-.57-1.52-.83C432,355.08,413.41,355.35,401.75,362.09Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 423.78,
    cy: 374.8,
    rx: 29.76,
    ry: 17.18,
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 423.78,
    cy: 374.8,
    rx: 29.76,
    ry: 17.18,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.74,367.44c11.62-6.71,30.46-6.71,42.08,0,4.76,2.74,7.56,6.18,8.43,9.75-.87,3.57-3.67,7-8.43,9.76-11.62,6.71-30.46,6.71-42.08,0-4.75-2.75-7.56-6.19-8.43-9.76C395.18,373.62,398,370.18,402.74,367.44Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.74,367.44c11.62-6.71,30.46-6.71,42.08,0,4.76,2.74,7.56,6.18,8.43,9.75-.87,3.57-3.67,7-8.43,9.76-11.62,6.71-30.46,6.71-42.08,0-4.75-2.75-7.56-6.19-8.43-9.76C395.18,373.62,398,370.18,402.74,367.44Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.52,380c0-.58,0-2.94,0-3.55,0-1.46-1-2.87-3.17-4.14l-.08,0c-4-2.3-8.12-2-11.8-1.08h0c-1.57.39-3.05.9-4.41,1.37A42.33,42.33,0,0,1,418.3,374h0a8.28,8.28,0,0,1-2.25.22,4.64,4.64,0,0,1-1.86-.5l.15-.1c.14-.1.3-.19.46-.29a12.08,12.08,0,0,1,1.25-.62,8.65,8.65,0,0,1,6.62-.15l3.81-3.85v-3.53a18.15,18.15,0,0,0-10.43-.38,21.44,21.44,0,0,0-3.32,1.15l-3.81-2.2-4.56,2.63v3.53l1.56.9a3.83,3.83,0,0,0-.67,2.06c0,.59,0,2.93,0,3.53,0,1.45,1,2.86,3.24,4.13a13.41,13.41,0,0,0,6.29,1.81h0c.42,0,.84,0,1.26,0a24.66,24.66,0,0,0,6.75-1.46l1.32-.45-3.84,3.85v3.53a18.67,18.67,0,0,0,14.71-.63l3.77,2.17,4.55-2.63v-3.53l-1.56-.9A4.16,4.16,0,0,0,442.52,380Zm-9.6-.3a10.47,10.47,0,0,1-1.06.53,9.81,9.81,0,0,1-7.45.11c3.57-1.26,6.55-2.36,9.09-1C433.32,379.42,433.13,379.55,432.92,379.67Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.47,371.15h0c-1.57.39-3.05.9-4.41,1.37A42.33,42.33,0,0,1,418.3,374h0a8.28,8.28,0,0,1-2.25.22,4.84,4.84,0,0,1-2.17-.65c-1.46-.85-1.67-2.08.46-3.48.14-.1.3-.19.46-.29a10.36,10.36,0,0,1,1.25-.62,8.65,8.65,0,0,1,6.62-.15l3.81-3.85a18.15,18.15,0,0,0-10.43-.38,21.44,21.44,0,0,0-3.32,1.15l-3.81-2.2-4.56,2.63,3.78,2.18,0,0c-3.83,2.91-3.91,5.93.4,8.42a13.41,13.41,0,0,0,6.29,1.81h0q.63,0,1.26,0a24.66,24.66,0,0,0,6.75-1.46c4.37-1.46,7.91-3.18,10.86-1.48,2,1.14,1.42,2.57-.74,3.82a10.47,10.47,0,0,1-1.06.53,9.78,9.78,0,0,1-7.58.05l-4,4a18.71,18.71,0,0,0,14.71-.64l3.77,2.18,4.55-2.63L439.55,381c3.78-2.93,4.22-6.12-.2-8.71l-.08,0C435.28,369.93,431.15,370.23,427.47,371.15Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.47,371.15h0c-1.57.39-3.05.9-4.41,1.37A42.33,42.33,0,0,1,418.3,374h0a8.28,8.28,0,0,1-2.25.22,4.84,4.84,0,0,1-2.17-.65c-1.46-.85-1.67-2.08.46-3.48.14-.1.3-.19.46-.29a10.36,10.36,0,0,1,1.25-.62,8.65,8.65,0,0,1,6.62-.15l3.81-3.85a18.15,18.15,0,0,0-10.43-.38,21.44,21.44,0,0,0-3.32,1.15l-3.81-2.2-4.56,2.63,3.78,2.18,0,0c-3.83,2.91-3.91,5.93.4,8.42a13.41,13.41,0,0,0,6.29,1.81h0q.63,0,1.26,0a24.66,24.66,0,0,0,6.75-1.46c4.37-1.46,7.91-3.18,10.86-1.48,2,1.14,1.42,2.57-.74,3.82a10.47,10.47,0,0,1-1.06.53,9.78,9.78,0,0,1-7.58.05l-4,4a18.71,18.71,0,0,0,14.71-.64l3.77,2.18,4.55-2.63L439.55,381c3.78-2.93,4.22-6.12-.2-8.71l-.08,0C435.28,369.93,431.15,370.23,427.47,371.15Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "404.37 366.37 408.96 364.28 412.73 365.94 408.92 363.74 404.37 366.37",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.52,364.94a21.37,21.37,0,0,1,9.79.33L422.67,369l3.81-3.85A18.22,18.22,0,0,0,415.52,364.94Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.27,372.23l.08,0c4.42,2.59,4,5.78.2,8.71,3.35-3.65,2.75-6.2-.9-8.31s-8.3-2.08-11.18-1.53C431.15,370.23,435.28,369.93,439.27,372.23Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.55 381 442.44 383.21 438.76 385.8 443.31 383.17 439.55 381",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.86,380.2a9.83,9.83,0,0,1-7.26.63l-4.32,3.43,4-4A9.78,9.78,0,0,0,431.86,380.2Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.3,374c-1.72.68-4.2.57-5.46-.51s-.47-2.35,1.5-3.4c-2.13,1.4-1.92,2.63-.46,3.48a4.84,4.84,0,0,0,2.17.65A8.28,8.28,0,0,0,418.3,374Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.1,368.57c-.32.29-3.06,2.85-1.85,5.4,1.28,2.72,5.3,4.47,8.54,4.82h0A13.41,13.41,0,0,1,408.5,377C404.19,374.5,404.27,371.48,408.1,368.57Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.64,362.4c-2.15-3.63-5.73-7-10.74-9.93-17.56-10.14-46-10.14-63.58,0-5,2.89-8.59,6.3-10.74,9.93h-2.43v9.18h0c.33,6.39,4.7,12.72,13.14,17.59,17.56,10.14,46,10.14,63.58,0,8.44-4.87,12.84-11.2,13.17-17.59h0V362.4Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.64,362.4c-2.15-3.63-5.73-7-10.74-9.93-17.56-10.14-46-10.14-63.58,0-5,2.89-8.59,6.3-10.74,9.93h-2.43v9.18h0c.33,6.39,4.7,12.72,13.14,17.59,17.56,10.14,46,10.14,63.58,0,8.44-4.87,12.84-11.2,13.17-17.59h0V362.4Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.11,344.87c-11.51,0-23,2.53-31.79,7.6-5,2.89-8.59,6.3-10.74,9.93h-2.43v9.18h0c.33,6.39,4.7,12.72,13.14,17.59,8.78,5.07,20.28,7.61,31.79,7.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.55,349.08a48.91,48.91,0,0,0-7.23,3.39c-5,2.89-8.59,6.3-10.74,9.93h-2.43v9.18h0c.33,6.39,4.7,12.72,13.14,17.59a48.91,48.91,0,0,0,7.23,3.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.66,349.08a48.56,48.56,0,0,1,7.24,3.39c5,2.89,8.59,6.3,10.74,9.93h2.43v9.18h0c-.33,6.39-4.73,12.72-13.17,17.6a49.54,49.54,0,0,1-7.24,3.38Z",
    style: {
      fill: "#B42F53",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.32,344.05c-17.56,10.14-17.56,26.57,0,36.71,15.36,8.87,39.07,10,56.52,3.32h0l.69-.27a48.47,48.47,0,0,0,6.36-3.05c14.64-8.46,17.07-21.29,7.29-31.2h0a34.43,34.43,0,0,0-7.29-5.51C431.34,333.91,402.88,333.91,385.32,344.05Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.32,344.05c-17.56,10.14-17.56,26.57,0,36.71,15.36,8.87,39.07,10,56.52,3.32h0l.69-.27a48.47,48.47,0,0,0,6.36-3.05c14.64-8.46,17.07-21.29,7.29-31.2h0a34.43,34.43,0,0,0-7.29-5.51C431.34,333.91,402.88,333.91,385.32,344.05Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.19,349.56c.19.22,6.33,6.7,4.7,16-1.55,8.92-14,16.43-18.35,18.23a48.47,48.47,0,0,0,6.36-3.05C463.54,372.3,466,359.47,456.19,349.56Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,375.24c-.19-.21-6.33-6.69-4.71-16,1.56-8.92,14.05-16.43,18.35-18.23a47.69,47.69,0,0,0-6.35,3.05C370.68,352.5,368.25,365.33,378,375.24Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 417.12,
    cy: 362.37,
    rx: 41.79,
    ry: 24.13,
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 417.12,
    cy: 362.37,
    rx: 41.79,
    ry: 24.13,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457,369.57c3.36-6.21,2.26-13.05-3.28-18.85a28.7,28.7,0,0,0-3.54-3.11,39,39,0,0,0-3.39-2.23c-.67-.39-1.35-.76-2.06-1.11,1.74,2.86,1.1,5.92-8.74,6.49-19.26,1.13,5.15,19.54,5.15,19.54S453.57,364.3,457,369.57Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455,364.48c2.89-.32,4.32-3.29,3.2-6.64s-4.38-5.79-7.27-5.47-4.32,3.3-3.2,6.64S452.14,364.81,455,364.48Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.56,379.82c-.95-7.15-32.21-26.95-32.21-26.95s-6.94-2.78-4.63-7.63a35.8,35.8,0,0,0-3.35,2.16c-.72.52-1.4,1.06-2,1.61-9.31,8.06-9.32,18.65,0,26.72.63.55,1.31,1.08,2,1.61a34.5,34.5,0,0,0,3.1,2c1.06.63,2.17,1.2,3.31,1.74.92.43,1.86.84,2.82,1.21s1.94.73,2.93,1.06a60.78,60.78,0,0,0,9.33,2.24l2.1.31a72.36,72.36,0,0,0,9.33.58,70.93,70.93,0,0,0,11.41-.94S423.67,384.53,424.56,379.82Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.12,379.82c-.95-7.15-32.22-26.95-32.22-26.95s-6.93-2.78-4.63-7.63a35.61,35.61,0,0,0-3.34,2.16c-.73.52-1.4,1.06-2,1.61-9.3,8.06-9.32,18.65,0,26.72.63.55,1.31,1.08,2,1.61a31.87,31.87,0,0,0,3.1,2c1.06.63,2.17,1.2,3.31,1.74.91.43,1.86.84,2.82,1.21s1.93.73,2.93,1.06a60.5,60.5,0,0,0,9.33,2.24l2.09.31a72.47,72.47,0,0,0,9.33.58,70.74,70.74,0,0,0,11.41-.94S423.22,384.53,424.12,379.82Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.09,349.66c-11.66,6.73-12.13,17.47-1.42,24.53.46.3.93.6,1.43.89,12.16,7,31.86,7,44,0s12.17-18.4,0-25.42c-.5-.29-1-.57-1.53-.83C425.37,342.65,406.76,342.92,395.09,349.66Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.09,349.66c-11.66,6.73-12.13,17.47-1.42,24.53.46.3.93.6,1.43.89,12.16,7,31.86,7,44,0s12.17-18.4,0-25.42c-.5-.29-1-.57-1.53-.83C425.37,342.65,406.76,342.92,395.09,349.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 417.13,
    cy: 362.37,
    rx: 29.76,
    ry: 17.18,
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 417.13,
    cy: 362.37,
    rx: 29.76,
    ry: 17.18,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.08,355c11.62-6.71,30.47-6.71,42.09,0,4.75,2.74,7.56,6.18,8.42,9.75-.86,3.57-3.67,7-8.42,9.76-11.62,6.71-30.47,6.71-42.09,0-4.75-2.75-7.56-6.19-8.42-9.76C388.52,361.19,391.33,357.75,396.08,355Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.08,355c11.62-6.71,30.47-6.71,42.09,0,4.75,2.74,7.56,6.18,8.42,9.75-.86,3.57-3.67,7-8.42,9.76-11.62,6.71-30.47,6.71-42.09,0-4.75-2.75-7.56-6.19-8.42-9.76C388.52,361.19,391.33,357.75,396.08,355Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.86,367.54c0-.58,0-2.94,0-3.55,0-1.46-1-2.87-3.18-4.14l-.07-.05c-4-2.3-8.13-2-11.81-1.08h0c-1.56.39-3,.9-4.4,1.37a43,43,0,0,1-4.73,1.46h0a8.28,8.28,0,0,1-2.25.22,4.73,4.73,0,0,1-1.86-.5l.15-.1.47-.29a12,12,0,0,1,1.24-.62,8.65,8.65,0,0,1,6.62-.15l3.82-3.85v-3.53a18.19,18.19,0,0,0-10.44-.38,21.7,21.7,0,0,0-3.31,1.15l-3.82-2.2-4.55,2.63v3.53l1.56.9a3.75,3.75,0,0,0-.67,2.06V364c0,1.45,1,2.86,3.25,4.13a13.41,13.41,0,0,0,6.28,1.81h0c.41,0,.84,0,1.25,0a24.73,24.73,0,0,0,6.76-1.46l1.31-.45-3.84,3.85v3.53a18.7,18.7,0,0,0,14.72-.63l3.77,2.17,4.55-2.63v-3.53l-1.56-.9A4.14,4.14,0,0,0,435.86,367.54Zm-9.6-.3a10.34,10.34,0,0,1-1.05.53,9.81,9.81,0,0,1-7.45.11c3.56-1.26,6.54-2.36,9.08-1C426.66,367,426.47,367.12,426.26,367.24Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.81,358.72h0c-1.56.39-3,.9-4.4,1.37a43,43,0,0,1-4.73,1.46h0a8.28,8.28,0,0,1-2.25.22,4.8,4.8,0,0,1-2.16-.65c-1.47-.85-1.68-2.08.45-3.48l.47-.29a10.24,10.24,0,0,1,1.24-.62,8.65,8.65,0,0,1,6.62-.15l3.82-3.85a18.19,18.19,0,0,0-10.44-.38,21.7,21.7,0,0,0-3.31,1.15l-3.82-2.2-4.55,2.63,3.77,2.18,0,0c-3.82,2.91-3.9,5.93.41,8.42a13.41,13.41,0,0,0,6.28,1.81h0c.41,0,.84,0,1.25,0a24.73,24.73,0,0,0,6.76-1.46c4.37-1.46,7.91-3.18,10.85-1.48,2,1.14,1.43,2.57-.74,3.82a10.34,10.34,0,0,1-1.05.53,9.8,9.8,0,0,1-7.59.05l-4,4a18.7,18.7,0,0,0,14.72-.64l3.77,2.18,4.55-2.63-3.77-2.17c3.79-2.94,4.22-6.13-.2-8.72l-.07-.05C428.62,357.5,424.49,357.8,420.81,358.72Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.81,358.72h0c-1.56.39-3,.9-4.4,1.37a43,43,0,0,1-4.73,1.46h0a8.28,8.28,0,0,1-2.25.22,4.8,4.8,0,0,1-2.16-.65c-1.47-.85-1.68-2.08.45-3.48l.47-.29a10.24,10.24,0,0,1,1.24-.62,8.65,8.65,0,0,1,6.62-.15l3.82-3.85a18.19,18.19,0,0,0-10.44-.38,21.7,21.7,0,0,0-3.31,1.15l-3.82-2.2-4.55,2.63,3.77,2.18,0,0c-3.82,2.91-3.9,5.93.41,8.42a13.41,13.41,0,0,0,6.28,1.81h0c.41,0,.84,0,1.25,0a24.73,24.73,0,0,0,6.76-1.46c4.37-1.46,7.91-3.18,10.85-1.48,2,1.14,1.43,2.57-.74,3.82a10.34,10.34,0,0,1-1.05.53,9.8,9.8,0,0,1-7.59.05l-4,4a18.7,18.7,0,0,0,14.72-.64l3.77,2.18,4.55-2.63-3.77-2.17c3.79-2.94,4.22-6.13-.2-8.72l-.07-.05C428.62,357.5,424.49,357.8,420.81,358.72Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "397.71 353.94 402.31 351.85 406.08 353.51 402.26 351.31 397.71 353.94",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.87,352.51a21.33,21.33,0,0,1,9.78.33L416,356.59l3.82-3.85A18.22,18.22,0,0,0,408.87,352.51Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.62,359.8l.07.05c4.42,2.59,4,5.78.2,8.72,3.36-3.66,2.75-6.21-.89-8.32s-8.3-2.07-11.19-1.53C424.49,357.8,428.62,357.5,432.62,359.8Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.89 368.56 435.78 370.79 432.11 373.37 436.66 370.74 432.89 368.56",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.21,367.77a9.82,9.82,0,0,1-7.26.63l-4.33,3.43,4-4A9.8,9.8,0,0,0,425.21,367.77Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.64,361.56c-1.72.68-4.2.57-5.45-.51s-.47-2.35,1.49-3.4c-2.13,1.4-1.92,2.63-.45,3.48a4.8,4.8,0,0,0,2.16.65A8.28,8.28,0,0,0,411.64,361.56Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.44,356.14c-.32.29-3.06,2.85-1.85,5.4,1.29,2.72,5.3,4.47,8.55,4.82h0a13.41,13.41,0,0,1-6.28-1.81C397.54,362.07,397.62,359.05,401.44,356.14Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.81,346.27c-2.15-3.63-5.73-7-10.74-9.93-17.56-10.14-46-10.14-63.58,0-5,2.89-8.59,6.3-10.74,9.93h-2.43v9.18h0c.33,6.39,4.7,12.72,13.14,17.59,17.56,10.14,46,10.14,63.58,0,8.44-4.87,12.84-11.2,13.17-17.59h0v-9.18Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.81,346.27c-2.15-3.63-5.73-7-10.74-9.93-17.56-10.14-46-10.14-63.58,0-5,2.89-8.59,6.3-10.74,9.93h-2.43v9.18h0c.33,6.39,4.7,12.72,13.14,17.59,17.56,10.14,46,10.14,63.58,0,8.44-4.87,12.84-11.2,13.17-17.59h0v-9.18Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.28,328.73c-11.5,0-23,2.54-31.79,7.61-5,2.89-8.59,6.3-10.74,9.93h-2.43v9.18h0c.33,6.39,4.7,12.72,13.14,17.59,8.78,5.07,20.29,7.61,31.79,7.6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.73,333a48.56,48.56,0,0,0-7.24,3.39c-5,2.89-8.59,6.3-10.74,9.93h-2.43v9.18h0c.33,6.39,4.7,12.72,13.14,17.59a48.56,48.56,0,0,0,7.24,3.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.83,333a48.56,48.56,0,0,1,7.24,3.39c5,2.89,8.59,6.3,10.74,9.93h2.43v9.18h0c-.33,6.39-4.73,12.72-13.17,17.59a48.56,48.56,0,0,1-7.24,3.39Z",
    style: {
      fill: "#B42F53",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.49,327.92c-17.56,10.13-17.56,26.57,0,36.7,15.36,8.87,39.07,10,56.52,3.33h0l.69-.27a48.51,48.51,0,0,0,6.36-3.06c14.64-8.45,17.07-21.28,7.29-31.19h0a34.1,34.1,0,0,0-7.29-5.51C434.51,317.78,406.05,317.78,388.49,327.92Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.49,327.92c-17.56,10.13-17.56,26.57,0,36.7,15.36,8.87,39.07,10,56.52,3.33h0l.69-.27a48.51,48.51,0,0,0,6.36-3.06c14.64-8.45,17.07-21.28,7.29-31.19h0a34.1,34.1,0,0,0-7.29-5.51C434.51,317.78,406.05,317.78,388.49,327.92Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.36,333.43c.19.21,6.33,6.69,4.7,16-1.55,8.92-14,16.42-18.35,18.23a48.51,48.51,0,0,0,6.36-3.06C466.71,356.17,469.14,343.34,459.36,333.43Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.2,359.11c-.19-.21-6.33-6.69-4.7-16,1.55-8.92,14-16.43,18.35-18.24a48.51,48.51,0,0,0-6.36,3.06C373.85,336.37,371.42,349.2,381.2,359.11Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 420.29,
    cy: 346.24,
    rx: 41.79,
    ry: 24.13,
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 420.29,
    cy: 346.24,
    rx: 41.79,
    ry: 24.13,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.19,353.44c3.36-6.21,2.26-13.05-3.28-18.86a28.65,28.65,0,0,0-3.54-3.1,36.83,36.83,0,0,0-3.39-2.23c-.66-.39-1.35-.76-2.05-1.11,1.73,2.85,1.1,5.92-8.75,6.49-19.26,1.13,5.15,19.53,5.15,19.53S456.75,348.17,460.19,353.44Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.2,348.35c2.89-.32,4.32-3.3,3.2-6.64s-4.38-5.79-7.27-5.47-4.32,3.3-3.2,6.64S455.31,348.67,458.2,348.35Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.73,363.69c-.94-7.15-32.21-27-32.21-27s-6.93-2.78-4.63-7.62a35.8,35.8,0,0,0-3.35,2.16,25.65,25.65,0,0,0-2,1.61c-9.31,8.06-9.32,18.64,0,26.71.62.55,1.3,1.09,2,1.61a36.88,36.88,0,0,0,3.1,2c1.06.62,2.17,1.2,3.32,1.74.91.43,1.85.83,2.81,1.21s1.94.73,2.93,1.06a62.26,62.26,0,0,0,9.33,2.24l2.1.3a72.37,72.37,0,0,0,9.33.59,70.93,70.93,0,0,0,11.41-.94S426.84,368.39,427.73,363.69Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.29,363.69c-1-7.15-32.22-27-32.22-27s-6.93-2.78-4.63-7.62a35.61,35.61,0,0,0-3.34,2.16,24,24,0,0,0-2,1.61c-9.31,8.06-9.32,18.64,0,26.71.63.55,1.31,1.09,2,1.61a36.88,36.88,0,0,0,3.1,2c1.06.62,2.17,1.2,3.31,1.74.91.43,1.86.83,2.82,1.21s1.93.73,2.93,1.06a61.68,61.68,0,0,0,9.33,2.24c.69.11,1.4.21,2.1.3a72.21,72.21,0,0,0,9.32.59,70.74,70.74,0,0,0,11.41-.94S426.39,368.39,427.29,363.69Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.27,333.52c-11.67,6.74-12.14,17.48-1.43,24.54.46.3.93.6,1.43.88,12.16,7,31.87,7,44,0s12.16-18.4,0-25.42c-.5-.28-1-.56-1.53-.82C428.54,326.51,409.93,326.79,398.27,333.52Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.27,333.52c-11.67,6.74-12.14,17.48-1.43,24.54.46.3.93.6,1.43.88,12.16,7,31.87,7,44,0s12.16-18.4,0-25.42c-.5-.28-1-.56-1.53-.82C428.54,326.51,409.93,326.79,398.27,333.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 420.3,
    cy: 346.23,
    rx: 29.76,
    ry: 17.18,
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 420.3,
    cy: 346.23,
    rx: 29.76,
    ry: 17.18,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.25,338.88c11.63-6.71,30.47-6.71,42.09,0,4.75,2.74,7.56,6.18,8.43,9.75-.87,3.57-3.68,7-8.43,9.75-11.62,6.71-30.46,6.71-42.09,0-4.75-2.74-7.56-6.18-8.42-9.75C391.69,345.06,394.5,341.62,399.25,338.88Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.25,338.88c11.63-6.71,30.47-6.71,42.09,0,4.75,2.74,7.56,6.18,8.43,9.75-.87,3.57-3.68,7-8.43,9.75-11.62,6.71-30.46,6.71-42.09,0-4.75-2.74-7.56-6.18-8.42-9.75C391.69,345.06,394.5,341.62,399.25,338.88Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,351.41c0-.58,0-2.94,0-3.55,0-1.46-1-2.87-3.18-4.14l-.07-.05c-4-2.31-8.13-2-11.81-1.08h0c-1.56.39-3.05.9-4.4,1.36a45.65,45.65,0,0,1-4.73,1.47h0a7.83,7.83,0,0,1-2.24.21,4.72,4.72,0,0,1-1.87-.49l.15-.1.47-.29a10.36,10.36,0,0,1,1.25-.62,8.63,8.63,0,0,1,6.61-.15l3.82-3.85v-3.53a18.16,18.16,0,0,0-10.43-.38,21.44,21.44,0,0,0-3.32,1.15l-3.82-2.2-4.55,2.62v3.54l1.56.9a3.75,3.75,0,0,0-.67,2.06c0,.58,0,2.93,0,3.52,0,1.46,1.05,2.87,3.25,4.14a13.41,13.41,0,0,0,6.28,1.81h0c.41,0,.84,0,1.26,0a24.66,24.66,0,0,0,6.75-1.46l1.31-.45-3.84,3.85v3.53a18.74,18.74,0,0,0,14.72-.64l3.77,2.18,4.55-2.63v-3.53l-1.56-.9A4.16,4.16,0,0,0,439,351.41Zm-9.61-.3a10.22,10.22,0,0,1-1.05.52,9.76,9.76,0,0,1-7.45.11c3.57-1.25,6.54-2.35,9.08-1Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,342.59h0c-1.56.39-3.05.9-4.4,1.36a45.65,45.65,0,0,1-4.73,1.47h0a7.83,7.83,0,0,1-2.24.21,4.71,4.71,0,0,1-2.17-.64c-1.47-.85-1.68-2.09.45-3.48a5.35,5.35,0,0,1,.47-.29,10.36,10.36,0,0,1,1.25-.62,8.58,8.58,0,0,1,6.61-.15l3.82-3.85a18.16,18.16,0,0,0-10.43-.38,21.44,21.44,0,0,0-3.32,1.15l-3.82-2.2-4.55,2.62,3.77,2.18,0,0c-3.83,2.91-3.91,5.93.4,8.41a13.18,13.18,0,0,0,6.28,1.81h0c.41,0,.84,0,1.26,0a25,25,0,0,0,6.75-1.46c4.37-1.46,7.91-3.18,10.85-1.48,2,1.13,1.43,2.57-.74,3.82a10.22,10.22,0,0,1-1.05.52,9.81,9.81,0,0,1-7.59.06l-4,4a18.74,18.74,0,0,0,14.72-.64l3.77,2.18,4.55-2.63-3.77-2.18c3.79-2.93,4.23-6.12-.2-8.71l-.07-.05C431.79,341.36,427.66,341.67,424,342.59Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424,342.59h0c-1.56.39-3.05.9-4.4,1.36a45.65,45.65,0,0,1-4.73,1.47h0a7.83,7.83,0,0,1-2.24.21,4.71,4.71,0,0,1-2.17-.64c-1.47-.85-1.68-2.09.45-3.48a5.35,5.35,0,0,1,.47-.29,10.36,10.36,0,0,1,1.25-.62,8.58,8.58,0,0,1,6.61-.15l3.82-3.85a18.16,18.16,0,0,0-10.43-.38,21.44,21.44,0,0,0-3.32,1.15l-3.82-2.2-4.55,2.62,3.77,2.18,0,0c-3.83,2.91-3.91,5.93.4,8.41a13.18,13.18,0,0,0,6.28,1.81h0c.41,0,.84,0,1.26,0a25,25,0,0,0,6.75-1.46c4.37-1.46,7.91-3.18,10.85-1.48,2,1.13,1.43,2.57-.74,3.82a10.22,10.22,0,0,1-1.05.52,9.81,9.81,0,0,1-7.59.06l-4,4a18.74,18.74,0,0,0,14.72-.64l3.77,2.18,4.55-2.63-3.77-2.18c3.79-2.93,4.23-6.12-.2-8.71l-.07-.05C431.79,341.36,427.66,341.67,424,342.59Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "400.88 337.81 405.48 335.72 409.25 337.38 405.43 335.18 400.88 337.81",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,336.38a21.1,21.1,0,0,1,9.79.33l-2.65,3.75,3.82-3.85A18.07,18.07,0,0,0,412,336.38Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.79,343.67l.07.05c4.43,2.59,4,5.78.2,8.71,3.36-3.65,2.75-6.2-.89-8.31s-8.3-2.08-11.19-1.53C427.66,341.67,431.79,341.36,435.79,343.67Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.06 352.43 438.95 354.65 435.28 357.24 439.83 354.61 436.06 352.43",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.38,351.63a9.8,9.8,0,0,1-7.26.64l-4.33,3.43,4-4A9.81,9.81,0,0,0,428.38,351.63Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.81,345.43c-1.72.68-4.2.56-5.45-.52s-.47-2.34,1.49-3.39c-2.13,1.39-1.92,2.63-.45,3.48a4.71,4.71,0,0,0,2.17.64A7.83,7.83,0,0,0,414.81,345.43Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.62,340c-.33.29-3.07,2.84-1.86,5.4,1.29,2.72,5.31,4.47,8.55,4.82h0a13.18,13.18,0,0,1-6.28-1.81C400.71,345.94,400.79,342.92,404.62,340Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.44,335.67c-2.15-3.63-5.73-7-10.74-9.93-17.56-10.14-46-10.14-63.58,0-5,2.89-8.59,6.3-10.74,9.93H365v9.19h0c.32,6.38,4.69,12.71,13.13,17.59,17.56,10.13,46,10.13,63.58,0,8.44-4.88,12.84-11.21,13.17-17.59h0v-9.19Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.44,335.67c-2.15-3.63-5.73-7-10.74-9.93-17.56-10.14-46-10.14-63.58,0-5,2.89-8.59,6.3-10.74,9.93H365v9.19h0c.32,6.38,4.69,12.71,13.13,17.59,17.56,10.13,46,10.13,63.58,0,8.44-4.88,12.84-11.21,13.17-17.59h0v-9.19Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.91,318.14c-11.5,0-23,2.53-31.79,7.6-5,2.89-8.59,6.3-10.74,9.93H365v9.19h0c.32,6.38,4.69,12.71,13.13,17.59,8.78,5.07,20.29,7.6,31.79,7.6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.36,322.35a49.58,49.58,0,0,0-7.24,3.39c-5,2.89-8.59,6.3-10.74,9.93H365v9.19h0c.32,6.38,4.69,12.71,13.13,17.59a50.64,50.64,0,0,0,7.24,3.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.46,322.35a49.58,49.58,0,0,1,7.24,3.39c5,2.89,8.59,6.3,10.74,9.93h2.43v9.19h0c-.33,6.38-4.73,12.71-13.17,17.59a50.64,50.64,0,0,1-7.24,3.39Z",
    style: {
      fill: "#B42F53",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.12,317.32c-17.56,10.14-17.55,26.57,0,36.71,15.36,8.87,39.07,10,56.53,3.33h0q.35-.12.69-.27A47.23,47.23,0,0,0,441.7,354c14.64-8.45,17.07-21.29,7.29-31.19h0a34.43,34.43,0,0,0-7.29-5.51C424.14,307.19,395.68,307.18,378.12,317.32Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.12,317.32c-17.56,10.14-17.55,26.57,0,36.71,15.36,8.87,39.07,10,56.53,3.33h0q.35-.12.69-.27A47.23,47.23,0,0,0,441.7,354c14.64-8.45,17.07-21.29,7.29-31.19h0a34.43,34.43,0,0,0-7.29-5.51C424.14,307.19,395.68,307.18,378.12,317.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,322.84c.19.21,6.33,6.69,4.71,16-1.56,8.92-14.05,16.43-18.36,18.23A47.23,47.23,0,0,0,441.7,354C456.34,345.58,458.77,332.74,449,322.84Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.83,348.51c-.19-.21-6.33-6.69-4.7-16,1.55-8.92,14-16.43,18.35-18.23a48.47,48.47,0,0,0-6.36,3.05C363.48,325.78,361.05,338.61,370.83,348.51Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 409.93,
    cy: 335.64,
    rx: 41.79,
    ry: 24.13,
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 409.93,
    cy: 335.64,
    rx: 41.79,
    ry: 24.13,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.82,342.85c3.36-6.21,2.26-13.06-3.28-18.86a27.84,27.84,0,0,0-3.54-3.1,36,36,0,0,0-3.38-2.23c-.67-.39-1.36-.77-2.06-1.12,1.73,2.86,1.1,5.92-8.75,6.49-19.26,1.13,5.15,19.54,5.15,19.54S446.38,337.57,449.82,342.85Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.83,337.75c2.89-.32,4.33-3.29,3.2-6.64s-4.38-5.79-7.27-5.46-4.32,3.29-3.2,6.64S444.94,338.08,447.83,337.75Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.37,353.09c-.95-7.15-32.22-26.95-32.22-26.95s-6.93-2.78-4.63-7.63a37.16,37.16,0,0,0-3.35,2.16c-.72.52-1.39,1.06-2,1.61-9.31,8.06-9.32,18.65,0,26.72.63.55,1.31,1.08,2,1.61a36.88,36.88,0,0,0,3.1,2c1.07.62,2.17,1.19,3.32,1.73.91.43,1.86.84,2.81,1.21s1.94.74,2.94,1.06a60.65,60.65,0,0,0,9.32,2.24c.7.11,1.4.22,2.1.31a72.36,72.36,0,0,0,9.33.58,70.83,70.83,0,0,0,11.41-.93S416.47,357.8,417.37,353.09Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.92,353.09c-.95-7.15-32.22-26.95-32.22-26.95s-6.93-2.78-4.63-7.63a35.61,35.61,0,0,0-3.34,2.16c-.72.52-1.4,1.06-2,1.61-9.31,8.06-9.32,18.65,0,26.72.63.55,1.31,1.08,2,1.61a36.88,36.88,0,0,0,3.1,2c1.06.62,2.17,1.19,3.31,1.73.91.43,1.86.84,2.82,1.21s1.93.74,2.93,1.06a60.78,60.78,0,0,0,9.33,2.24c.69.11,1.4.22,2.1.31a72.21,72.21,0,0,0,9.32.58,70.74,70.74,0,0,0,11.41-.93S416,357.8,416.92,353.09Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.9,322.93c-11.67,6.73-12.14,17.47-1.43,24.54.46.3.94.59,1.43.88,12.16,7,31.87,7,44,0s12.16-18.4,0-25.42c-.49-.29-1-.56-1.53-.83C418.17,315.92,399.56,316.19,387.9,322.93Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.9,322.93c-11.67,6.73-12.14,17.47-1.43,24.54.46.3.94.59,1.43.88,12.16,7,31.87,7,44,0s12.16-18.4,0-25.42c-.49-.29-1-.56-1.53-.83C418.17,315.92,399.56,316.19,387.9,322.93Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 409.93,
    cy: 335.64,
    rx: 29.76,
    ry: 17.18,
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 409.93,
    cy: 335.64,
    rx: 29.76,
    ry: 17.18,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.88,328.28c11.63-6.71,30.47-6.71,42.09,0,4.75,2.74,7.56,6.19,8.43,9.75-.87,3.57-3.68,7-8.43,9.76-11.62,6.71-30.46,6.71-42.09,0-4.75-2.75-7.55-6.19-8.42-9.76C381.33,334.47,384.13,331,388.88,328.28Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.88,328.28c11.63-6.71,30.47-6.71,42.09,0,4.75,2.74,7.56,6.19,8.43,9.75-.87,3.57-3.68,7-8.43,9.76-11.62,6.71-30.46,6.71-42.09,0-4.75-2.75-7.55-6.19-8.42-9.76C381.33,334.47,384.13,331,388.88,328.28Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.67,340.81c0-.58,0-2.94,0-3.55,0-1.45-1-2.87-3.18-4.14l-.07,0c-4-2.31-8.13-2-11.81-1.08h0c-1.56.4-3.05.9-4.4,1.37a43,43,0,0,1-4.73,1.46h0a8.62,8.62,0,0,1-2.24.21,4.89,4.89,0,0,1-1.87-.49l.15-.11.47-.29a10.26,10.26,0,0,1,1.25-.61,8.58,8.58,0,0,1,6.61-.15l3.82-3.85V326a18.16,18.16,0,0,0-10.43-.38,22.54,22.54,0,0,0-3.32,1.15l-3.82-2.2-4.55,2.63v3.53l1.56.9a3.75,3.75,0,0,0-.67,2.06c0,.59,0,2.94,0,3.53,0,1.46,1,2.86,3.24,4.13a13.18,13.18,0,0,0,6.28,1.81h0c.42,0,.84,0,1.26,0a25,25,0,0,0,6.75-1.45l1.31-.46-3.84,3.85v3.54a18.74,18.74,0,0,0,14.72-.64l3.77,2.17,4.55-2.63V344l-1.56-.9A4.16,4.16,0,0,0,428.67,340.81Zm-9.61-.3A9.39,9.39,0,0,1,418,341a9.81,9.81,0,0,1-7.45.11c3.57-1.26,6.54-2.36,9.08-1A6.42,6.42,0,0,1,419.06,340.51Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.61,332h0c-1.56.4-3.05.9-4.4,1.37a43,43,0,0,1-4.73,1.46h0a8.62,8.62,0,0,1-2.24.21,4.84,4.84,0,0,1-2.17-.65c-1.46-.84-1.68-2.08.45-3.48l.47-.29a12.08,12.08,0,0,1,1.25-.62,8.63,8.63,0,0,1,6.61-.15l3.82-3.85a18.16,18.16,0,0,0-10.43-.38,22.54,22.54,0,0,0-3.32,1.15l-3.82-2.2-4.55,2.63,3.77,2.18,0,0c-3.83,2.9-3.91,5.92.4,8.41a13.41,13.41,0,0,0,6.28,1.81h0c.42,0,.84,0,1.26,0a24.66,24.66,0,0,0,6.75-1.46c4.37-1.46,7.91-3.18,10.85-1.48,2,1.14,1.43,2.57-.74,3.82A9.39,9.39,0,0,1,418,341a9.76,9.76,0,0,1-7.59,0l-4,4a18.74,18.74,0,0,0,14.72-.63l3.77,2.17,4.55-2.63-3.77-2.17c3.79-2.93,4.23-6.13-.2-8.72l-.07,0C421.42,330.77,417.29,331.07,413.61,332Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.61,332h0c-1.56.4-3.05.9-4.4,1.37a43,43,0,0,1-4.73,1.46h0a8.62,8.62,0,0,1-2.24.21,4.84,4.84,0,0,1-2.17-.65c-1.46-.84-1.68-2.08.45-3.48l.47-.29a12.08,12.08,0,0,1,1.25-.62,8.63,8.63,0,0,1,6.61-.15l3.82-3.85a18.16,18.16,0,0,0-10.43-.38,22.54,22.54,0,0,0-3.32,1.15l-3.82-2.2-4.55,2.63,3.77,2.18,0,0c-3.83,2.9-3.91,5.92.4,8.41a13.41,13.41,0,0,0,6.28,1.81h0c.42,0,.84,0,1.26,0a24.66,24.66,0,0,0,6.75-1.46c4.37-1.46,7.91-3.18,10.85-1.48,2,1.14,1.43,2.57-.74,3.82A9.39,9.39,0,0,1,418,341a9.76,9.76,0,0,1-7.59,0l-4,4a18.74,18.74,0,0,0,14.72-.63l3.77,2.17,4.55-2.63-3.77-2.17c3.79-2.93,4.23-6.13-.2-8.72l-.07,0C421.42,330.77,417.29,331.07,413.61,332Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "390.51 327.21 395.11 325.13 398.88 326.78 395.06 324.58 390.51 327.21",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.67,325.78a21.37,21.37,0,0,1,9.79.33l-2.65,3.75,3.82-3.84A18.15,18.15,0,0,0,401.67,325.78Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.42,333.08l.07,0c4.43,2.59,4,5.79.2,8.72,3.36-3.66,2.75-6.21-.89-8.32s-8.3-2.07-11.19-1.52C417.29,331.07,421.42,330.77,425.42,333.08Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.69 341.84 428.58 344.06 424.91 346.64 429.46 344.01 425.69 341.84",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,341a9.77,9.77,0,0,1-7.26.63l-4.33,3.43,4-4A9.76,9.76,0,0,0,418,341Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.44,334.84c-1.72.67-4.2.56-5.45-.52s-.47-2.35,1.49-3.4c-2.13,1.4-1.91,2.64-.45,3.48a4.84,4.84,0,0,0,2.17.65A8.62,8.62,0,0,0,404.44,334.84Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.25,329.42c-.32.28-3.07,2.84-1.86,5.39,1.29,2.73,5.31,4.47,8.55,4.83h0a13.41,13.41,0,0,1-6.28-1.81C390.34,335.34,390.42,332.32,394.25,329.42Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462,321.14c-2.15-3.63-5.72-7-10.74-9.93-17.55-10.14-46-10.14-63.57,0-5,2.89-8.59,6.3-10.74,9.93h-2.43v9.19h0c.32,6.38,4.69,12.71,13.14,17.59,17.55,10.13,46,10.13,63.57,0,8.45-4.88,12.85-11.21,13.17-17.59h0v-9.19Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462,321.14c-2.15-3.63-5.72-7-10.74-9.93-17.55-10.14-46-10.14-63.57,0-5,2.89-8.59,6.3-10.74,9.93h-2.43v9.19h0c.32,6.38,4.69,12.71,13.14,17.59,17.55,10.13,46,10.13,63.57,0,8.45-4.88,12.85-11.21,13.17-17.59h0v-9.19Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.52,303.61c-11.51,0-23,2.53-31.79,7.6-5,2.89-8.59,6.3-10.74,9.93h-2.43v9.19h0c.32,6.38,4.69,12.71,13.14,17.59,8.77,5.07,20.28,7.6,31.79,7.6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395,307.82a49,49,0,0,0-7.23,3.39c-5,2.89-8.59,6.3-10.74,9.93h-2.43v9.19h0c.32,6.38,4.69,12.71,13.14,17.59a50,50,0,0,0,7.23,3.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.07,307.82a49,49,0,0,1,7.23,3.39c5,2.89,8.59,6.3,10.74,9.93h2.43v9.19h0c-.32,6.38-4.72,12.71-13.17,17.59a50,50,0,0,1-7.23,3.39Z",
    style: {
      fill: "#B42F53",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.72,302.79c-17.55,10.14-17.55,26.57,0,36.71,15.37,8.87,39.08,10,56.53,3.33h0c.23-.09.47-.17.7-.27a49,49,0,0,0,6.35-3.05c14.64-8.45,17.08-21.29,7.3-31.19h0a33.92,33.92,0,0,0-7.29-5.51C433.75,292.66,405.28,292.65,387.72,302.79Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.72,302.79c-17.55,10.14-17.55,26.57,0,36.71,15.37,8.87,39.08,10,56.53,3.33h0c.23-.09.47-.17.7-.27a49,49,0,0,0,6.35-3.05c14.64-8.45,17.08-21.29,7.3-31.19h0a33.92,33.92,0,0,0-7.29-5.51C433.75,292.66,405.28,292.65,387.72,302.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.6,308.31c.19.21,6.33,6.69,4.7,16-1.56,8.92-14.05,16.43-18.35,18.23a49,49,0,0,0,6.35-3.05C465.94,331.05,468.38,318.21,458.6,308.31Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.43,334c-.19-.21-6.33-6.69-4.7-16,1.55-8.92,14-16.43,18.35-18.23a49,49,0,0,0-6.35,3.05C373.08,311.24,370.65,324.08,380.43,334Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 419.53,
    cy: 321.11,
    rx: 41.79,
    ry: 24.13,
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 419.53,
    cy: 321.11,
    rx: 41.79,
    ry: 24.13,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.42,328.32c3.36-6.21,2.27-13.06-3.28-18.86a27.17,27.17,0,0,0-3.54-3.1,33.53,33.53,0,0,0-3.38-2.23c-.67-.39-1.35-.77-2.06-1.12,1.74,2.86,1.1,5.92-8.74,6.49-19.26,1.13,5.14,19.54,5.14,19.54S456,323,459.42,328.32Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.44,323.22c2.89-.32,4.32-3.29,3.2-6.64s-4.38-5.79-7.27-5.46-4.33,3.29-3.2,6.64S454.55,323.55,457.44,323.22Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427,338.56c-1-7.15-32.22-26.95-32.22-26.95s-6.93-2.78-4.63-7.63a35.61,35.61,0,0,0-3.34,2.16c-.72.52-1.4,1.06-2,1.61-9.31,8.06-9.32,18.65,0,26.72.63.55,1.31,1.08,2,1.61a36.88,36.88,0,0,0,3.1,2c1.06.62,2.17,1.19,3.31,1.73.91.43,1.86.84,2.82,1.21s1.93.73,2.93,1.06a60.78,60.78,0,0,0,9.33,2.24c.69.11,1.4.22,2.1.31a72.5,72.5,0,0,0,20.73-.35S426.07,343.27,427,338.56Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.52,338.56c-.95-7.15-32.21-26.95-32.21-26.95s-6.94-2.78-4.63-7.63a35.8,35.8,0,0,0-3.35,2.16c-.72.52-1.4,1.06-2,1.61-9.31,8.06-9.32,18.65,0,26.72.62.55,1.3,1.08,2,1.61a36.88,36.88,0,0,0,3.1,2c1.06.62,2.17,1.19,3.32,1.73.91.43,1.85.84,2.81,1.21s1.94.73,2.93,1.06a60.78,60.78,0,0,0,9.33,2.24c.7.11,1.4.22,2.1.31a72.57,72.57,0,0,0,20.74-.35S425.63,343.27,426.52,338.56Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.5,308.4c-11.66,6.73-12.14,17.47-1.42,24.54.45.3.93.59,1.42.88,12.16,7,31.87,7,44,0s12.16-18.4,0-25.42c-.49-.29-1-.56-1.52-.83C427.77,301.39,409.16,301.66,397.5,308.4Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.5,308.4c-11.66,6.73-12.14,17.47-1.42,24.54.45.3.93.59,1.42.88,12.16,7,31.87,7,44,0s12.16-18.4,0-25.42c-.49-.29-1-.56-1.52-.83C427.77,301.39,409.16,301.66,397.5,308.4Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 419.53,
    cy: 321.11,
    rx: 29.76,
    ry: 17.18,
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 419.53,
    cy: 321.11,
    rx: 29.76,
    ry: 17.18,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.49,313.75c11.62-6.71,30.46-6.71,42.09,0,4.75,2.74,7.55,6.19,8.42,9.75-.86,3.57-3.67,7-8.42,9.76-11.63,6.71-30.47,6.71-42.09,0-4.75-2.75-7.56-6.19-8.43-9.76C390.93,319.94,393.74,316.49,398.49,313.75Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.49,313.75c11.62-6.71,30.46-6.71,42.09,0,4.75,2.74,7.55,6.19,8.42,9.75-.86,3.57-3.67,7-8.42,9.76-11.63,6.71-30.47,6.71-42.09,0-4.75-2.75-7.56-6.19-8.43-9.76C390.93,319.94,393.74,316.49,398.49,313.75Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.27,326.28c0-.58,0-2.94,0-3.55,0-1.45-1-2.87-3.17-4.14l-.08,0c-4-2.31-8.12-2-11.8-1.08h0c-1.57.39-3.05.9-4.41,1.37a42.9,42.9,0,0,1-4.72,1.46h0a8.66,8.66,0,0,1-2.25.21,4.8,4.8,0,0,1-1.86-.49l.15-.11c.14-.1.3-.19.46-.29a10.26,10.26,0,0,1,1.25-.61,8.56,8.56,0,0,1,6.62-.15l3.81-3.85v-3.54a18.15,18.15,0,0,0-10.43-.38,22.54,22.54,0,0,0-3.32,1.15l-3.81-2.2-4.56,2.63v3.53l1.56.9a3.83,3.83,0,0,0-.67,2.06c0,.59,0,2.93,0,3.53,0,1.46,1.05,2.86,3.24,4.13a13.19,13.19,0,0,0,6.29,1.81h0c.42,0,.84,0,1.26,0a25,25,0,0,0,6.75-1.45l1.32-.46L416,330.57v3.54a18.71,18.71,0,0,0,14.71-.64l3.77,2.17,4.56-2.63v-3.53l-1.57-.9A4.16,4.16,0,0,0,438.27,326.28Zm-9.6-.3a9.53,9.53,0,0,1-1.06.53,9.78,9.78,0,0,1-7.44.11c3.56-1.26,6.54-2.36,9.08-1A6.42,6.42,0,0,1,428.67,326Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.22,317.47h0c-1.57.39-3.05.9-4.41,1.37a42.9,42.9,0,0,1-4.72,1.46h0a8.66,8.66,0,0,1-2.25.21,4.76,4.76,0,0,1-2.16-.65c-1.47-.84-1.68-2.08.45-3.48.14-.1.3-.19.46-.29a12.08,12.08,0,0,1,1.25-.62,8.65,8.65,0,0,1,6.62-.15l3.81-3.85a18.15,18.15,0,0,0-10.43-.38,22.54,22.54,0,0,0-3.32,1.15l-3.81-2.2-4.56,2.63,3.78,2.18,0,0c-3.83,2.9-3.9,5.92.4,8.41a13.41,13.41,0,0,0,6.29,1.81h0c.42,0,.84,0,1.26,0a24.66,24.66,0,0,0,6.75-1.46c4.37-1.46,7.91-3.18,10.86-1.48,2,1.14,1.42,2.57-.74,3.82a9.53,9.53,0,0,1-1.06.53,9.78,9.78,0,0,1-7.58.05l-4,4a18.72,18.72,0,0,0,14.71-.63l3.77,2.17,4.56-2.63-3.77-2.17c3.79-2.93,4.22-6.13-.2-8.72l-.08,0C431,316.24,426.9,316.54,423.22,317.47Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.22,317.47h0c-1.57.39-3.05.9-4.41,1.37a42.9,42.9,0,0,1-4.72,1.46h0a8.66,8.66,0,0,1-2.25.21,4.76,4.76,0,0,1-2.16-.65c-1.47-.84-1.68-2.08.45-3.48.14-.1.3-.19.46-.29a12.08,12.08,0,0,1,1.25-.62,8.65,8.65,0,0,1,6.62-.15l3.81-3.85a18.15,18.15,0,0,0-10.43-.38,22.54,22.54,0,0,0-3.32,1.15l-3.81-2.2-4.56,2.63,3.78,2.18,0,0c-3.83,2.9-3.9,5.92.4,8.41a13.41,13.41,0,0,0,6.29,1.81h0c.42,0,.84,0,1.26,0a24.66,24.66,0,0,0,6.75-1.46c4.37-1.46,7.91-3.18,10.86-1.48,2,1.14,1.42,2.57-.74,3.82a9.53,9.53,0,0,1-1.06.53,9.78,9.78,0,0,1-7.58.05l-4,4a18.72,18.72,0,0,0,14.71-.63l3.77,2.17,4.56-2.63-3.77-2.17c3.79-2.93,4.22-6.13-.2-8.72l-.08,0C431,316.24,426.9,316.54,423.22,317.47Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "400.12 312.68 404.71 310.6 408.49 312.25 404.67 310.05 400.12 312.68",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.27,311.25a21.37,21.37,0,0,1,9.79.33l-2.64,3.75,3.81-3.85A18.22,18.22,0,0,0,411.27,311.25Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,318.55l.08,0c4.42,2.59,4,5.79.2,8.72,3.35-3.66,2.75-6.21-.9-8.32s-8.3-2.07-11.18-1.52C426.9,316.54,431,316.24,435,318.55Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.3 327.31 438.19 329.53 434.51 332.11 439.07 329.48 435.3 327.31",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.61,326.51a9.83,9.83,0,0,1-7.26.63L416,330.57l4-4A9.78,9.78,0,0,0,427.61,326.51Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.05,320.31c-1.72.67-4.2.56-5.46-.52s-.47-2.35,1.5-3.4c-2.13,1.4-1.92,2.64-.45,3.48a4.76,4.76,0,0,0,2.16.65A8.66,8.66,0,0,0,414.05,320.31Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.85,314.89c-.32.28-3.06,2.84-1.85,5.39,1.28,2.73,5.3,4.47,8.54,4.83h0a13.41,13.41,0,0,1-6.29-1.81C400,320.81,400,317.79,403.85,314.89Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.45,303.75c-2.15-3.62-5.73-7-10.74-9.93-17.56-10.13-46-10.13-63.58,0-5,2.9-8.59,6.31-10.74,9.93H377v9.19h0c.32,6.39,4.69,12.72,13.13,17.59,17.56,10.14,46,10.14,63.58,0,8.44-4.87,12.85-11.21,13.17-17.59h0v-9.19Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.45,303.75c-2.15-3.62-5.73-7-10.74-9.93-17.56-10.13-46-10.13-63.58,0-5,2.9-8.59,6.31-10.74,9.93H377v9.19h0c.32,6.39,4.69,12.72,13.13,17.59,17.56,10.14,46,10.14,63.58,0,8.44-4.87,12.85-11.21,13.17-17.59h0v-9.19Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.92,286.22c-11.5,0-23,2.53-31.79,7.6-5,2.9-8.59,6.31-10.74,9.93H377v9.19h0c.32,6.39,4.69,12.72,13.13,17.59,8.78,5.07,20.29,7.6,31.79,7.6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.37,290.43a49.58,49.58,0,0,0-7.24,3.39c-5,2.9-8.59,6.31-10.74,9.93H377v9.19h0c.32,6.39,4.69,12.72,13.13,17.59a49.58,49.58,0,0,0,7.24,3.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.48,290.43a51,51,0,0,1,7.23,3.39c5,2.9,8.59,6.31,10.74,9.93h2.43v9.19h0c-.32,6.38-4.73,12.72-13.17,17.59a50,50,0,0,1-7.23,3.39Z",
    style: {
      fill: "#B42F53",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.13,285.4c-17.56,10.14-17.55,26.58,0,36.71,15.36,8.87,39.08,10,56.53,3.33h0l.7-.27a49,49,0,0,0,6.35-3.06c14.64-8.45,17.07-21.28,7.29-31.19h0a34.25,34.25,0,0,0-7.29-5.51C436.16,275.27,407.69,275.27,390.13,285.4Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.13,285.4c-17.56,10.14-17.55,26.58,0,36.71,15.36,8.87,39.08,10,56.53,3.33h0l.7-.27a49,49,0,0,0,6.35-3.06c14.64-8.45,17.07-21.28,7.29-31.19h0a34.25,34.25,0,0,0-7.29-5.51C436.16,275.27,407.69,275.27,390.13,285.4Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,290.92c.19.21,6.33,6.69,4.71,16-1.56,8.92-14,16.43-18.35,18.24a49,49,0,0,0,6.35-3.06C468.35,313.66,470.78,300.83,461,290.92Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.84,316.6c-.19-.22-6.33-6.69-4.7-16,1.55-8.92,14-16.43,18.35-18.23a49.78,49.78,0,0,0-6.36,3C375.49,293.86,373.06,306.69,382.84,316.6Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 421.94,
    cy: 303.72,
    rx: 41.79,
    ry: 24.13,
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 421.94,
    cy: 303.72,
    rx: 41.79,
    ry: 24.13,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.83,310.93c3.36-6.21,2.26-13.06-3.28-18.86A28.65,28.65,0,0,0,455,289a34.71,34.71,0,0,0-3.38-2.23c-.67-.39-1.36-.76-2.06-1.12,1.73,2.86,1.1,5.92-8.75,6.5-19.26,1.12,5.15,19.53,5.15,19.53S458.39,305.66,461.83,310.93Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.84,305.84c2.89-.33,4.33-3.3,3.2-6.64s-4.37-5.79-7.26-5.47-4.33,3.3-3.2,6.64S457,306.16,459.84,305.84Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.38,321.18c-.95-7.16-32.22-27-32.22-27s-6.93-2.78-4.63-7.63a33.75,33.75,0,0,0-3.34,2.17c-.73.52-1.4,1.05-2,1.6-9.3,8.06-9.32,18.65,0,26.72.63.55,1.31,1.09,2,1.61a33.89,33.89,0,0,0,3.1,2c1.06.62,2.17,1.2,3.31,1.73.91.43,1.86.84,2.82,1.22s1.93.73,2.93,1a61.69,61.69,0,0,0,9.33,2.25c.69.11,1.39.21,2.09.3a74.32,74.32,0,0,0,9.33.59,70.74,70.74,0,0,0,11.41-.94S428.48,325.88,429.38,321.18Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.93,321.18c-.95-7.16-32.21-27-32.21-27s-6.94-2.78-4.64-7.63a35,35,0,0,0-3.34,2.17c-.72.52-1.4,1.05-2,1.6-9.31,8.06-9.32,18.65,0,26.72.63.55,1.31,1.09,2,1.61a36.88,36.88,0,0,0,3.1,2c1.06.62,2.17,1.2,3.31,1.73.91.43,1.86.84,2.82,1.22s1.93.73,2.93,1a62,62,0,0,0,9.33,2.25c.69.11,1.4.21,2.1.3a74.08,74.08,0,0,0,9.33.59,70.93,70.93,0,0,0,11.41-.94S428,325.88,428.93,321.18Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.91,291c-11.67,6.73-12.14,17.48-1.43,24.54.46.3.94.6,1.43.88,12.16,7,31.87,7,44,0s12.16-18.4,0-25.42c-.49-.29-1-.56-1.53-.82C430.18,284,411.57,284.28,399.91,291Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.91,291c-11.67,6.73-12.14,17.48-1.43,24.54.46.3.94.6,1.43.88,12.16,7,31.87,7,44,0s12.16-18.4,0-25.42c-.49-.29-1-.56-1.53-.82C430.18,284,411.57,284.28,399.91,291Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 421.94,
    cy: 303.72,
    rx: 29.76,
    ry: 17.18,
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 421.94,
    cy: 303.72,
    rx: 29.76,
    ry: 17.18,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.9,296.36c11.62-6.71,30.46-6.71,42.08,0,4.76,2.75,7.56,6.19,8.43,9.76-.87,3.57-3.67,7-8.43,9.75-11.62,6.71-30.46,6.71-42.08,0-4.76-2.74-7.56-6.19-8.43-9.75C393.34,302.55,396.14,299.11,400.9,296.36Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.9,296.36c11.62-6.71,30.46-6.71,42.08,0,4.76,2.75,7.56,6.19,8.43,9.76-.87,3.57-3.67,7-8.43,9.75-11.62,6.71-30.46,6.71-42.08,0-4.76-2.74-7.56-6.19-8.43-9.75C393.34,302.55,396.14,299.11,400.9,296.36Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.68,308.9c0-.58,0-2.95,0-3.56,0-1.45-1-2.86-3.18-4.13l-.07,0c-4-2.31-8.13-2-11.8-1.08h0c-1.56.4-3,.91-4.4,1.37a42.33,42.33,0,0,1-4.73,1.46h0a8.28,8.28,0,0,1-2.25.21,4.8,4.8,0,0,1-1.86-.49l.14-.1.47-.29a10.36,10.36,0,0,1,1.25-.62,8.58,8.58,0,0,1,6.61-.15l3.82-3.85V294.1a18.16,18.16,0,0,0-10.43-.38,20.44,20.44,0,0,0-3.32,1.15l-3.81-2.21-4.56,2.63v3.53l1.56.9a3.89,3.89,0,0,0-.67,2.06c0,.59,0,2.94,0,3.53,0,1.46,1,2.87,3.24,4.13a13.19,13.19,0,0,0,6.29,1.81h0c.42,0,.84,0,1.26,0a25,25,0,0,0,6.75-1.46l1.32-.45-3.84,3.85v3.53a18.71,18.71,0,0,0,14.71-.64l3.77,2.18,4.55-2.63V312.1l-1.56-.91A4.11,4.11,0,0,0,440.68,308.9Zm-9.6-.31a10.47,10.47,0,0,1-1.06.53,9.81,9.81,0,0,1-7.45.11c3.57-1.26,6.55-2.36,9.08-1A5.1,5.1,0,0,1,431.08,308.59Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.63,300.08h0c-1.56.4-3,.91-4.4,1.37a42.33,42.33,0,0,1-4.73,1.46h0a8.28,8.28,0,0,1-2.25.21,4.83,4.83,0,0,1-2.17-.64c-1.46-.85-1.68-2.09.45-3.49l.47-.28a9.07,9.07,0,0,1,1.25-.62,8.58,8.58,0,0,1,6.61-.15l3.82-3.85a18.16,18.16,0,0,0-10.43-.38,20.44,20.44,0,0,0-3.32,1.15l-3.81-2.21-4.56,2.63,3.77,2.18,0,0c-3.83,2.91-3.91,5.92.4,8.41a13.19,13.19,0,0,0,6.29,1.81h0c.42,0,.84,0,1.26,0a25,25,0,0,0,6.75-1.45c4.37-1.46,7.91-3.19,10.85-1.49,2,1.14,1.43,2.57-.73,3.82a10.47,10.47,0,0,1-1.06.53,9.79,9.79,0,0,1-7.58.06l-4,4a18.71,18.71,0,0,0,14.71-.64l3.77,2.17,4.55-2.62-3.77-2.18c3.79-2.93,4.23-6.12-.2-8.71l-.07,0C433.43,298.85,429.3,299.15,425.63,300.08Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.63,300.08h0c-1.56.4-3,.91-4.4,1.37a42.33,42.33,0,0,1-4.73,1.46h0a8.28,8.28,0,0,1-2.25.21,4.83,4.83,0,0,1-2.17-.64c-1.46-.85-1.68-2.09.45-3.49l.47-.28a9.07,9.07,0,0,1,1.25-.62,8.58,8.58,0,0,1,6.61-.15l3.82-3.85a18.16,18.16,0,0,0-10.43-.38,20.44,20.44,0,0,0-3.32,1.15l-3.81-2.21-4.56,2.63,3.77,2.18,0,0c-3.83,2.91-3.91,5.92.4,8.41a13.19,13.19,0,0,0,6.29,1.81h0c.42,0,.84,0,1.26,0a25,25,0,0,0,6.75-1.45c4.37-1.46,7.91-3.19,10.85-1.49,2,1.14,1.43,2.57-.73,3.82a10.47,10.47,0,0,1-1.06.53,9.79,9.79,0,0,1-7.58.06l-4,4a18.71,18.71,0,0,0,14.71-.64l3.77,2.17,4.55-2.62-3.77-2.18c3.79-2.93,4.23-6.12-.2-8.71l-.07,0C433.43,298.85,429.3,299.15,425.63,300.08Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "402.52 295.29 407.12 293.21 410.89 294.87 407.08 292.66 402.52 295.29",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.68,293.86a21.37,21.37,0,0,1,9.79.33L420.83,298l3.81-3.85A18.15,18.15,0,0,0,413.68,293.86Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.43,301.16l.07,0c4.43,2.59,4,5.78.2,8.71,3.36-3.66,2.76-6.21-.89-8.31s-8.3-2.08-11.18-1.53C429.3,299.15,433.43,298.85,437.43,301.16Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.7 309.92 440.59 312.14 436.92 314.73 441.47 312.1 437.7 309.92",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,309.12a9.77,9.77,0,0,1-7.26.63l-4.32,3.44,4-4A9.79,9.79,0,0,0,430,309.12Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.46,302.92c-1.73.68-4.2.56-5.46-.52s-.47-2.34,1.49-3.4c-2.13,1.4-1.91,2.64-.45,3.49a4.83,4.83,0,0,0,2.17.64A8.28,8.28,0,0,0,416.46,302.92Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.26,297.5c-.32.29-3.06,2.84-1.85,5.39,1.28,2.73,5.3,4.48,8.54,4.83h0a13.19,13.19,0,0,1-6.29-1.81C402.35,303.42,402.43,300.41,406.26,297.5Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.2,288.73c-2.15-3.63-5.73-7-10.74-9.93-17.56-10.14-46-10.14-63.58,0-5,2.89-8.59,6.3-10.74,9.93h-2.42v9.19h0c.32,6.38,4.69,12.71,13.13,17.59,17.56,10.13,46,10.13,63.58,0,8.44-4.88,12.85-11.21,13.17-17.6h0v-9.19Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.2,288.73c-2.15-3.63-5.73-7-10.74-9.93-17.56-10.14-46-10.14-63.58,0-5,2.89-8.59,6.3-10.74,9.93h-2.42v9.19h0c.32,6.38,4.69,12.71,13.13,17.59,17.56,10.13,46,10.13,63.58,0,8.44-4.88,12.85-11.21,13.17-17.6h0v-9.19Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.67,271.2c-11.5,0-23,2.53-31.79,7.6-5,2.89-8.59,6.3-10.74,9.93h-2.42v9.19h0c.32,6.38,4.69,12.71,13.13,17.59,8.78,5.06,20.29,7.6,31.79,7.6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.12,275.41a49.58,49.58,0,0,0-7.24,3.39c-5,2.89-8.59,6.3-10.74,9.93h-2.42v9.19h0c.32,6.38,4.69,12.71,13.13,17.59a49.54,49.54,0,0,0,7.24,3.38Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.23,275.41a50,50,0,0,1,7.23,3.39c5,2.89,8.59,6.3,10.74,9.93h2.43v9.19h0c-.32,6.39-4.73,12.72-13.17,17.6a49.91,49.91,0,0,1-7.23,3.38Z",
    style: {
      fill: "#B42F53",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.88,270.38c-17.56,10.14-17.55,26.57,0,36.71,15.36,8.87,39.08,10,56.53,3.32h0l.7-.27a49,49,0,0,0,6.35-3.05c14.64-8.46,17.07-21.29,7.3-31.19h0a33.92,33.92,0,0,0-7.29-5.51C426.91,260.24,398.44,260.24,380.88,270.38Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.88,270.38c-17.56,10.14-17.55,26.57,0,36.71,15.36,8.87,39.08,10,56.53,3.32h0l.7-.27a49,49,0,0,0,6.35-3.05c14.64-8.46,17.07-21.29,7.3-31.19h0a33.92,33.92,0,0,0-7.29-5.51C426.91,260.24,398.44,260.24,380.88,270.38Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.76,275.9c.18.21,6.32,6.69,4.7,16-1.56,8.92-14,16.43-18.35,18.23a49,49,0,0,0,6.35-3.05C459.1,298.63,461.53,285.8,451.76,275.9Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.59,301.57c-.19-.21-6.33-6.69-4.7-16,1.55-8.92,14-16.43,18.35-18.23a47.23,47.23,0,0,0-6.36,3.05C366.24,278.83,363.81,291.67,373.59,301.57Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 412.69,
    cy: 288.7,
    rx: 41.79,
    ry: 24.13,
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 412.69,
    cy: 288.7,
    rx: 41.79,
    ry: 24.13,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.58,295.9c3.36-6.2,2.26-13-3.28-18.85a28.7,28.7,0,0,0-3.54-3.11,38.81,38.81,0,0,0-3.38-2.23c-.67-.39-1.36-.76-2.06-1.11,1.73,2.86,1.1,5.92-8.75,6.49-19.26,1.13,5.15,19.54,5.15,19.54S449.14,290.63,452.58,295.9Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.59,290.81c2.89-.32,4.33-3.29,3.2-6.64s-4.37-5.79-7.26-5.46-4.33,3.29-3.2,6.64S447.7,291.14,450.59,290.81Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.13,306.15c-.95-7.15-32.22-26.95-32.22-26.95s-6.93-2.78-4.63-7.63a35.61,35.61,0,0,0-3.34,2.16c-.73.52-1.4,1.06-2,1.61-9.3,8.06-9.32,18.65,0,26.72.63.55,1.31,1.08,2,1.61a31.87,31.87,0,0,0,3.1,2c1.06.63,2.17,1.2,3.31,1.74.91.43,1.86.84,2.82,1.21s1.93.73,2.93,1.06a60.5,60.5,0,0,0,9.33,2.24c.69.11,1.39.22,2.09.31a72.47,72.47,0,0,0,9.33.58,70.74,70.74,0,0,0,11.41-.94S419.23,310.86,420.13,306.15Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.68,306.15c-.95-7.15-32.21-26.95-32.21-26.95s-6.94-2.78-4.64-7.63a37,37,0,0,0-3.34,2.16c-.72.52-1.4,1.06-2,1.61-9.31,8.06-9.32,18.65,0,26.72.63.55,1.31,1.08,2,1.61a34.5,34.5,0,0,0,3.1,2c1.06.63,2.17,1.2,3.31,1.74.91.43,1.86.84,2.82,1.21s1.93.73,2.93,1.06a60.78,60.78,0,0,0,9.33,2.24c.7.11,1.4.22,2.1.31a72.25,72.25,0,0,0,9.33.58,70.93,70.93,0,0,0,11.41-.94S418.79,310.86,419.68,306.15Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.66,276c-11.67,6.73-12.14,17.47-1.43,24.54.46.29.94.59,1.43.88,12.16,7,31.87,7,44,0s12.16-18.4,0-25.42c-.49-.29-1-.56-1.53-.83C420.93,269,402.32,269.25,390.66,276Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.66,276c-11.67,6.73-12.14,17.47-1.43,24.54.46.29.94.59,1.43.88,12.16,7,31.87,7,44,0s12.16-18.4,0-25.42c-.49-.29-1-.56-1.53-.83C420.93,269,402.32,269.25,390.66,276Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 412.69,
    cy: 288.7,
    rx: 29.76,
    ry: 17.18,
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 412.69,
    cy: 288.7,
    rx: 29.76,
    ry: 17.18,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.65,281.34c11.62-6.71,30.46-6.71,42.08,0,4.76,2.74,7.56,6.19,8.43,9.75-.87,3.57-3.67,7-8.43,9.76-11.62,6.71-30.46,6.71-42.08,0-4.76-2.75-7.56-6.19-8.43-9.76C384.09,287.52,386.89,284.08,391.65,281.34Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.65,281.34c11.62-6.71,30.46-6.71,42.08,0,4.76,2.74,7.56,6.19,8.43,9.75-.87,3.57-3.67,7-8.43,9.76-11.62,6.71-30.46,6.71-42.08,0-4.76-2.75-7.56-6.19-8.43-9.76C384.09,287.52,386.89,284.08,391.65,281.34Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.43,293.87c0-.58,0-2.94,0-3.55,0-1.46-1-2.87-3.18-4.14l-.07-.05c-4-2.3-8.13-2-11.8-1.08h0c-1.56.39-3,.9-4.4,1.37a42.33,42.33,0,0,1-4.73,1.46h0a8.69,8.69,0,0,1-2.25.21,4.8,4.8,0,0,1-1.86-.49l.14-.11.47-.29a12.08,12.08,0,0,1,1.25-.62,8.63,8.63,0,0,1,6.61-.15l3.82-3.85v-3.53a18.16,18.16,0,0,0-10.43-.38,22.54,22.54,0,0,0-3.32,1.15l-3.81-2.2-4.56,2.63v3.53l1.56.9a3.83,3.83,0,0,0-.67,2.06c0,.59,0,2.93,0,3.53,0,1.46,1,2.86,3.24,4.13a13.41,13.41,0,0,0,6.29,1.81h0c.42,0,.84,0,1.26,0a24.66,24.66,0,0,0,6.75-1.46l1.32-.45-3.84,3.85v3.53a18.67,18.67,0,0,0,14.71-.63l3.77,2.17,4.55-2.63v-3.53l-1.56-.9A4.16,4.16,0,0,0,431.43,293.87Zm-9.6-.3a10.47,10.47,0,0,1-1.06.53,9.81,9.81,0,0,1-7.45.11c3.57-1.26,6.55-2.36,9.08-1C422.23,293.32,422,293.45,421.83,293.57Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.38,285.05h0c-1.56.39-3,.9-4.4,1.37a42.33,42.33,0,0,1-4.73,1.46h0a8.69,8.69,0,0,1-2.25.21,4.84,4.84,0,0,1-2.17-.65c-1.46-.84-1.68-2.08.45-3.48l.47-.29a10.36,10.36,0,0,1,1.25-.62,8.63,8.63,0,0,1,6.61-.15l3.82-3.85a18.16,18.16,0,0,0-10.43-.38,22.54,22.54,0,0,0-3.32,1.15l-3.81-2.2-4.56,2.63,3.77,2.18,0,0c-3.83,2.9-3.91,5.92.4,8.41a13.41,13.41,0,0,0,6.29,1.81h0c.42,0,.84,0,1.26,0a24.66,24.66,0,0,0,6.75-1.46c4.37-1.46,7.91-3.18,10.85-1.48,2,1.14,1.43,2.57-.73,3.82a10.47,10.47,0,0,1-1.06.53,9.78,9.78,0,0,1-7.58,0l-4,4a18.67,18.67,0,0,0,14.71-.64l3.77,2.18,4.55-2.63-3.77-2.17c3.79-2.94,4.23-6.13-.2-8.72l-.07-.05C424.18,283.83,420.05,284.13,416.38,285.05Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416.38,285.05h0c-1.56.39-3,.9-4.4,1.37a42.33,42.33,0,0,1-4.73,1.46h0a8.69,8.69,0,0,1-2.25.21,4.84,4.84,0,0,1-2.17-.65c-1.46-.84-1.68-2.08.45-3.48l.47-.29a10.36,10.36,0,0,1,1.25-.62,8.63,8.63,0,0,1,6.61-.15l3.82-3.85a18.16,18.16,0,0,0-10.43-.38,22.54,22.54,0,0,0-3.32,1.15l-3.81-2.2-4.56,2.63,3.77,2.18,0,0c-3.83,2.9-3.91,5.92.4,8.41a13.41,13.41,0,0,0,6.29,1.81h0c.42,0,.84,0,1.26,0a24.66,24.66,0,0,0,6.75-1.46c4.37-1.46,7.91-3.18,10.85-1.48,2,1.14,1.43,2.57-.73,3.82a10.47,10.47,0,0,1-1.06.53,9.78,9.78,0,0,1-7.58,0l-4,4a18.67,18.67,0,0,0,14.71-.64l3.77,2.18,4.55-2.63-3.77-2.17c3.79-2.94,4.23-6.13-.2-8.72l-.07-.05C424.18,283.83,420.05,284.13,416.38,285.05Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "393.27 280.27 397.87 278.19 401.64 279.84 397.83 277.64 393.27 280.27",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.43,278.84a21.37,21.37,0,0,1,9.79.33l-2.64,3.75,3.81-3.85A18.22,18.22,0,0,0,404.43,278.84Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.18,286.13l.07.05c4.43,2.59,4,5.78.2,8.72,3.36-3.66,2.76-6.21-.89-8.32s-8.3-2.07-11.18-1.53C420.05,284.13,424.18,283.83,428.18,286.13Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.45 294.9 431.34 297.12 427.67 299.7 432.22 297.07 428.45 294.9",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.77,294.1a9.83,9.83,0,0,1-7.26.63l-4.32,3.43,4-4A9.78,9.78,0,0,0,420.77,294.1Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.21,287.9c-1.73.67-4.2.56-5.46-.52s-.47-2.35,1.49-3.4c-2.13,1.4-1.91,2.64-.45,3.48a4.84,4.84,0,0,0,2.17.65A8.69,8.69,0,0,0,407.21,287.9Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,282.48c-.32.28-3.06,2.84-1.85,5.39,1.28,2.73,5.3,4.47,8.54,4.83h0a13.41,13.41,0,0,1-6.29-1.81C393.1,288.4,393.18,285.38,397,282.48Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.09,348.92s10.42,15.94,12.37,22.64c2,7,4.33,8.94,4.9,16.9.13,1.73,0,5.29.11,6.7a2.09,2.09,0,0,0,2.44,2.1c3.29-.07,7.15-7,8.16-13.83s1.22-21.75,1-23.5a9.77,9.77,0,0,0-2.15-4.72,15.1,15.1,0,0,0-2-2.24c-1.76-2.85-3.62-8.59-5.45-12.44Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.75,365a7.48,7.48,0,0,1,1.38,2.12c.41,1.4-1.76,6.77-2.64,8.75a11.36,11.36,0,0,0-.47,8.56c1.24,4.48.22,9.28-1.89,13.67a32.1,32.1,0,0,1-13.41,13.62c-7.08,4-10.63.87-10.63.87s-3.2-3.07-2.13-4.86S403.75,365,403.75,365Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.92,353c.23-.06.62-.22,1.39.35.28.22,2.46,3.25,4,4.75s5.37,4.17,6.42,6.94c-.47,5.91-4.87,10.94-4.44,16.33s1.75,11.46-4.95,19.67-15,10.76-18.39,9.75-3.88-4.25-1.08-11.23c3-7.42,2.75-22,2.75-22a46.15,46.15,0,0,0-.59-6.09c-.29-1.93-1.34-3.84-1.93-5.72a4.3,4.3,0,0,1-.24-2.73,4.64,4.64,0,0,1,1.9-2,20.38,20.38,0,0,1,3.88-2.33,6.91,6.91,0,0,1,4.45-.46,31.78,31.78,0,0,0,3.11,1.08,4,4,0,0,0,3.85-1.6,3.29,3.29,0,0,0,.25-3.86A9.12,9.12,0,0,0,391.92,353Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,394.83s-4.65-5.6-13.34-3.62-10.68,7-11.41,9.82c-.87,3.38-1.22,9.24,2.73,10,4.28.83,8.65-.7,14.9-5.74S398,394.83,398,394.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.37,369.56a.93.93,0,0,1-.79.17c-1.5-.37-8.95-.23-12.21,4.45-.63-.3-.7-1.09-.27-2.33,4.14-4.09,11.18-4.25,13-3.81a.82.82,0,0,1,.6,1.06A.88.88,0,0,1,390.37,369.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.64,379.34a2.63,2.63,0,0,1-.05-2.45c4.19-3.6,10.73-3.73,12.47-3.31a.84.84,0,0,1,.6,1.06.94.94,0,0,1-.32.46.93.93,0,0,1-.79.17C388.09,374.91,381,375.05,377.64,379.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.78,391.63a4.9,4.9,0,0,1,.39-3.33c4.16-3.92,11-4.08,12.83-3.64a.83.83,0,0,1,.6,1,.93.93,0,0,1-1.12.64C387.9,386,379.7,386.14,376.78,391.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.31,380.64a.93.93,0,0,1-.79.17c-1.49-.36-8.78-.22-12.1,4.3a3,3,0,0,1,.14-2.68c4.19-3.61,10.73-3.74,12.47-3.31a.84.84,0,0,1,.6,1.06A1,1,0,0,1,390.31,380.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.2,374.6s.28,16.48.41,29.22c.08,9.25-6.6,13.88-11.95,20.35-1.17,1.41-3.84,4-4.8,5.18a2.13,2.13,0,0,0,.35,3.31c2.57,2.26,13.11,2.54,18.85-2s10.78-13.86,14.17-17.44a54.59,54.59,0,0,0,3.6-4.17c1.09-1.4.73-2.69.78-4.23,0-.74-.16-2.77-.16-2.77.68-3.64,2.68-14.8,3.71-18.36Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.11,418.32a7.73,7.73,0,0,1-.17,2.63c-.54,1.42-5.76,4.62-7.75,5.74s-4.14,2.68-5.8,6.91c-1.77,4.52-5.66,7.93-10.21,10.34a34.54,34.54,0,0,1-19.91,3.26c-8.5-1-9.53-5.77-9.53-5.77s-.77-4.53,1.27-5.38S387.11,418.32,387.11,418.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.71,401c.24.09.67.2,1,1.14.11.36,0,4.24.4,6.46.4,2.37,1.91,6.78,1.05,9.75-4.13,4.68-11,6.22-14.05,11s-5.75,10.7-16.58,13.51-19.42-.09-21.67-3-.61-5.95,6.17-10.1c7.19-4.42,16.17-16.81,16.18-16.81a51,51,0,0,0,3.34-5.48c1-1.81,1.29-4,2-6A4.57,4.57,0,0,1,364,399a5,5,0,0,1,2.88-.55,21.58,21.58,0,0,1,4.75.41,7.29,7.29,0,0,1,4.05,2.33,32.44,32.44,0,0,0,1.93,2.81,4.26,4.26,0,0,0,4.27,1,3.47,3.47,0,0,0,2.64-3.1A8.24,8.24,0,0,0,384.71,401Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.41,439.85s-.4-7.55-9-11.2S341,428,338.6,429.94c-2.86,2.32-6.86,7-4,10.09,3.09,3.32,7.74,4.7,16.2,4.28S363.41,439.85,363.41,439.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.94,414a1,1,0,0,1-.78-.34c-1-1.23-7.4-5.66-13.11-3.72-.35-.64.09-1.35,1.24-2.12,6.08-.92,12.13,3.25,13.37,4.73a.84.84,0,0,1-.16,1.25A1,1,0,0,1,372.94,414Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,414.42a2.79,2.79,0,0,1,1.51-2.09c5.8-.47,11.42,3.42,12.61,4.84a.85.85,0,0,1-.15,1.25,1,1,0,0,1-1.35-.15C367.64,417.08,361.59,412.88,356,414.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.55,424.23a5.12,5.12,0,0,1,2.43-2.56c6-.76,11.89,3.31,13.12,4.77a.85.85,0,0,1-.15,1.25,1,1,0,0,1-.56.2,1,1,0,0,1-.78-.34C360.51,426.25,353.47,421.39,347.55,424.23Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.91,423.25a1,1,0,0,1-.78-.34c-1-1.21-7.27-5.55-12.93-3.77A3.2,3.2,0,0,1,354,417c5.81-.48,11.42,3.41,12.61,4.83a.86.86,0,0,1-.15,1.26A1.07,1.07,0,0,1,365.91,423.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.32,247.65S360.87,267.84,346,285.44c-5.33,6.3-8.55,11.72-1.54,26.67,5.39,11.5,14.23,24,22.61,38.81l65.1-88Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.32,247.65S360.87,267.84,346,285.44c-5.33,6.3-8.55,11.72-1.54,26.67,5.39,11.5,14.23,24,22.61,38.81l65.1-88Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.91,348.92C376.22,338.26,407,279,407,279l-1.59-.15c-8.77-3.16-13-14.48-13-14.48-.73,4.68,1.6,11.13,4.69,14.47-4.58,3.84-14.93,12.56-30.81,26.19-2.76,2.37-8.36,6.89-7.46,15C360,330.62,361,341,361,341Z",
    style: {
      fill: "#B42F53",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.27,247.65h0l70.38,5.84c.56,8.36-.92,22.41-6.61,32.25-4.12,7.14-8.91,11.63-26.08,22.16-16,9.82-30.35,18.07-34,20.37-2.76,1.72-1.8,8.1-2.17,15.7-.37,8-.92,12.43-4.14,29.61-1.57,8.35-3.27,15.58-3.27,15.58s-13.72,2.46-24.37-2.37c0,0-1.1-41.66-1.24-51.89-.12-8.74-1.24-16.81,5-23.75,5.34-5.95,38.66-32.27,38.66-32.27S388.35,263.64,393.27,247.65Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.27,247.65h0l70.38,5.84c.56,8.36-.92,22.41-6.61,32.25-4.12,7.14-8.91,11.63-26.08,22.16-16,9.82-30.35,18.07-34,20.37-2.76,1.72-1.8,8.1-2.17,15.7-.37,8-.92,12.43-4.14,29.61-1.57,8.35-3.27,15.58-3.27,15.58s-13.72,2.46-24.37-2.37c0,0-1.1-41.66-1.24-51.89-.12-8.74-1.24-16.81,5-23.75,5.34-5.95,38.66-32.27,38.66-32.27S388.35,263.64,393.27,247.65Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.37,252.8l-1-.08c.38,11.49-.62,20.3-8.32,29.29-5.5-3.2-4.63-6.57-3.06-12.58.47-1.82,1-3.87,1.42-6.18A59.07,59.07,0,0,0,445.5,252l-1-.09a58.15,58.15,0,0,1-1,11.18c-.41,2.27-.94,4.3-1.41,6.1-1.57,6-2.6,10,3.35,13.57a56,56,0,0,1-6.33,6c-11.74,9.59-28.45,21.06-38.44,27.91-3.49,2.39-6.25,4.28-7.66,5.32-5.77,4.23-5.79,6.51-4.9,16.62.77,8.84-3.33,38.8-5.63,51.11l1-.07c2.33-12.55,6.38-42.29,5.6-51.13-.89-10.22-.68-11.94,4.51-15.75,1.4-1,4.16-2.91,7.64-5.3,10-6.86,26.73-18.34,38.5-28C454.12,277.69,455.84,267.36,455.37,252.8Z",
    style: {
      fill: "#B42F53",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409,161.44c-15.7-1.15-20.93,13.12-24.45,25.79-1.23,4.44-7.29,25.23-7.29,25.23S360.75,209,352.89,206c-4.56-1.74-6.59-3.91-8-7.54-2-5.14-2.37-8.05-3.24-9s-6.75-4.36-8.81-6.33-3.09-1.31-5.5-1.35c-2.91-.06-13.85,1.52-13.61,2.33a4.49,4.49,0,0,0,3.84,3.75c2.25.38,8.25-.22,8.25-.22s-.91,2.78-1.4,4,0,1.88,2.3,4.31a3,3,0,0,0-.91,2.26,6.61,6.61,0,0,0,1.77,2.9,3.07,3.07,0,0,0-.75,1.82c0,1.07,1.72,3.19,3.52,4.86a34.77,34.77,0,0,0,4.43,7.22c1.91,2.25,4,2.63,6.31,3,2.64.44,4.28,1.48,8.46,3.6s25.13,12.89,32.81,14.63,9.83-.19,12.09-5.7c4.31-10.49,12.82-27.89,16.14-39.28Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.35,160.54c-6.82-.52-14.87-.87-20.29,10.59S379,204.72,379,204.72s2.63,4.2,10.94,8.13,11.89,2.54,11.89,2.54l9.45-23.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.22,212.46a22.73,22.73,0,0,1,10.91,6.32c-1.86-3.39-5.46-7.36-10.18-8.81Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.13,191.54a10.28,10.28,0,0,1-5.64-3.54c-1.36-1.79-2.74-3.87-3.42-3.62-1.14.4-2.4,3.41-.45,6.52s4.88,6.11,5.35,7,.56,3.4.56,5.35a9.5,9.5,0,0,0,6.8,8.52,8.83,8.83,0,0,1-5.89-2.86c-3-2.94-2.25-7.37-2.5-9.26s-.3-2.26-2.52-4.77-4.63-5.21-3.49-9,2.72-2.81,3.5-2S335.32,190.52,339.13,191.54Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.79,187.58l2.48.2-.45.8a2.91,2.91,0,0,0-2.82,1.33Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.69,195.89c.74.83,3.19,3.24,3.68,3.73s1.56-.14,1.77-1.54a4.52,4.52,0,0,0-.55-3.33,5,5,0,0,1,1.13,3.36c-.21,1.81-1.2,2.43-1.93,2.49S328.28,197.64,326.69,195.89Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.55,201.05c.54.63,1.44,1.35,3,3,.9,1,1.43,1.65,2.11,1.27s1.32-2.38.59-3.72a11.22,11.22,0,0,0-1.52-2.17l.47-.47a8.73,8.73,0,0,1,2.1,3.57c.38,1.82-.73,3.79-1.64,3.65s-1.4-.72-2.63-2.18S327.55,201.05,327.55,201.05Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.18,205.75c.31.45.49,1.66-.31,2a1.93,1.93,0,0,1-1.55,0,1.62,1.62,0,0,0,1.82.44c1-.44,1-1.64.85-2.56Z",
    style: {
      fill: "#af6152"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M391,190.45c.72-20.3,9.11-28.61,19.39-29.91,0,0,12.58,1,20.79,2.13,10,1.33,19.93,5.13,22.76,6.1,4,1.8,9.78,11.79,10.66,26.1.63,10.16,2.32,23.09,1.12,41.12-.78,11.75-.92,20.72-2.87,36.18-14,5.54-60.33.23-72.52-23.22,1.25-3.57,1.54-15.61,1.35-22.43S390.74,196.84,391,190.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.73,152.93c.27-5.74,5.16-12.28,7.08-17.49,1.86-5,2.87-8.87,2.05-13.28-.48-2.61-2.57-6-4.61-6.49,1.07-10.06-6.82-13.71-10.83-14.16a42,42,0,0,1-5.58-.86c-2.23-.63-2.91-2.27-4.8-3.52-3.24-2.14-8.2-1.6-9.63,2.41-2.27-2.29-4.92-1.9-7.89-.75a5.27,5.27,0,0,0-3.3,6.41c-4.38-1.8-7.8,1.55-7.88,4-.06,1.81.5,3.27-.47,5-1.1,2-3.58,2.23-4.51.87-.12,2.58,1.1,4.38,3.83,3.91a5.77,5.77,0,0,0-.13,4.91,5.25,5.25,0,0,0,5.17,3c.46,1.36.67,2.62,1.69,3.71a9.1,9.1,0,0,0,3.58,2.52c4.39,1.48,9.06,1.57,13.64,2l5.44.46c.32,0,1.93-.07,2.16.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.66,144.83c-3.67,2.84-6.65.61-6.65.61L435.54,164c-2.13,8.3-15.53,11.28-20.73,9.63s-4.94-4.65-2.27-9.48l-.71-3a54.69,54.69,0,0,1-6.72.51c-4.49-.07-8.24-3.24-10.07-7.87a49.93,49.93,0,0,1-2.84-18.85,16.19,16.19,0,0,0-.32-4.66c-.92-4-.47-6.53.17-10.1,4.38-4.5,15.44-7.19,26.67-2.09-.45,6.37,2.57,11,7.38,12.83,0,1.71.3,6,3.06,5.57,2-.3,1.81-2.81,3.59-5.26s6.47-3.61,8.71-.59C444.6,134.83,443.68,141.72,439.66,144.83Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.83,128.34l13.69,2a5.32,5.32,0,0,0-1.66,2.36L420,131.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.84,130.06a4.24,4.24,0,0,0,1.05,1.92,1.88,1.88,0,0,1,.42.68,39.69,39.69,0,0,0,1.77,5.3,6.53,6.53,0,0,0,6.07,3.73,7.75,7.75,0,0,0,1.91-.21l.14,0a4.63,4.63,0,0,0,1.49-.67l.08-.06.13-.09.15-.12.14-.12.15-.15.15-.15a4.19,4.19,0,0,0,.26-.33,6.48,6.48,0,0,0,1-2.07c.57-1.89,0-4.48,1.3-4.8a.45.45,0,0,1,.16,0h.17c1.8,0,2,2.82,3.28,4.83a7.86,7.86,0,0,0,7.25,4h.51l.41,0a6.2,6.2,0,0,0,.93-.16l.29-.07.27-.1a1.27,1.27,0,0,0,.18-.06,4.44,4.44,0,0,0,1-.54l.32-.26a4.07,4.07,0,0,0,.53-.57,5.45,5.45,0,0,0,.89-1.94c.38-1.43.13-4,.22-5.3a2.1,2.1,0,0,1,.17-.77,3.12,3.12,0,0,0,.57-1.89,2,2,0,0,0-1.35-1.61l-1-.11c-3.12-.31-7.12-.39-9.41.31-2.87.89-3.77,1.88-5.45,1.89s-2.71-1-5.66-1.86c-2.34-.7-6-.6-8.86-.28l-.87.11C388.14,128.47,387.7,129.23,387.84,130.06Zm19.94,1.49a2.12,2.12,0,0,1,.76-.72.42.42,0,0,1,.14-.09l.08-.05a3.58,3.58,0,0,1,.39-.21l.37-.17a11.54,11.54,0,0,1,1.22-.44l.49-.13a10.86,10.86,0,0,1,1.29-.23l.3,0c2.85-.29,4.75.36,5.5.94s.91,3.35.86,4.75v.1s0,.07,0,.11,0,.36,0,.57,0,.23,0,.35v0c0,.19-.06.38-.1.59h0a1.94,1.94,0,0,0-.05.2.56.56,0,0,1,0,.12l0,.14-.06.17a1.46,1.46,0,0,1-.07.19,1.67,1.67,0,0,1-.08.2,1.86,1.86,0,0,1-.1.2,3.94,3.94,0,0,1-3.8,2.08,6.32,6.32,0,0,1-4.58-1.61h0a7.39,7.39,0,0,1-1.82-2.81C407.79,134.21,407.34,132.4,407.78,131.55Zm-17.15-1.08a2.23,2.23,0,0,1,.65-.47l.05,0,.3-.13.19-.07.15-.05.1,0h0l.15,0a5.8,5.8,0,0,1,.65-.12,2.2,2.2,0,0,1,.36,0l.21,0,.17,0h.78c.42,0,.86,0,1.35.1,2.08.26,4.35,1.18,5,2s.77,2.65.7,4.21a7.31,7.31,0,0,1-.13,1.05.24.24,0,0,1,0,.08s0,.07,0,.11,0,0,0,.07l0,.13-.08.26a2,2,0,0,0-.08.22l0,.08-.06.15a.54.54,0,0,1-.07.13,0,0,0,0,1,0,0c-.58,1.16-1.76,2.18-4.1,2.13a5.34,5.34,0,0,1-2.26-.5c-2.2-1-3-3.42-3.35-4.52C390.77,133.81,390.08,131.08,390.63,130.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.83,142.93l7.05,2.65L406,134.11c-.39-.75-.86-1.26-1.64-1.26a.33.33,0,0,0-.17,0l-.16,0a.63.63,0,0,0-.22.08s0,0,0,0-.21.22-.31.34a18.57,18.57,0,0,0-2,2.88c-.62,1-1.26,2.19-1.88,3.38-.36.66-.69,1.33-1.05,2C398.3,142.05,398.06,142.49,397.83,142.93Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.83,161.12c6.89-1.67,12.12-3.08,15.15-8.59a44,44,0,0,0,3.21-8.8s0,6.28-1.74,10.76c-1.37,3.44-5.19,6.8-16,9.08Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.08,134.84a2,2,0,1,0,1.82-2.21A2,2,0,0,0,411.08,134.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.13,125.66l4.73,1a2.53,2.53,0,0,0-1.9-3A2.37,2.37,0,0,0,411.13,125.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.33,146.21,407,149a3.61,3.61,0,0,0,4.65,1.82A3.36,3.36,0,0,0,413.33,146.21Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.79,151a4.06,4.06,0,0,1,3.82-3.84,3.32,3.32,0,0,1-1.94,3.61A3.49,3.49,0,0,1,409.79,151Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.33,127.68l4.75-1.13a2.34,2.34,0,0,0-2.85-1.85A2.57,2.57,0,0,0,393.33,127.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.67,135.19a2,2,0,1,0,1.62-2.36A2,2,0,0,0,395.67,135.19Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--laptop--inject-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.14,272.47l0,.92a3.77,3.77,0,0,0,1.78,3.32l64.64,40.2a3.8,3.8,0,0,0,3.77.12l36.6-19.49a3.76,3.76,0,0,0,2-3.2l0-1.26h0a.44.44,0,0,1-.25.4L402.47,315Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.48,315l-.09,2.51a3.71,3.71,0,0,1-1.86-.57l-64.64-40.2a3.74,3.74,0,0,1-1.78-3.32l0-.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.59,293.37a.38.38,0,0,0,.19-.3.34.34,0,0,0-.17-.31l-66.5-41.36a2,2,0,0,0-1.1-.32,2,2,0,0,0-1,.25l-39.59,21.15,68.05,42.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,251.23a2,2,0,0,1,1,.29l66.49,41.36a.22.22,0,0,1,.1.18.2.2,0,0,1-.11.17l-40,21.4-67.76-42.14,39.36-21a2,2,0,0,1,.92-.23m0-.3a2.2,2.2,0,0,0-1.06.27l-39.81,21.27L402.48,315l40.18-21.47a.51.51,0,0,0,0-.87l-66.5-41.36a2.18,2.18,0,0,0-1.18-.34Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.95 311.67 424.42 300.2 363.97 262.61 342.39 274 402.95 311.67",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.39 274 343.18 274.49 363.94 263.54 423.59 300.64 424.41 300.21 363.97 262.61 342.39 274",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.41 278.2 414.02 278.41 403.49 284.03 385.47 272.83 385.1 272.6 396.02 266.76 414.41 278.2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.02 278.41 403.49 284.03 385.47 272.83 396 267.2 414.02 278.41",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M487.79,234.28c-5-16.29-9.77-31.88-14.45-44.14-2.59-6.78-4.15-16.11-19.1-20.27-8.76,7.49-4.37,26.6-2.62,31.37l11.54,37.35s-2.45,3.35-10.73,12.34c-7.05,7.65-10.5,10.48-18.92,12.24s-9.22,1.24-13.48,3.56c-2.27,1.23-7.45,4.09-9.21,5.18s-4.75,4.71-7.6,7.21c-2.67,2.54,1,3.49,3.19,2.65a29.07,29.07,0,0,0,6.4-3.83,37.87,37.87,0,0,1,5.55-2.7,33.82,33.82,0,0,0-.63,6.8c.1,1.22,0,2.73,1.1,3.53a9.46,9.46,0,0,0,2.66.83,1.82,1.82,0,0,0,.61,1.14,3.06,3.06,0,0,0,2.22.37,10.06,10.06,0,0,0,1.23-.3,2.25,2.25,0,0,0,1.53,1.65,9.94,9.94,0,0,0,5.23-.28c.25-.13,2.1-1.34,2.64-1.69.79-.5,1.5-.81,1.82-1.38s-1-2-2-2.11a10.26,10.26,0,0,0-3.3.51,11.48,11.48,0,0,0,.72-2.95c.78-1.53,7.44-.62,13.15-2.14,4.31-1.14,7.23-5.4,9-6.64,10.86-7.63,13.66-9.4,25-19C490.14,244.44,490.46,243,487.79,234.28Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.26,275.73l1.1-.49a14.77,14.77,0,0,1,1.51-3.85C418.65,272,417.79,274,417.26,275.73Zm4.62-.13a15.45,15.45,0,0,0-.67,3.59,31.22,31.22,0,0,0-.15,3.62,13.57,13.57,0,0,0,.43,3.59,28.49,28.49,0,0,1,.1-3.58c.1-1.19.19-2.38.31-3.56a25.14,25.14,0,0,1,.49-3.51,10.26,10.26,0,0,1,.54-1.68,4.87,4.87,0,0,1,.86-1.54A6.49,6.49,0,0,0,421.88,275.6Zm3.58,4.92a30.07,30.07,0,0,0-.22,3.55,16.14,16.14,0,0,0,.31,3.54c.07-2.36.32-4.68.6-7,.13-1.16.3-2.31.5-3.46a16.21,16.21,0,0,1,.36-1.71,4.46,4.46,0,0,1,.66-1.61,6.85,6.85,0,0,0-1.55,3.2A24.53,24.53,0,0,0,425.46,280.52Zm7.66,3.24a4.38,4.38,0,0,0-1.36.41l-.26.14.06.27a1.68,1.68,0,0,1,0,.4,2.94,2.94,0,0,1-.1.48,5.07,5.07,0,0,1-.52,1,2.16,2.16,0,0,0,.94-.74,1.69,1.69,0,0,0,.28-.57,1.93,1.93,0,0,0,.06-.42,9.57,9.57,0,0,1,1.12-.55,6.17,6.17,0,0,1,1.45-.34A3,3,0,0,0,433.12,283.76Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.9,168.77c7.75,2.55,14,4.34,18,14.92,4.89,12.83,11.08,32.47,11.08,32.47s-1.9,5.23-11.25,8.1-13.72.66-13.72.66-5.58-16.3-7.76-23.09S443.93,175.23,453.9,168.77Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M401.4,315.49a4.49,4.49,0,0,1-3.84-.42L333.2,275a4.45,4.45,0,0,1-2.06-3.19l-5.78-43.06a4.59,4.59,0,0,1,0-.74,4.45,4.45,0,0,1,1.43-3.13l66.88,41.61a3.34,3.34,0,0,1,1.53,2.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.48,315l-.46.25c-.2.1-.41.19-.62.27l-6.24-46.6a3.34,3.34,0,0,0-1.53-2.36l-66.88-41.61a4.86,4.86,0,0,1,.93-.66l67,41.68a3.31,3.31,0,0,1,1.52,2.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.57,267.43l1.08-.57a3.31,3.31,0,0,1,.57,1.44L402.48,315l-.46.25c-.2.1-.41.19-.62.27l-6.24-46.6A3.42,3.42,0,0,0,394.57,267.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.75,274.74c-.39-2.88-3.23-6.79-6.34-8.72s-5.32-1.17-4.93,1.72,3.22,6.79,6.33,8.72S366.13,277.63,365.75,274.74Z",
    style: {
      fill: "#B42F53"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.59,109.34a27.63,27.63,0,0,1,11.77,16.56l.58,3.11A27.64,27.64,0,0,1,311,140.47l-.73-3.08a27.64,27.64,0,0,1,42.28-28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.35,116.2a30,30,0,0,0,47.26,36.65l9.13,1.91a1.75,1.75,0,0,0,1.77-2.73l-5.46-7.56a30,30,0,0,0-52.7-28.27Zm40.24-6.86a27.63,27.63,0,0,1,11.77,16.56l.58,3.11A27.64,27.64,0,0,1,311,140.47l-.73-3.08a27.64,27.64,0,0,1,42.28-28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.59,109.34a27.63,27.63,0,0,1,11.77,16.56l.58,3.11A27.64,27.64,0,0,1,311,140.47l-.73-3.08a27.64,27.64,0,0,1,42.28-28Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Check--inject-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.66,147.13a4,4,0,0,1-2.9-1.26l-9-9.64a4,4,0,1,1,5.81-5.45l5.87,6.27,13.87-17.58a4,4,0,1,1,6.25,4.94l-16.74,21.21a4,4,0,0,1-3,1.51Z",
    style: {
      fill: "#B42F53"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyMoney);
export default __webpack_public_path__ + "static/media/myMoney.309d2387f773c57624467127e97250cb.svg";
export { ForwardRef as ReactComponent };